/* tslint:disable */
/* eslint-disable */
/**
 * ADAM API 1.0
 * ADAM API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface ActivityTrackingListDto
 */
export interface ActivityTrackingListDto {
    /**
     * 
     * @type {string}
     * @memberof ActivityTrackingListDto
     */
    'componentSid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ActivityTrackingListDto
     */
    'componentType'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ActivityTrackingListDto
     */
    'action'?: number;
    /**
     * 
     * @type {number}
     * @memberof ActivityTrackingListDto
     */
    'previousStatus'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ActivityTrackingListDto
     */
    'newStatus'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityTrackingListDto
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityTrackingListDto
     */
    'plantGroupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityTrackingListDto
     */
    'plantName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityTrackingListDto
     */
    'componentPageLink'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityTrackingListDto
     */
    'componentName'?: string | null;
}
/**
 * 
 * @export
 * @interface AddBookmarkRequest
 */
export interface AddBookmarkRequest {
    /**
     * The sid of the component to which the bookmark is added.
     * @type {string}
     * @memberof AddBookmarkRequest
     */
    'componentSid'?: string | null;
    /**
     * The component type.
     * @type {number}
     * @memberof AddBookmarkRequest
     */
    'componentType'?: number;
}
/**
 * 
 * @export
 * @interface AddBookmarkResponse
 */
export interface AddBookmarkResponse {
    /**
     * The id of the bookmark added.
     * @type {number}
     * @memberof AddBookmarkResponse
     */
    'bookmarkId'?: number;
}
/**
 * 
 * @export
 * @interface AddBookmarkResponseOkResponse
 */
export interface AddBookmarkResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof AddBookmarkResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof AddBookmarkResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddBookmarkResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {AddBookmarkResponse}
     * @memberof AddBookmarkResponseOkResponse
     */
    'result'?: AddBookmarkResponse;
}
/**
 * 
 * @export
 * @interface AddCommentRequest
 */
export interface AddCommentRequest {
    /**
     * The sid of the component to which the comment is added.
     * @type {string}
     * @memberof AddCommentRequest
     */
    'componentSid': string;
    /**
     * The type of the component to which the comment is added.
     * @type {number}
     * @memberof AddCommentRequest
     */
    'componentType': number;
    /**
     * 
     * @type {CommentAddDto}
     * @memberof AddCommentRequest
     */
    'data'?: CommentAddDto;
}
/**
 * 
 * @export
 * @interface AddCommentResponse
 */
export interface AddCommentResponse {
    /**
     * The id of the comment added.
     * @type {number}
     * @memberof AddCommentResponse
     */
    'commentId'?: number;
}
/**
 * 
 * @export
 * @interface AddCommentResponseOkResponse
 */
export interface AddCommentResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof AddCommentResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof AddCommentResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddCommentResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {AddCommentResponse}
     * @memberof AddCommentResponseOkResponse
     */
    'result'?: AddCommentResponse;
}
/**
 * 
 * @export
 * @interface AddGeneralCommentResponse
 */
export interface AddGeneralCommentResponse {
    /**
     * 
     * @type {number}
     * @memberof AddGeneralCommentResponse
     */
    'generalCommentId'?: number;
}
/**
 * 
 * @export
 * @interface AddGeneralCommentResponseOkResponse
 */
export interface AddGeneralCommentResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof AddGeneralCommentResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof AddGeneralCommentResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddGeneralCommentResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {AddGeneralCommentResponse}
     * @memberof AddGeneralCommentResponseOkResponse
     */
    'result'?: AddGeneralCommentResponse;
}
/**
 * 
 * @export
 * @interface AddNoActionResponse
 */
export interface AddNoActionResponse {
    /**
     * 
     * @type {number}
     * @memberof AddNoActionResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AddNoActionResponse
     */
    'componentSid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AddNoActionResponse
     */
    'componentType'?: number;
    /**
     * 
     * @type {string}
     * @memberof AddNoActionResponse
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddNoActionResponse
     */
    'createdAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddNoActionResponse
     */
    'createdBy'?: string | null;
}
/**
 * 
 * @export
 * @interface AddNoActionResponseOkResponse
 */
export interface AddNoActionResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof AddNoActionResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof AddNoActionResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddNoActionResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {AddNoActionResponse}
     * @memberof AddNoActionResponseOkResponse
     */
    'result'?: AddNoActionResponse;
}
/**
 * 
 * @export
 * @interface AddRecommendationResponse
 */
export interface AddRecommendationResponse {
    /**
     * The id of the recommendation added.
     * @type {number}
     * @memberof AddRecommendationResponse
     */
    'recommendationId'?: number;
}
/**
 * 
 * @export
 * @interface AddRecommendationResponseOkResponse
 */
export interface AddRecommendationResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof AddRecommendationResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof AddRecommendationResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddRecommendationResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {AddRecommendationResponse}
     * @memberof AddRecommendationResponseOkResponse
     */
    'result'?: AddRecommendationResponse;
}
/**
 * 
 * @export
 * @interface AddRecommendationTypeRequest
 */
export interface AddRecommendationTypeRequest {
    /**
     * 
     * @type {string}
     * @memberof AddRecommendationTypeRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddRecommendationTypeRequest
     */
    'germanName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AddRecommendationTypeRequest
     */
    'componentType'?: number;
}
/**
 * 
 * @export
 * @interface AddRecommendationTypeResponse
 */
export interface AddRecommendationTypeResponse {
    /**
     * 
     * @type {number}
     * @memberof AddRecommendationTypeResponse
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface AddRecommendationTypeResponseOkResponse
 */
export interface AddRecommendationTypeResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof AddRecommendationTypeResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof AddRecommendationTypeResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddRecommendationTypeResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {AddRecommendationTypeResponse}
     * @memberof AddRecommendationTypeResponseOkResponse
     */
    'result'?: AddRecommendationTypeResponse;
}
/**
 * 
 * @export
 * @interface AnalysisCommentDto
 */
export interface AnalysisCommentDto {
    /**
     * 
     * @type {string}
     * @memberof AnalysisCommentDto
     */
    'text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisCommentDto
     */
    'imageRef'?: string | null;
}
/**
 * 
 * @export
 * @interface AnalysisDto
 */
export interface AnalysisDto {
    /**
     * 
     * @type {string}
     * @memberof AnalysisDto
     */
    'samplingDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof AnalysisDto
     */
    'status'?: number;
    /**
     * 
     * @type {string}
     * @memberof AnalysisDto
     */
    'samplingPoint'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisDto
     */
    'comment'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisDto
     */
    'temperature'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisDto
     */
    'sampler'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnalysisDto
     */
    'isExcluded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnalysisDto
     */
    'canBeExcluded'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AnalysisDto
     */
    'analysisType'?: number;
    /**
     * 
     * @type {string}
     * @memberof AnalysisDto
     */
    'componentSid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisDto
     */
    'analyticalNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisDto
     */
    'note'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnalysisDto
     */
    'hasImages'?: boolean;
    /**
     * 
     * @type {Array<ParameterReportDto>}
     * @memberof AnalysisDto
     */
    'parameters'?: Array<ParameterReportDto> | null;
    /**
     * 
     * @type {Array<CommentDto>}
     * @memberof AnalysisDto
     */
    'comments'?: Array<CommentDto> | null;
}
/**
 * 
 * @export
 * @interface AssetDto
 */
export interface AssetDto {
    /**
     * 
     * @type {number}
     * @memberof AssetDto
     */
    'sid'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface AttachmentDto
 */
export interface AttachmentDto {
    /**
     * 
     * @type {number}
     * @memberof AttachmentDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AttachmentDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AttachmentDto
     */
    'size'?: string | null;
}
/**
 * 
 * @export
 * @interface BadRequestResponse
 */
export interface BadRequestResponse {
    /**
     * 
     * @type {number}
     * @memberof BadRequestResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof BadRequestResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BadRequestResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BadRequestResponse
     */
    'errors'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface BookmarkDto
 */
export interface BookmarkDto {
    /**
     * 
     * @type {number}
     * @memberof BookmarkDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof BookmarkDto
     */
    'hierarchy'?: number;
    /**
     * 
     * @type {string}
     * @memberof BookmarkDto
     */
    'componentSid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookmarkDto
     */
    'componentName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BookmarkDto
     */
    'componentType'?: number;
}
/**
 * 
 * @export
 * @interface BookmarkUpdateDto
 */
export interface BookmarkUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof BookmarkUpdateDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof BookmarkUpdateDto
     */
    'hierarchy'?: number;
}
/**
 * 
 * @export
 * @interface CommentAddDto
 */
export interface CommentAddDto {
    /**
     * 
     * @type {string}
     * @memberof CommentAddDto
     */
    'reportNumber': string;
    /**
     * 
     * @type {number}
     * @memberof CommentAddDto
     */
    'analysisType'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommentAddDto
     */
    'parameterId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CommentAddDto
     */
    'unit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommentAddDto
     */
    'text': string;
}
/**
 * 
 * @export
 * @interface CommentDto
 */
export interface CommentDto {
    /**
     * 
     * @type {number}
     * @memberof CommentDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommentDto
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentDto
     */
    'componentSid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommentDto
     */
    'reportNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommentDto
     */
    'analysisType'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommentDto
     */
    'visualInspectionId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommentDto
     */
    'parameterId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CommentDto
     */
    'text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommentDto
     */
    'kid'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommentDto
     */
    'isOverride'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CommentDto
     */
    'previousStatus'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommentDto
     */
    'newStatus'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommentDto
     */
    'componentType'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CommentDto
     */
    'unit'?: string | null;
}
/**
 * 
 * @export
 * @interface CommentEditDto
 */
export interface CommentEditDto {
    /**
     * 
     * @type {string}
     * @memberof CommentEditDto
     */
    'text'?: string | null;
}
/**
 * 
 * @export
 * @interface CommentParameterDto
 */
export interface CommentParameterDto {
    /**
     * 
     * @type {string}
     * @memberof CommentParameterDto
     */
    'text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommentParameterDto
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentParameterDto
     */
    'kid'?: string | null;
}
/**
 * 
 * @export
 * @interface ConditionStatusTooltipDto
 */
export interface ConditionStatusTooltipDto {
    /**
     * 
     * @type {string}
     * @memberof ConditionStatusTooltipDto
     */
    'transformerSid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConditionStatusTooltipDto
     */
    'transformerName'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateFolderResponseOkResponse
 */
export interface CreateFolderResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof CreateFolderResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateFolderResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFolderResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof CreateFolderResponseOkResponse
     */
    'result'?: object;
}
/**
 * 
 * @export
 * @interface DeleteBookmarkResponse
 */
export interface DeleteBookmarkResponse {
    /**
     * Id of the deleted entity.
     * @type {number}
     * @memberof DeleteBookmarkResponse
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DeleteBookmarkResponseOkResponse
 */
export interface DeleteBookmarkResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof DeleteBookmarkResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeleteBookmarkResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeleteBookmarkResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {DeleteBookmarkResponse}
     * @memberof DeleteBookmarkResponseOkResponse
     */
    'result'?: DeleteBookmarkResponse;
}
/**
 * 
 * @export
 * @interface DeleteCommentResponse
 */
export interface DeleteCommentResponse {
    /**
     * Id of the deleted entity.
     * @type {number}
     * @memberof DeleteCommentResponse
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DeleteCommentResponseOkResponse
 */
export interface DeleteCommentResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof DeleteCommentResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeleteCommentResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeleteCommentResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {DeleteCommentResponse}
     * @memberof DeleteCommentResponseOkResponse
     */
    'result'?: DeleteCommentResponse;
}
/**
 * 
 * @export
 * @interface DeleteFileResponseOkResponse
 */
export interface DeleteFileResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof DeleteFileResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeleteFileResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeleteFileResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof DeleteFileResponseOkResponse
     */
    'result'?: object;
}
/**
 * 
 * @export
 * @interface DeleteGeneralCommentResponse
 */
export interface DeleteGeneralCommentResponse {
    /**
     * 
     * @type {number}
     * @memberof DeleteGeneralCommentResponse
     */
    'generalCommentId'?: number;
}
/**
 * 
 * @export
 * @interface DeleteGeneralCommentResponseOkResponse
 */
export interface DeleteGeneralCommentResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof DeleteGeneralCommentResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeleteGeneralCommentResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeleteGeneralCommentResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {DeleteGeneralCommentResponse}
     * @memberof DeleteGeneralCommentResponseOkResponse
     */
    'result'?: DeleteGeneralCommentResponse;
}
/**
 * 
 * @export
 * @interface DeleteNoActionResponse
 */
export interface DeleteNoActionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteNoActionResponse
     */
    'succcess'?: boolean;
}
/**
 * 
 * @export
 * @interface DeleteNoActionResponseOkResponse
 */
export interface DeleteNoActionResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof DeleteNoActionResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeleteNoActionResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeleteNoActionResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {DeleteNoActionResponse}
     * @memberof DeleteNoActionResponseOkResponse
     */
    'result'?: DeleteNoActionResponse;
}
/**
 * 
 * @export
 * @interface DownloadImageRequest
 */
export interface DownloadImageRequest {
    /**
     * 
     * @type {string}
     * @memberof DownloadImageRequest
     */
    'filePath'?: string | null;
}
/**
 * 
 * @export
 * @interface DownloadImagesAsZipRequest
 */
export interface DownloadImagesAsZipRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DownloadImagesAsZipRequest
     */
    'filePaths'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface EditCommentRequest
 */
export interface EditCommentRequest {
    /**
     * The id of the comment to be updated.
     * @type {number}
     * @memberof EditCommentRequest
     */
    'commentId': number;
    /**
     * 
     * @type {CommentEditDto}
     * @memberof EditCommentRequest
     */
    'data'?: CommentEditDto;
}
/**
 * 
 * @export
 * @interface EditCommentResponse
 */
export interface EditCommentResponse {
    /**
     * Id of the edited comment.
     * @type {number}
     * @memberof EditCommentResponse
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface EditCommentResponseOkResponse
 */
export interface EditCommentResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof EditCommentResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof EditCommentResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EditCommentResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {EditCommentResponse}
     * @memberof EditCommentResponseOkResponse
     */
    'result'?: EditCommentResponse;
}
/**
 * 
 * @export
 * @interface EditGeneralCommentResponse
 */
export interface EditGeneralCommentResponse {
    /**
     * 
     * @type {number}
     * @memberof EditGeneralCommentResponse
     */
    'generalCommentId'?: number;
}
/**
 * 
 * @export
 * @interface EditGeneralCommentResponseOkResponse
 */
export interface EditGeneralCommentResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof EditGeneralCommentResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof EditGeneralCommentResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EditGeneralCommentResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {EditGeneralCommentResponse}
     * @memberof EditGeneralCommentResponseOkResponse
     */
    'result'?: EditGeneralCommentResponse;
}
/**
 * 
 * @export
 * @interface EditNextReportDateResponse
 */
export interface EditNextReportDateResponse {
    /**
     * 
     * @type {boolean}
     * @memberof EditNextReportDateResponse
     */
    'isSuccessfull'?: boolean;
}
/**
 * 
 * @export
 * @interface EditNextReportDateResponseOkResponse
 */
export interface EditNextReportDateResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof EditNextReportDateResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof EditNextReportDateResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EditNextReportDateResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {EditNextReportDateResponse}
     * @memberof EditNextReportDateResponseOkResponse
     */
    'result'?: EditNextReportDateResponse;
}
/**
 * 
 * @export
 * @interface EditRecommendationResponse
 */
export interface EditRecommendationResponse {
    /**
     * The id of the updated recommentdation.
     * @type {number}
     * @memberof EditRecommendationResponse
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface EditRecommendationResponseOkResponse
 */
export interface EditRecommendationResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof EditRecommendationResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof EditRecommendationResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EditRecommendationResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {EditRecommendationResponse}
     * @memberof EditRecommendationResponseOkResponse
     */
    'result'?: EditRecommendationResponse;
}
/**
 * 
 * @export
 * @interface EditRecommendationTypeResponse
 */
export interface EditRecommendationTypeResponse {
    /**
     * 
     * @type {number}
     * @memberof EditRecommendationTypeResponse
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface EditRecommendationTypeResponseOkResponse
 */
export interface EditRecommendationTypeResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof EditRecommendationTypeResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof EditRecommendationTypeResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EditRecommendationTypeResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {EditRecommendationTypeResponse}
     * @memberof EditRecommendationTypeResponseOkResponse
     */
    'result'?: EditRecommendationTypeResponse;
}
/**
 * 
 * @export
 * @interface EditThresholdResponse
 */
export interface EditThresholdResponse {
    /**
     * The id of the new threshold.
     * @type {number}
     * @memberof EditThresholdResponse
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface EditThresholdResponseOkResponse
 */
export interface EditThresholdResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof EditThresholdResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof EditThresholdResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EditThresholdResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {EditThresholdResponse}
     * @memberof EditThresholdResponseOkResponse
     */
    'result'?: EditThresholdResponse;
}
/**
 * 
 * @export
 * @interface FlaggedGeneratorDto
 */
export interface FlaggedGeneratorDto {
    /**
     * 
     * @type {string}
     * @memberof FlaggedGeneratorDto
     */
    'generatorSid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlaggedGeneratorDto
     */
    'generatorName'?: string | null;
}
/**
 * 
 * @export
 * @interface FlaggedTransformerDto
 */
export interface FlaggedTransformerDto {
    /**
     * 
     * @type {string}
     * @memberof FlaggedTransformerDto
     */
    'transformerSid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlaggedTransformerDto
     */
    'transformerName'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralCommentDto
 */
export interface GeneralCommentDto {
    /**
     * 
     * @type {number}
     * @memberof GeneralCommentDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GeneralCommentDto
     */
    'componentSid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GeneralCommentDto
     */
    'componentType'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeneralCommentDto
     */
    'actionType'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralCommentDto
     */
    'text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralCommentDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralCommentDto
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralCommentDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralCommentDto
     */
    'updatedAt'?: string | null;
    /**
     * 
     * @type {AttachmentDto}
     * @memberof GeneralCommentDto
     */
    'attachment'?: AttachmentDto;
}
/**
 * 
 * @export
 * @interface GeneratorIdDto
 */
export interface GeneratorIdDto {
    /**
     * 
     * @type {string}
     * @memberof GeneratorIdDto
     */
    'generatorSid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneratorIdDto
     */
    'functionalLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneratorIdDto
     */
    'generatorName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GeneratorIdDto
     */
    'bookmarkId'?: number | null;
}
/**
 * 
 * @export
 * @interface GeneratorReportDataDto
 */
export interface GeneratorReportDataDto {
    /**
     * 
     * @type {string}
     * @memberof GeneratorReportDataDto
     */
    'analyticalNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneratorReportDataDto
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof GeneratorReportDataDto
     */
    'status'?: number;
    /**
     * 
     * @type {string}
     * @memberof GeneratorReportDataDto
     */
    'referenceStartDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneratorReportDataDto
     */
    'referenceEndDate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GeneratorReportDataDto
     */
    'isCurrentReference'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneratorReportDataDto
     */
    'canBeSetAsReference'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GeneratorReportDataDto
     */
    'analysisType'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GeneratorReportDataDto
     */
    'canBeExcluded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneratorReportDataDto
     */
    'isExcluded'?: boolean;
    /**
     * 
     * @type {Array<AnalysisCommentDto>}
     * @memberof GeneratorReportDataDto
     */
    'comments'?: Array<AnalysisCommentDto> | null;
    /**
     * 
     * @type {Array<ParameterDto>}
     * @memberof GeneratorReportDataDto
     */
    'parameters'?: Array<ParameterDto> | null;
    /**
     * 
     * @type {Array<ImageDetailsDto>}
     * @memberof GeneratorReportDataDto
     */
    'images'?: Array<ImageDetailsDto> | null;
    /**
     * 
     * @type {string}
     * @memberof GeneratorReportDataDto
     */
    'createdAt'?: string | null;
}
/**
 * 
 * @export
 * @interface GetConditionStatusByAgeResponse
 */
export interface GetConditionStatusByAgeResponse {
    /**
     * 
     * @type {Array<number>}
     * @memberof GetConditionStatusByAgeResponse
     */
    'years'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetConditionStatusByAgeResponse
     */
    'numberOfNormal'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetConditionStatusByAgeResponse
     */
    'numberOfInferior'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetConditionStatusByAgeResponse
     */
    'numberOfCritical'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetConditionStatusByAgeResponse
     */
    'numberOfNoAction'?: Array<number> | null;
    /**
     * 
     * @type {Array<{ [key: string]: Array<ConditionStatusTooltipDto>; }>}
     * @memberof GetConditionStatusByAgeResponse
     */
    'tooltipData'?: Array<{ [key: string]: Array<ConditionStatusTooltipDto>; }> | null;
}
/**
 * 
 * @export
 * @interface GetConditionStatusByAgeResponseOkResponse
 */
export interface GetConditionStatusByAgeResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof GetConditionStatusByAgeResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetConditionStatusByAgeResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConditionStatusByAgeResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {GetConditionStatusByAgeResponse}
     * @memberof GetConditionStatusByAgeResponseOkResponse
     */
    'result'?: GetConditionStatusByAgeResponse;
}
/**
 * 
 * @export
 * @interface GetConditionStatusByComponentResponse
 */
export interface GetConditionStatusByComponentResponse {
    /**
     * 
     * @type {number}
     * @memberof GetConditionStatusByComponentResponse
     */
    'generalStatus'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetConditionStatusByComponentResponse
     */
    'isNoActionSet'?: boolean;
    /**
     * 
     * @type {NoActionComponentDto}
     * @memberof GetConditionStatusByComponentResponse
     */
    'noActionComponent'?: NoActionComponentDto;
    /**
     * 
     * @type {string}
     * @memberof GetConditionStatusByComponentResponse
     */
    'lastSyncedDate'?: string | null;
    /**
     * 
     * @type {Array<LatestConditionStatusDto>}
     * @memberof GetConditionStatusByComponentResponse
     */
    'latestConditionStatuses'?: Array<LatestConditionStatusDto> | null;
}
/**
 * 
 * @export
 * @interface GetConditionStatusByComponentResponseOkResponse
 */
export interface GetConditionStatusByComponentResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof GetConditionStatusByComponentResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetConditionStatusByComponentResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConditionStatusByComponentResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {GetConditionStatusByComponentResponse}
     * @memberof GetConditionStatusByComponentResponseOkResponse
     */
    'result'?: GetConditionStatusByComponentResponse;
}
/**
 * 
 * @export
 * @interface GetConditionStatusYearlyResponse
 */
export interface GetConditionStatusYearlyResponse {
    /**
     * 
     * @type {Array<number>}
     * @memberof GetConditionStatusYearlyResponse
     */
    'years'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetConditionStatusYearlyResponse
     */
    'numberOfNormal'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetConditionStatusYearlyResponse
     */
    'numberOfInferior'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetConditionStatusYearlyResponse
     */
    'numberOfCritical'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetConditionStatusYearlyResponse
     */
    'numberOfNoAction'?: Array<number> | null;
    /**
     * 
     * @type {Array<{ [key: string]: Array<ConditionStatusTooltipDto>; }>}
     * @memberof GetConditionStatusYearlyResponse
     */
    'tooltipData'?: Array<{ [key: string]: Array<ConditionStatusTooltipDto>; }> | null;
}
/**
 * 
 * @export
 * @interface GetConditionStatusYearlyResponseOkResponse
 */
export interface GetConditionStatusYearlyResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof GetConditionStatusYearlyResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetConditionStatusYearlyResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConditionStatusYearlyResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {GetConditionStatusYearlyResponse}
     * @memberof GetConditionStatusYearlyResponseOkResponse
     */
    'result'?: GetConditionStatusYearlyResponse;
}
/**
 * 
 * @export
 * @interface GetConstantsResponse
 */
export interface GetConstantsResponse {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GetConstantsResponse
     */
    'statusTypes'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GetConstantsResponse
     */
    'analysisTypes'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GetConstantsResponse
     */
    'unitOfMeasureTypes'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GetConstantsResponse
     */
    'thresholdOperatorTypes'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GetConstantsResponse
     */
    'thresholdLastOperatorTypes'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GetConstantsResponse
     */
    'thresholdCriteriaTypes'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GetConstantsResponse
     */
    'componentTypes'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GetConstantsResponse
     */
    'reportTypes'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GetConstantsResponse
     */
    'languageTypes'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GetConstantsResponse
     */
    'exportTypes'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GetConstantsResponse
     */
    'transformerAgeTypes'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {Array<RecommendationTypesDto>}
     * @memberof GetConstantsResponse
     */
    'recommendationTypes'?: Array<RecommendationTypesDto> | null;
    /**
     * 
     * @type {Array<ParameterTypeDto>}
     * @memberof GetConstantsResponse
     */
    'parameters'?: Array<ParameterTypeDto> | null;
    /**
     * 
     * @type {Array<VisualInspectionParameterDto>}
     * @memberof GetConstantsResponse
     */
    'visualInspectionParameters'?: Array<VisualInspectionParameterDto> | null;
    /**
     * 
     * @type {Array<ParameterGroupDto>}
     * @memberof GetConstantsResponse
     */
    'gasInOilParameterGroups'?: Array<ParameterGroupDto> | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GetConstantsResponse
     */
    'actionTypes'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GetConstantsResponse
     */
    'generatorsActionTypes'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GetConstantsResponse
     */
    'trafosActionTypes'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {HistoricalTrendsDropdownSourceDto}
     * @memberof GetConstantsResponse
     */
    'generatorHistoricalTrends'?: HistoricalTrendsDropdownSourceDto;
}
/**
 * 
 * @export
 * @interface GetConstantsResponseOkResponse
 */
export interface GetConstantsResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof GetConstantsResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetConstantsResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConstantsResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {GetConstantsResponse}
     * @memberof GetConstantsResponseOkResponse
     */
    'result'?: GetConstantsResponse;
}
/**
 * 
 * @export
 * @interface GetGeneralCommentsResponse
 */
export interface GetGeneralCommentsResponse {
    /**
     * 
     * @type {Array<GeneralCommentDto>}
     * @memberof GetGeneralCommentsResponse
     */
    'generalComments'?: Array<GeneralCommentDto> | null;
}
/**
 * 
 * @export
 * @interface GetGeneralCommentsResponseOkResponse
 */
export interface GetGeneralCommentsResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof GetGeneralCommentsResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetGeneralCommentsResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetGeneralCommentsResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {GetGeneralCommentsResponse}
     * @memberof GetGeneralCommentsResponseOkResponse
     */
    'result'?: GetGeneralCommentsResponse;
}
/**
 * 
 * @export
 * @interface GetGeneratorConditionStatusByAgeResponse
 */
export interface GetGeneratorConditionStatusByAgeResponse {
    /**
     * 
     * @type {Array<number>}
     * @memberof GetGeneratorConditionStatusByAgeResponse
     */
    'years'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetGeneratorConditionStatusByAgeResponse
     */
    'numberOfNormal'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetGeneratorConditionStatusByAgeResponse
     */
    'numberOfInferior'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetGeneratorConditionStatusByAgeResponse
     */
    'numberOfCritical'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetGeneratorConditionStatusByAgeResponse
     */
    'numberOfNoAction'?: Array<number> | null;
    /**
     * 
     * @type {Array<{ [key: string]: Array<ConditionStatusTooltipDto>; }>}
     * @memberof GetGeneratorConditionStatusByAgeResponse
     */
    'tooltipData'?: Array<{ [key: string]: Array<ConditionStatusTooltipDto>; }> | null;
}
/**
 * 
 * @export
 * @interface GetGeneratorConditionStatusByAgeResponseOkResponse
 */
export interface GetGeneratorConditionStatusByAgeResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof GetGeneratorConditionStatusByAgeResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetGeneratorConditionStatusByAgeResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetGeneratorConditionStatusByAgeResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {GetGeneratorConditionStatusByAgeResponse}
     * @memberof GetGeneratorConditionStatusByAgeResponseOkResponse
     */
    'result'?: GetGeneratorConditionStatusByAgeResponse;
}
/**
 * 
 * @export
 * @interface GetGeneratorConditionStatusYearlyResponse
 */
export interface GetGeneratorConditionStatusYearlyResponse {
    /**
     * 
     * @type {Array<number>}
     * @memberof GetGeneratorConditionStatusYearlyResponse
     */
    'years'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetGeneratorConditionStatusYearlyResponse
     */
    'numberOfNormal'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetGeneratorConditionStatusYearlyResponse
     */
    'numberOfInferior'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetGeneratorConditionStatusYearlyResponse
     */
    'numberOfCritical'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetGeneratorConditionStatusYearlyResponse
     */
    'numberOfNoAction'?: Array<number> | null;
    /**
     * 
     * @type {Array<{ [key: string]: Array<ConditionStatusTooltipDto>; }>}
     * @memberof GetGeneratorConditionStatusYearlyResponse
     */
    'tooltipData'?: Array<{ [key: string]: Array<ConditionStatusTooltipDto>; }> | null;
}
/**
 * 
 * @export
 * @interface GetGeneratorConditionStatusYearlyResponseOkResponse
 */
export interface GetGeneratorConditionStatusYearlyResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof GetGeneratorConditionStatusYearlyResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetGeneratorConditionStatusYearlyResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetGeneratorConditionStatusYearlyResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {GetGeneratorConditionStatusYearlyResponse}
     * @memberof GetGeneratorConditionStatusYearlyResponseOkResponse
     */
    'result'?: GetGeneratorConditionStatusYearlyResponse;
}
/**
 * 
 * @export
 * @interface GetGeneratorHistoricalTrendsResponse
 */
export interface GetGeneratorHistoricalTrendsResponse {
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof GetGeneratorHistoricalTrendsResponse
     */
    'dataPoints'?: Array<{ [key: string]: any; }> | null;
    /**
     * 
     * @type {Array<{ [key: string]: number; }>}
     * @memberof GetGeneratorHistoricalTrendsResponse
     */
    'statuses'?: Array<{ [key: string]: number; }> | null;
    /**
     * 
     * @type {Array<{ [key: string]: number; }>}
     * @memberof GetGeneratorHistoricalTrendsResponse
     */
    'unitsOfMeasure'?: Array<{ [key: string]: number; }> | null;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof GetGeneratorHistoricalTrendsResponse
     */
    'legend'?: { [key: string]: boolean; } | null;
}
/**
 * 
 * @export
 * @interface GetGeneratorHistoricalTrendsResponseOkResponse
 */
export interface GetGeneratorHistoricalTrendsResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof GetGeneratorHistoricalTrendsResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetGeneratorHistoricalTrendsResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetGeneratorHistoricalTrendsResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {GetGeneratorHistoricalTrendsResponse}
     * @memberof GetGeneratorHistoricalTrendsResponseOkResponse
     */
    'result'?: GetGeneratorHistoricalTrendsResponse;
}
/**
 * 
 * @export
 * @interface GetGeneratorPlantGroupStatusSummaryResponse
 */
export interface GetGeneratorPlantGroupStatusSummaryResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetGeneratorPlantGroupStatusSummaryResponse
     */
    'plantGroups'?: Array<string> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetGeneratorPlantGroupStatusSummaryResponse
     */
    'plantGroupSids'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetGeneratorPlantGroupStatusSummaryResponse
     */
    'numberOfNormalComponents'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetGeneratorPlantGroupStatusSummaryResponse
     */
    'numberOfInferiorComponents'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetGeneratorPlantGroupStatusSummaryResponse
     */
    'numberOfCriticalComponents'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetGeneratorPlantGroupStatusSummaryResponse
     */
    'numberOfNotAssessedComponents'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetGeneratorPlantGroupStatusSummaryResponse
     */
    'numberOfNoActionComponents'?: Array<number> | null;
    /**
     * 
     * @type {Array<{ [key: string]: string; }>}
     * @memberof GetGeneratorPlantGroupStatusSummaryResponse
     */
    'tooltipData'?: Array<{ [key: string]: string; }> | null;
}
/**
 * 
 * @export
 * @interface GetGeneratorPlantGroupStatusSummaryResponseOkResponse
 */
export interface GetGeneratorPlantGroupStatusSummaryResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof GetGeneratorPlantGroupStatusSummaryResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetGeneratorPlantGroupStatusSummaryResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetGeneratorPlantGroupStatusSummaryResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {GetGeneratorPlantGroupStatusSummaryResponse}
     * @memberof GetGeneratorPlantGroupStatusSummaryResponseOkResponse
     */
    'result'?: GetGeneratorPlantGroupStatusSummaryResponse;
}
/**
 * 
 * @export
 * @interface GetGeneratorPlantStatusSummaryResponse
 */
export interface GetGeneratorPlantStatusSummaryResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetGeneratorPlantStatusSummaryResponse
     */
    'plants'?: Array<string> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetGeneratorPlantStatusSummaryResponse
     */
    'numberOfNormalComponents'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetGeneratorPlantStatusSummaryResponse
     */
    'numberOfInferiorComponents'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetGeneratorPlantStatusSummaryResponse
     */
    'numberOfCriticalComponents'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetGeneratorPlantStatusSummaryResponse
     */
    'numberOfNotAssessedComponents'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetGeneratorPlantStatusSummaryResponse
     */
    'numberOfNoActionComponents'?: Array<number> | null;
    /**
     * 
     * @type {Array<{ [key: string]: Array<PlantOverviewToolTipDto>; }>}
     * @memberof GetGeneratorPlantStatusSummaryResponse
     */
    'tooltipData'?: Array<{ [key: string]: Array<PlantOverviewToolTipDto>; }> | null;
}
/**
 * 
 * @export
 * @interface GetGeneratorPlantStatusSummaryResponseOkResponse
 */
export interface GetGeneratorPlantStatusSummaryResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof GetGeneratorPlantStatusSummaryResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetGeneratorPlantStatusSummaryResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetGeneratorPlantStatusSummaryResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {GetGeneratorPlantStatusSummaryResponse}
     * @memberof GetGeneratorPlantStatusSummaryResponseOkResponse
     */
    'result'?: GetGeneratorPlantStatusSummaryResponse;
}
/**
 * 
 * @export
 * @interface GetGeneratorReportResponse
 */
export interface GetGeneratorReportResponse {
    /**
     * 
     * @type {number}
     * @memberof GetGeneratorReportResponse
     */
    'status'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetGeneratorReportResponse
     */
    'reportId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetGeneratorReportResponse
     */
    'canBeExcluded'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetGeneratorReportResponse
     */
    'isExcluded'?: boolean | null;
    /**
     * 
     * @type {Array<GeneratorReportDataDto>}
     * @memberof GetGeneratorReportResponse
     */
    'reports'?: Array<GeneratorReportDataDto> | null;
    /**
     * 
     * @type {VisualInspectionDataDto}
     * @memberof GetGeneratorReportResponse
     */
    'visualInspectionReport'?: VisualInspectionDataDto;
}
/**
 * 
 * @export
 * @interface GetGeneratorReportResponseOkResponse
 */
export interface GetGeneratorReportResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof GetGeneratorReportResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetGeneratorReportResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetGeneratorReportResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {GetGeneratorReportResponse}
     * @memberof GetGeneratorReportResponseOkResponse
     */
    'result'?: GetGeneratorReportResponse;
}
/**
 * 
 * @export
 * @interface GetGeneratorStatusSummaryResponse
 */
export interface GetGeneratorStatusSummaryResponse {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof GetGeneratorStatusSummaryResponse
     */
    'statusSummary'?: { [key: string]: number; } | null;
}
/**
 * 
 * @export
 * @interface GetGeneratorStatusSummaryResponseOkResponse
 */
export interface GetGeneratorStatusSummaryResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof GetGeneratorStatusSummaryResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetGeneratorStatusSummaryResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetGeneratorStatusSummaryResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {GetGeneratorStatusSummaryResponse}
     * @memberof GetGeneratorStatusSummaryResponseOkResponse
     */
    'result'?: GetGeneratorStatusSummaryResponse;
}
/**
 * 
 * @export
 * @interface GetImagesResponse
 */
export interface GetImagesResponse {
    /**
     * 
     * @type {{ [key: string]: Array<ImageDetailsDto>; }}
     * @memberof GetImagesResponse
     */
    'analysisImages'?: { [key: string]: Array<ImageDetailsDto>; } | null;
}
/**
 * 
 * @export
 * @interface GetImagesResponseOkResponse
 */
export interface GetImagesResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof GetImagesResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetImagesResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetImagesResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {GetImagesResponse}
     * @memberof GetImagesResponseOkResponse
     */
    'result'?: GetImagesResponse;
}
/**
 * 
 * @export
 * @interface GetMasterDataGeneratorDetailsResponse
 */
export interface GetMasterDataGeneratorDetailsResponse {
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'generatorID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'kw'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'category'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'functionalLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'excitation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'renewalPending'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'powerPlantName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'powerPlantSid'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'riverGroupName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'plantGroupSid'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'manufacturer'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'typeDesigantionManufacturer'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'windingType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'age'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'yearOfConstruction'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'rewindingRotor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'rewindingStator'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'newSheetMetal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'manufacturerNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'nominalPower'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'turbinePower'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'nominalVoltage'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'nominalCurrent'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'frequency'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'nominalCosPhi'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'efficiency'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'nominalSpeed'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'maximumSpeed'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'isolationSystem'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'isoClass'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'coolingMedium'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'coolingType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'excitationType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'excitationCurrent'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'excitationVoltage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'yearOfConstructionExcitation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'maxNumberOfStartStop'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'designSizeMachineHours'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponse
     */
    'typenschildAnalysis'?: string | null;
}
/**
 * 
 * @export
 * @interface GetMasterDataGeneratorDetailsResponseOkResponse
 */
export interface GetMasterDataGeneratorDetailsResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataGeneratorDetailsResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorDetailsResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {GetMasterDataGeneratorDetailsResponse}
     * @memberof GetMasterDataGeneratorDetailsResponseOkResponse
     */
    'result'?: GetMasterDataGeneratorDetailsResponse;
}
/**
 * 
 * @export
 * @interface GetMasterDataGeneratorsResponse
 */
export interface GetMasterDataGeneratorsResponse {
    /**
     * 
     * @type {Array<PlantGroupWithGeneratorHierarchyDto>}
     * @memberof GetMasterDataGeneratorsResponse
     */
    'plantGroups'?: Array<PlantGroupWithGeneratorHierarchyDto> | null;
}
/**
 * 
 * @export
 * @interface GetMasterDataGeneratorsResponseOkResponse
 */
export interface GetMasterDataGeneratorsResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataGeneratorsResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorsResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataGeneratorsResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {GetMasterDataGeneratorsResponse}
     * @memberof GetMasterDataGeneratorsResponseOkResponse
     */
    'result'?: GetMasterDataGeneratorsResponse;
}
/**
 * 
 * @export
 * @interface GetMasterDataPlantsResponse
 */
export interface GetMasterDataPlantsResponse {
    /**
     * 
     * @type {Array<PlantGroupDto>}
     * @memberof GetMasterDataPlantsResponse
     */
    'plantGroups'?: Array<PlantGroupDto> | null;
}
/**
 * 
 * @export
 * @interface GetMasterDataPlantsResponseOkResponse
 */
export interface GetMasterDataPlantsResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataPlantsResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataPlantsResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataPlantsResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {GetMasterDataPlantsResponse}
     * @memberof GetMasterDataPlantsResponseOkResponse
     */
    'result'?: GetMasterDataPlantsResponse;
}
/**
 * 
 * @export
 * @interface GetMasterDataTransformerDetailsResponse
 */
export interface GetMasterDataTransformerDetailsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataTransformerDetailsResponse
     */
    'transformerSid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataTransformerDetailsResponse
     */
    'transformerName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataTransformerDetailsResponse
     */
    'plantGroupSid'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataTransformerDetailsResponse
     */
    'plantGroupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataTransformerDetailsResponse
     */
    'plantNameShort'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataTransformerDetailsResponse
     */
    'plantSid'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataTransformerDetailsResponse
     */
    'plantName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataTransformerDetailsResponse
     */
    'storagePlantSid'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataTransformerDetailsResponse
     */
    'storagePlantName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataTransformerDetailsResponse
     */
    'technicalLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataTransformerDetailsResponse
     */
    'manufacturer'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataTransformerDetailsResponse
     */
    'manufacturerEnumSid'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataTransformerDetailsResponse
     */
    'transformerType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataTransformerDetailsResponse
     */
    'transformerTypeEnumSid'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataTransformerDetailsResponse
     */
    'constructionYear'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataTransformerDetailsResponse
     */
    'nominalPower'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataTransformerDetailsResponse
     */
    'primaryVoltageOs'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataTransformerDetailsResponse
     */
    'secondaryVoltageOs'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataTransformerDetailsResponse
     */
    'coolingSystem'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataTransformerDetailsResponse
     */
    'coolingSystemEnumSid'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataTransformerDetailsResponse
     */
    'oilWeight'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataTransformerDetailsResponse
     */
    'totalWeight'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataTransformerDetailsResponse
     */
    'age'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetMasterDataTransformerDetailsResponse
     */
    'isReserve'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataTransformerDetailsResponse
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataTransformerDetailsResponse
     */
    'decommissioningDate'?: string | null;
}
/**
 * 
 * @export
 * @interface GetMasterDataTransformerDetailsResponseOkResponse
 */
export interface GetMasterDataTransformerDetailsResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataTransformerDetailsResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataTransformerDetailsResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataTransformerDetailsResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {GetMasterDataTransformerDetailsResponse}
     * @memberof GetMasterDataTransformerDetailsResponseOkResponse
     */
    'result'?: GetMasterDataTransformerDetailsResponse;
}
/**
 * 
 * @export
 * @interface GetMasterDataTransformersResponse
 */
export interface GetMasterDataTransformersResponse {
    /**
     * 
     * @type {Array<PlantGroupWithTransformerHierarchyDto>}
     * @memberof GetMasterDataTransformersResponse
     */
    'plantGroups'?: Array<PlantGroupWithTransformerHierarchyDto> | null;
}
/**
 * 
 * @export
 * @interface GetMasterDataTransformersResponseOkResponse
 */
export interface GetMasterDataTransformersResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof GetMasterDataTransformersResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataTransformersResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMasterDataTransformersResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {GetMasterDataTransformersResponse}
     * @memberof GetMasterDataTransformersResponseOkResponse
     */
    'result'?: GetMasterDataTransformersResponse;
}
/**
 * 
 * @export
 * @interface GetOilHistoricalTrendsResponse
 */
export interface GetOilHistoricalTrendsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GetOilHistoricalTrendsResponse
     */
    'hasThresholds'?: boolean;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof GetOilHistoricalTrendsResponse
     */
    'dataPoints'?: Array<{ [key: string]: any; }> | null;
    /**
     * 
     * @type {Array<{ [key: string]: number; }>}
     * @memberof GetOilHistoricalTrendsResponse
     */
    'statuses'?: Array<{ [key: string]: number; }> | null;
    /**
     * 
     * @type {Array<{ [key: string]: number; }>}
     * @memberof GetOilHistoricalTrendsResponse
     */
    'unitsOfMeasure'?: Array<{ [key: string]: number; }> | null;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof GetOilHistoricalTrendsResponse
     */
    'legend'?: { [key: string]: boolean; } | null;
}
/**
 * 
 * @export
 * @interface GetOilHistoricalTrendsResponseOkResponse
 */
export interface GetOilHistoricalTrendsResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof GetOilHistoricalTrendsResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetOilHistoricalTrendsResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOilHistoricalTrendsResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {GetOilHistoricalTrendsResponse}
     * @memberof GetOilHistoricalTrendsResponseOkResponse
     */
    'result'?: GetOilHistoricalTrendsResponse;
}
/**
 * 
 * @export
 * @interface GetPlantGroupStatusSummaryResponse
 */
export interface GetPlantGroupStatusSummaryResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetPlantGroupStatusSummaryResponse
     */
    'plantGroups'?: Array<string> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetPlantGroupStatusSummaryResponse
     */
    'plantGroupSids'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetPlantGroupStatusSummaryResponse
     */
    'numberOfNormalComponents'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetPlantGroupStatusSummaryResponse
     */
    'numberOfInferiorComponents'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetPlantGroupStatusSummaryResponse
     */
    'numberOfCriticalComponents'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetPlantGroupStatusSummaryResponse
     */
    'numberOfNotAssessedComponents'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetPlantGroupStatusSummaryResponse
     */
    'numberOfNoActionComponents'?: Array<number> | null;
    /**
     * 
     * @type {Array<{ [key: string]: string; }>}
     * @memberof GetPlantGroupStatusSummaryResponse
     */
    'tooltipData'?: Array<{ [key: string]: string; }> | null;
}
/**
 * 
 * @export
 * @interface GetPlantGroupStatusSummaryResponseOkResponse
 */
export interface GetPlantGroupStatusSummaryResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof GetPlantGroupStatusSummaryResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetPlantGroupStatusSummaryResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPlantGroupStatusSummaryResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {GetPlantGroupStatusSummaryResponse}
     * @memberof GetPlantGroupStatusSummaryResponseOkResponse
     */
    'result'?: GetPlantGroupStatusSummaryResponse;
}
/**
 * 
 * @export
 * @interface GetPlantStatusSummaryResponse
 */
export interface GetPlantStatusSummaryResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetPlantStatusSummaryResponse
     */
    'plants'?: Array<string> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetPlantStatusSummaryResponse
     */
    'numberOfNormalComponents'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetPlantStatusSummaryResponse
     */
    'numberOfInferiorComponents'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetPlantStatusSummaryResponse
     */
    'numberOfCriticalComponents'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetPlantStatusSummaryResponse
     */
    'numberOfNotAssessedComponents'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetPlantStatusSummaryResponse
     */
    'numberOfNoActionComponents'?: Array<number> | null;
    /**
     * 
     * @type {Array<{ [key: string]: Array<PlantOverviewToolTipDto>; }>}
     * @memberof GetPlantStatusSummaryResponse
     */
    'tooltipData'?: Array<{ [key: string]: Array<PlantOverviewToolTipDto>; }> | null;
}
/**
 * 
 * @export
 * @interface GetPlantStatusSummaryResponseOkResponse
 */
export interface GetPlantStatusSummaryResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof GetPlantStatusSummaryResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetPlantStatusSummaryResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPlantStatusSummaryResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {GetPlantStatusSummaryResponse}
     * @memberof GetPlantStatusSummaryResponseOkResponse
     */
    'result'?: GetPlantStatusSummaryResponse;
}
/**
 * 
 * @export
 * @interface GetRecommendationResponse
 */
export interface GetRecommendationResponse {
    /**
     * 
     * @type {number}
     * @memberof GetRecommendationResponse
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetRecommendationResponse
     */
    'recommendationTypeId'?: number;
    /**
     * 
     * @type {Array<RecommendationCommentDto>}
     * @memberof GetRecommendationResponse
     */
    'comments'?: Array<RecommendationCommentDto> | null;
    /**
     * 
     * @type {RecommendationSapNotificationDto}
     * @memberof GetRecommendationResponse
     */
    'sapNotifcation'?: RecommendationSapNotificationDto;
    /**
     * 
     * @type {number}
     * @memberof GetRecommendationResponse
     */
    'componentType'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetRecommendationResponse
     */
    'powerPlant'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetRecommendationResponse
     */
    'componentSid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetRecommendationResponse
     */
    'sapNotificationNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetRecommendationResponse
     */
    'pspNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetRecommendationResponse
     */
    'ptRiskId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetRecommendationResponse
     */
    'sapNotificationUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetRecommendationResponse
     */
    'ptRiskUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetRecommendationResponse
     */
    'pspNumberUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetRecommendationResponse
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRecommendationResponse
     */
    'freeText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetRecommendationResponse
     */
    'kid'?: string | null;
}
/**
 * 
 * @export
 * @interface GetRecommendationResponseOkResponse
 */
export interface GetRecommendationResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof GetRecommendationResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetRecommendationResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetRecommendationResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {GetRecommendationResponse}
     * @memberof GetRecommendationResponseOkResponse
     */
    'result'?: GetRecommendationResponse;
}
/**
 * 
 * @export
 * @interface GetRecommendationTypeResponse
 */
export interface GetRecommendationTypeResponse {
    /**
     * 
     * @type {number}
     * @memberof GetRecommendationTypeResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetRecommendationTypeResponse
     */
    'englishName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetRecommendationTypeResponse
     */
    'germanName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetRecommendationTypeResponse
     */
    'componentType'?: number;
}
/**
 * 
 * @export
 * @interface GetRecommendationTypeResponseOkResponse
 */
export interface GetRecommendationTypeResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof GetRecommendationTypeResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetRecommendationTypeResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetRecommendationTypeResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {GetRecommendationTypeResponse}
     * @memberof GetRecommendationTypeResponseOkResponse
     */
    'result'?: GetRecommendationTypeResponse;
}
/**
 * 
 * @export
 * @interface GetReportResponse
 */
export interface GetReportResponse {
    /**
     * 
     * @type {string}
     * @memberof GetReportResponse
     */
    'reportId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetReportResponse
     */
    'status'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetReportResponse
     */
    'reportType'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetReportResponse
     */
    'isExcluded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetReportResponse
     */
    'canBeExcluded'?: boolean;
    /**
     * 
     * @type {Array<AnalysisDto>}
     * @memberof GetReportResponse
     */
    'data'?: Array<AnalysisDto> | null;
}
/**
 * 
 * @export
 * @interface GetReportResponseOkResponse
 */
export interface GetReportResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof GetReportResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetReportResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetReportResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {GetReportResponse}
     * @memberof GetReportResponseOkResponse
     */
    'result'?: GetReportResponse;
}
/**
 * 
 * @export
 * @interface GetStatusSummaryResponse
 */
export interface GetStatusSummaryResponse {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof GetStatusSummaryResponse
     */
    'statusSummary'?: { [key: string]: number; } | null;
}
/**
 * 
 * @export
 * @interface GetStatusSummaryResponseOkResponse
 */
export interface GetStatusSummaryResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof GetStatusSummaryResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetStatusSummaryResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetStatusSummaryResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {GetStatusSummaryResponse}
     * @memberof GetStatusSummaryResponseOkResponse
     */
    'result'?: GetStatusSummaryResponse;
}
/**
 * 
 * @export
 * @interface GetThresholdResponse
 */
export interface GetThresholdResponse {
    /**
     * 
     * @type {number}
     * @memberof GetThresholdResponse
     */
    'normalValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetThresholdResponse
     */
    'normalOperatorType'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetThresholdResponse
     */
    'inferiorOperatorType'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetThresholdResponse
     */
    'criticalValue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetThresholdResponse
     */
    'criticalOperatorType'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetThresholdResponse
     */
    'criticalLastValue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetThresholdResponse
     */
    'criticalLastOperatorType'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetThresholdResponse
     */
    'inferiorLastValue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetThresholdResponse
     */
    'inferiorLastOperatorType'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetThresholdResponse
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetThresholdResponse
     */
    'parameterId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetThresholdResponse
     */
    'criteriaDescription'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetThresholdResponse
     */
    'criteriaFieldType'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetThresholdResponse
     */
    'criteriaOperatorType'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetThresholdResponse
     */
    'criteriaValue'?: number | null;
}
/**
 * 
 * @export
 * @interface GetThresholdResponseOkResponse
 */
export interface GetThresholdResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof GetThresholdResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetThresholdResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetThresholdResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {GetThresholdResponse}
     * @memberof GetThresholdResponseOkResponse
     */
    'result'?: GetThresholdResponse;
}
/**
 * 
 * @export
 * @interface HistoricalTrendsDropdownSourceDto
 */
export interface HistoricalTrendsDropdownSourceDto {
    /**
     * 
     * @type {Array<HistoricalTrendsOptionDto>}
     * @memberof HistoricalTrendsDropdownSourceDto
     */
    'options'?: Array<HistoricalTrendsOptionDto> | null;
    /**
     * 
     * @type {string}
     * @memberof HistoricalTrendsDropdownSourceDto
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof HistoricalTrendsDropdownSourceDto
     */
    'endDate'?: string;
}
/**
 * 
 * @export
 * @interface HistoricalTrendsOptionDto
 */
export interface HistoricalTrendsOptionDto {
    /**
     * 
     * @type {string}
     * @memberof HistoricalTrendsOptionDto
     */
    'translationKey'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HistoricalTrendsOptionDto
     */
    'id'?: number;
    /**
     * 
     * @type {Array<HistoricalTrendsOptionDto>}
     * @memberof HistoricalTrendsOptionDto
     */
    'options'?: Array<HistoricalTrendsOptionDto> | null;
}
/**
 * 
 * @export
 * @interface HttpStatusResponse
 */
export interface HttpStatusResponse {
    /**
     * 
     * @type {number}
     * @memberof HttpStatusResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof HttpStatusResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HttpStatusResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof HttpStatusResponse
     */
    'errors'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface ImageDetailsDto
 */
export interface ImageDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ImageDetailsDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ImageDetailsDto
     */
    'analysisNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImageDetailsDto
     */
    'commentText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImageDetailsDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImageDetailsDto
     */
    'imagePath'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ImageDetailsDto
     */
    'analysisType'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ImageDetailsDto
     */
    'parameterId'?: number | null;
}
/**
 * 
 * @export
 * @interface ImportGeneratorsResponseOkResponse
 */
export interface ImportGeneratorsResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof ImportGeneratorsResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof ImportGeneratorsResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportGeneratorsResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ImportGeneratorsResponseOkResponse
     */
    'result'?: object;
}
/**
 * 
 * @export
 * @interface InternalServerErrorResponse
 */
export interface InternalServerErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof InternalServerErrorResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof InternalServerErrorResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternalServerErrorResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternalServerErrorResponse
     */
    'details'?: string | null;
}
/**
 * 
 * @export
 * @interface LatestConditionStatusDto
 */
export interface LatestConditionStatusDto {
    /**
     * 
     * @type {string}
     * @memberof LatestConditionStatusDto
     */
    'componentSid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LatestConditionStatusDto
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof LatestConditionStatusDto
     */
    'reportType'?: number;
    /**
     * 
     * @type {string}
     * @memberof LatestConditionStatusDto
     */
    'reportId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LatestConditionStatusDto
     */
    'status'?: number;
    /**
     * 
     * @type {string}
     * @memberof LatestConditionStatusDto
     */
    'nextReportDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LatestConditionStatusDto
     */
    'isNextDateDue'?: boolean;
}
/**
 * 
 * @export
 * @interface LimitDto
 */
export interface LimitDto {
    /**
     * 
     * @type {number}
     * @memberof LimitDto
     */
    'parameterId'?: number;
    /**
     * 
     * @type {number}
     * @memberof LimitDto
     */
    'limit'?: number;
}
/**
 * 
 * @export
 * @interface ListBookmarksResponse
 */
export interface ListBookmarksResponse {
    /**
     * 
     * @type {Array<BookmarkDto>}
     * @memberof ListBookmarksResponse
     */
    'bookmarks'?: Array<BookmarkDto> | null;
}
/**
 * 
 * @export
 * @interface ListBookmarksResponseOkResponse
 */
export interface ListBookmarksResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof ListBookmarksResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListBookmarksResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListBookmarksResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {ListBookmarksResponse}
     * @memberof ListBookmarksResponseOkResponse
     */
    'result'?: ListBookmarksResponse;
}
/**
 * 
 * @export
 * @interface ListCommentsResponse
 */
export interface ListCommentsResponse {
    /**
     * 
     * @type {Array<CommentDto>}
     * @memberof ListCommentsResponse
     */
    'comments'?: Array<CommentDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ListCommentsResponse
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface ListCommentsResponseOkResponse
 */
export interface ListCommentsResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof ListCommentsResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListCommentsResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListCommentsResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {ListCommentsResponse}
     * @memberof ListCommentsResponseOkResponse
     */
    'result'?: ListCommentsResponse;
}
/**
 * 
 * @export
 * @interface ListComponentRecommendationsResponse
 */
export interface ListComponentRecommendationsResponse {
    /**
     * 
     * @type {Array<RecommendationDto>}
     * @memberof ListComponentRecommendationsResponse
     */
    'items'?: Array<RecommendationDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ListComponentRecommendationsResponse
     */
    'totalCount'?: number;
}
/**
 * 
 * @export
 * @interface ListComponentRecommendationsResponseOkResponse
 */
export interface ListComponentRecommendationsResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof ListComponentRecommendationsResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListComponentRecommendationsResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListComponentRecommendationsResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {ListComponentRecommendationsResponse}
     * @memberof ListComponentRecommendationsResponseOkResponse
     */
    'result'?: ListComponentRecommendationsResponse;
}
/**
 * 
 * @export
 * @interface ListFlaggedGeneratorsResponse
 */
export interface ListFlaggedGeneratorsResponse {
    /**
     * 
     * @type {Array<FlaggedGeneratorDto>}
     * @memberof ListFlaggedGeneratorsResponse
     */
    'items'?: Array<FlaggedGeneratorDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ListFlaggedGeneratorsResponse
     */
    'totalCount'?: number;
}
/**
 * 
 * @export
 * @interface ListFlaggedGeneratorsResponseOkResponse
 */
export interface ListFlaggedGeneratorsResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof ListFlaggedGeneratorsResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListFlaggedGeneratorsResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListFlaggedGeneratorsResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {ListFlaggedGeneratorsResponse}
     * @memberof ListFlaggedGeneratorsResponseOkResponse
     */
    'result'?: ListFlaggedGeneratorsResponse;
}
/**
 * 
 * @export
 * @interface ListFlaggedTransformersResponse
 */
export interface ListFlaggedTransformersResponse {
    /**
     * 
     * @type {Array<FlaggedTransformerDto>}
     * @memberof ListFlaggedTransformersResponse
     */
    'items'?: Array<FlaggedTransformerDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ListFlaggedTransformersResponse
     */
    'totalCount'?: number;
}
/**
 * 
 * @export
 * @interface ListFlaggedTransformersResponseOkResponse
 */
export interface ListFlaggedTransformersResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof ListFlaggedTransformersResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListFlaggedTransformersResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListFlaggedTransformersResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {ListFlaggedTransformersResponse}
     * @memberof ListFlaggedTransformersResponseOkResponse
     */
    'result'?: ListFlaggedTransformersResponse;
}
/**
 * 
 * @export
 * @interface ListGeneratorAnalysisByTypeResponse
 */
export interface ListGeneratorAnalysisByTypeResponse {
    /**
     * 
     * @type {number}
     * @memberof ListGeneratorAnalysisByTypeResponse
     */
    'status'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListGeneratorAnalysisByTypeResponse
     */
    'reportId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ListGeneratorAnalysisByTypeResponse
     */
    'canBeExcluded'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ListGeneratorAnalysisByTypeResponse
     */
    'isExcluded'?: boolean | null;
    /**
     * 
     * @type {Array<GeneratorReportDataDto>}
     * @memberof ListGeneratorAnalysisByTypeResponse
     */
    'reports'?: Array<GeneratorReportDataDto> | null;
    /**
     * 
     * @type {VisualInspectionDataDto}
     * @memberof ListGeneratorAnalysisByTypeResponse
     */
    'visualInspectionReport'?: VisualInspectionDataDto;
}
/**
 * 
 * @export
 * @interface ListGeneratorAnalysisByTypeResponseOkResponse
 */
export interface ListGeneratorAnalysisByTypeResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof ListGeneratorAnalysisByTypeResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListGeneratorAnalysisByTypeResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListGeneratorAnalysisByTypeResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {ListGeneratorAnalysisByTypeResponse}
     * @memberof ListGeneratorAnalysisByTypeResponseOkResponse
     */
    'result'?: ListGeneratorAnalysisByTypeResponse;
}
/**
 * 
 * @export
 * @interface ListGeneratorVisualInspectionsResponse
 */
export interface ListGeneratorVisualInspectionsResponse {
    /**
     * 
     * @type {Array<VisualInspectionDataDto>}
     * @memberof ListGeneratorVisualInspectionsResponse
     */
    'items'?: Array<VisualInspectionDataDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ListGeneratorVisualInspectionsResponse
     */
    'totalCount'?: number;
}
/**
 * 
 * @export
 * @interface ListGeneratorVisualInspectionsResponseOkResponse
 */
export interface ListGeneratorVisualInspectionsResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof ListGeneratorVisualInspectionsResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListGeneratorVisualInspectionsResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListGeneratorVisualInspectionsResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {ListGeneratorVisualInspectionsResponse}
     * @memberof ListGeneratorVisualInspectionsResponseOkResponse
     */
    'result'?: ListGeneratorVisualInspectionsResponse;
}
/**
 * 
 * @export
 * @interface ListOilAnalysisReportsByTransformerResponse
 */
export interface ListOilAnalysisReportsByTransformerResponse {
    /**
     * 
     * @type {number}
     * @memberof ListOilAnalysisReportsByTransformerResponse
     */
    'status'?: number;
    /**
     * 
     * @type {Array<ReportDataDto>}
     * @memberof ListOilAnalysisReportsByTransformerResponse
     */
    'reports'?: Array<ReportDataDto> | null;
    /**
     * 
     * @type {Array<LimitDto>}
     * @memberof ListOilAnalysisReportsByTransformerResponse
     */
    'limits'?: Array<LimitDto> | null;
}
/**
 * 
 * @export
 * @interface ListOilAnalysisReportsByTransformerResponseOkResponse
 */
export interface ListOilAnalysisReportsByTransformerResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof ListOilAnalysisReportsByTransformerResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListOilAnalysisReportsByTransformerResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListOilAnalysisReportsByTransformerResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {ListOilAnalysisReportsByTransformerResponse}
     * @memberof ListOilAnalysisReportsByTransformerResponseOkResponse
     */
    'result'?: ListOilAnalysisReportsByTransformerResponse;
}
/**
 * 
 * @export
 * @interface ListPortfolioEventsResponse
 */
export interface ListPortfolioEventsResponse {
    /**
     * 
     * @type {Array<ActivityTrackingListDto>}
     * @memberof ListPortfolioEventsResponse
     */
    'items'?: Array<ActivityTrackingListDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ListPortfolioEventsResponse
     */
    'totalCount'?: number;
}
/**
 * 
 * @export
 * @interface ListPortfolioEventsResponseOkResponse
 */
export interface ListPortfolioEventsResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof ListPortfolioEventsResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListPortfolioEventsResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListPortfolioEventsResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {ListPortfolioEventsResponse}
     * @memberof ListPortfolioEventsResponseOkResponse
     */
    'result'?: ListPortfolioEventsResponse;
}
/**
 * 
 * @export
 * @interface ListRecommendationTypesResponse
 */
export interface ListRecommendationTypesResponse {
    /**
     * 
     * @type {RecommendationTypesDtoPaginatedResponseDto}
     * @memberof ListRecommendationTypesResponse
     */
    'recommendationTypes'?: RecommendationTypesDtoPaginatedResponseDto;
}
/**
 * 
 * @export
 * @interface ListRecommendationTypesResponseOkResponse
 */
export interface ListRecommendationTypesResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof ListRecommendationTypesResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListRecommendationTypesResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListRecommendationTypesResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {ListRecommendationTypesResponse}
     * @memberof ListRecommendationTypesResponseOkResponse
     */
    'result'?: ListRecommendationTypesResponse;
}
/**
 * 
 * @export
 * @interface ListRecommendationsByComponentTypeResponse
 */
export interface ListRecommendationsByComponentTypeResponse {
    /**
     * 
     * @type {Array<RecommendationComponentListDto>}
     * @memberof ListRecommendationsByComponentTypeResponse
     */
    'items'?: Array<RecommendationComponentListDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ListRecommendationsByComponentTypeResponse
     */
    'totalCount'?: number;
}
/**
 * 
 * @export
 * @interface ListRecommendationsByComponentTypeResponseOkResponse
 */
export interface ListRecommendationsByComponentTypeResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof ListRecommendationsByComponentTypeResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListRecommendationsByComponentTypeResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListRecommendationsByComponentTypeResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {ListRecommendationsByComponentTypeResponse}
     * @memberof ListRecommendationsByComponentTypeResponseOkResponse
     */
    'result'?: ListRecommendationsByComponentTypeResponse;
}
/**
 * 
 * @export
 * @interface ListReportNumbersResponse
 */
export interface ListReportNumbersResponse {
    /**
     * 
     * @type {Array<ReportNumberDto>}
     * @memberof ListReportNumbersResponse
     */
    'reportNumbers'?: Array<ReportNumberDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ListReportNumbersResponse
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface ListReportNumbersResponseOkResponse
 */
export interface ListReportNumbersResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof ListReportNumbersResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListReportNumbersResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListReportNumbersResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {ListReportNumbersResponse}
     * @memberof ListReportNumbersResponseOkResponse
     */
    'result'?: ListReportNumbersResponse;
}
/**
 * 
 * @export
 * @interface ListReportsResponse
 */
export interface ListReportsResponse {
    /**
     * 
     * @type {number}
     * @memberof ListReportsResponse
     */
    'total'?: number;
    /**
     * 
     * @type {Array<ReportDto>}
     * @memberof ListReportsResponse
     */
    'reports'?: Array<ReportDto> | null;
}
/**
 * 
 * @export
 * @interface ListReportsResponseOkResponse
 */
export interface ListReportsResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof ListReportsResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListReportsResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListReportsResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {ListReportsResponse}
     * @memberof ListReportsResponseOkResponse
     */
    'result'?: ListReportsResponse;
}
/**
 * 
 * @export
 * @interface ListThresholdsResponse
 */
export interface ListThresholdsResponse {
    /**
     * 
     * @type {Array<ThresholdsAnalysisDto>}
     * @memberof ListThresholdsResponse
     */
    'thresholdsAnalysis'?: Array<ThresholdsAnalysisDto> | null;
}
/**
 * 
 * @export
 * @interface ListThresholdsResponseOkResponse
 */
export interface ListThresholdsResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof ListThresholdsResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListThresholdsResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListThresholdsResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {ListThresholdsResponse}
     * @memberof ListThresholdsResponseOkResponse
     */
    'result'?: ListThresholdsResponse;
}
/**
 * 
 * @export
 * @interface ListVisualInspectionsResponse
 */
export interface ListVisualInspectionsResponse {
    /**
     * 
     * @type {Array<VisualInspectionDataDto>}
     * @memberof ListVisualInspectionsResponse
     */
    'items'?: Array<VisualInspectionDataDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ListVisualInspectionsResponse
     */
    'totalCount'?: number;
}
/**
 * 
 * @export
 * @interface ListVisualInspectionsResponseOkResponse
 */
export interface ListVisualInspectionsResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof ListVisualInspectionsResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListVisualInspectionsResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListVisualInspectionsResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {ListVisualInspectionsResponse}
     * @memberof ListVisualInspectionsResponseOkResponse
     */
    'result'?: ListVisualInspectionsResponse;
}
/**
 * 
 * @export
 * @interface NoActionComponentDto
 */
export interface NoActionComponentDto {
    /**
     * 
     * @type {number}
     * @memberof NoActionComponentDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof NoActionComponentDto
     */
    'componentSid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NoActionComponentDto
     */
    'componentType'?: number;
    /**
     * 
     * @type {string}
     * @memberof NoActionComponentDto
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NoActionComponentDto
     */
    'createdAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NoActionComponentDto
     */
    'createdBy'?: string | null;
}
/**
 * 
 * @export
 * @interface NotFoundResponse
 */
export interface NotFoundResponse {
    /**
     * 
     * @type {number}
     * @memberof NotFoundResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof NotFoundResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotFoundResponse
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface OverrideCommentDto
 */
export interface OverrideCommentDto {
    /**
     * 
     * @type {string}
     * @memberof OverrideCommentDto
     */
    'text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OverrideCommentDto
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof OverrideCommentDto
     */
    'kid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OverrideCommentDto
     */
    'previousStatus'?: number;
    /**
     * 
     * @type {number}
     * @memberof OverrideCommentDto
     */
    'newStatus'?: number;
}
/**
 * 
 * @export
 * @interface OverrideParameterStatusRequest
 */
export interface OverrideParameterStatusRequest {
    /**
     * 
     * @type {OverrideStatusDto}
     * @memberof OverrideParameterStatusRequest
     */
    'overrideData'?: OverrideStatusDto;
}
/**
 * 
 * @export
 * @interface OverrideParameterStatusResponse
 */
export interface OverrideParameterStatusResponse {
    /**
     * The id of the updated parameter value.
     * @type {number}
     * @memberof OverrideParameterStatusResponse
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface OverrideParameterStatusResponseOkResponse
 */
export interface OverrideParameterStatusResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof OverrideParameterStatusResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof OverrideParameterStatusResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OverrideParameterStatusResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {OverrideParameterStatusResponse}
     * @memberof OverrideParameterStatusResponseOkResponse
     */
    'result'?: OverrideParameterStatusResponse;
}
/**
 * 
 * @export
 * @interface OverrideReportStatusDto
 */
export interface OverrideReportStatusDto {
    /**
     * 
     * @type {number}
     * @memberof OverrideReportStatusDto
     */
    'reportType'?: number;
    /**
     * 
     * @type {number}
     * @memberof OverrideReportStatusDto
     */
    'reportId'?: number;
    /**
     * 
     * @type {number}
     * @memberof OverrideReportStatusDto
     */
    'newStatus'?: number;
    /**
     * 
     * @type {string}
     * @memberof OverrideReportStatusDto
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OverrideReportStatusDto
     */
    'componentSid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OverrideReportStatusDto
     */
    'componentType'?: number;
}
/**
 * 
 * @export
 * @interface OverrideReportStatusRequest
 */
export interface OverrideReportStatusRequest {
    /**
     * 
     * @type {OverrideReportStatusDto}
     * @memberof OverrideReportStatusRequest
     */
    'overrideData'?: OverrideReportStatusDto;
}
/**
 * 
 * @export
 * @interface OverrideReportStatusResponse
 */
export interface OverrideReportStatusResponse {
    /**
     * The id of the updated report.
     * @type {number}
     * @memberof OverrideReportStatusResponse
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface OverrideReportStatusResponseOkResponse
 */
export interface OverrideReportStatusResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof OverrideReportStatusResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof OverrideReportStatusResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OverrideReportStatusResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {OverrideReportStatusResponse}
     * @memberof OverrideReportStatusResponseOkResponse
     */
    'result'?: OverrideReportStatusResponse;
}
/**
 * 
 * @export
 * @interface OverrideStatusDto
 */
export interface OverrideStatusDto {
    /**
     * 
     * @type {number}
     * @memberof OverrideStatusDto
     */
    'parameterValueId'?: number;
    /**
     * 
     * @type {number}
     * @memberof OverrideStatusDto
     */
    'newStatus'?: number;
    /**
     * 
     * @type {string}
     * @memberof OverrideStatusDto
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OverrideStatusDto
     */
    'componentSid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OverrideStatusDto
     */
    'analysisType'?: number;
    /**
     * 
     * @type {number}
     * @memberof OverrideStatusDto
     */
    'componentType'?: number;
}
/**
 * 
 * @export
 * @interface ParameterDto
 */
export interface ParameterDto {
    /**
     * 
     * @type {number}
     * @memberof ParameterDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ParameterDto
     */
    'parameterId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ParameterDto
     */
    'status'?: number;
    /**
     * 
     * @type {CommentParameterDto}
     * @memberof ParameterDto
     */
    'latestComment'?: CommentParameterDto;
    /**
     * 
     * @type {string}
     * @memberof ParameterDto
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterDto
     */
    'imageRef'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ParameterDto
     */
    'numberValue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterDto
     */
    'stringValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterDto
     */
    'unit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterDto
     */
    'unitParameter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterDto
     */
    'referenceValue'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ParameterDto
     */
    'canBeOverritten'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ParameterDto
     */
    'tableNumber'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ParameterDto
     */
    'isReferenceParam'?: boolean;
    /**
     * 
     * @type {OverrideCommentDto}
     * @memberof ParameterDto
     */
    'overrideComment'?: OverrideCommentDto;
}
/**
 * 
 * @export
 * @interface ParameterGroupDto
 */
export interface ParameterGroupDto {
    /**
     * 
     * @type {string}
     * @memberof ParameterGroupDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ParameterGroupDto
     */
    'mustIncludeTemperature'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ParameterGroupDto
     */
    'analysisType'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ParameterGroupDto
     */
    'parameterIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ParameterGroupDto
     */
    'denominatorParameterIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ParameterReportDto
 */
export interface ParameterReportDto {
    /**
     * 
     * @type {number}
     * @memberof ParameterReportDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ParameterReportDto
     */
    'parameterId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ParameterReportDto
     */
    'status'?: number;
    /**
     * 
     * @type {CommentParameterDto}
     * @memberof ParameterReportDto
     */
    'latestComment'?: CommentParameterDto;
    /**
     * 
     * @type {string}
     * @memberof ParameterReportDto
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterReportDto
     */
    'imageRef'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ParameterReportDto
     */
    'numberValue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterReportDto
     */
    'stringValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterReportDto
     */
    'unit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterReportDto
     */
    'unitParameter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterReportDto
     */
    'referenceValue'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ParameterReportDto
     */
    'canBeOverritten'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ParameterReportDto
     */
    'tableNumber'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ParameterReportDto
     */
    'isReferenceParam'?: boolean;
    /**
     * 
     * @type {OverrideCommentDto}
     * @memberof ParameterReportDto
     */
    'overrideComment'?: OverrideCommentDto;
    /**
     * 
     * @type {number}
     * @memberof ParameterReportDto
     */
    'limit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterReportDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<CommentDto>}
     * @memberof ParameterReportDto
     */
    'comments'?: Array<CommentDto> | null;
}
/**
 * 
 * @export
 * @interface ParameterTypeDto
 */
export interface ParameterTypeDto {
    /**
     * 
     * @type {number}
     * @memberof ParameterTypeDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ParameterTypeDto
     */
    'analysisType'?: number;
    /**
     * 
     * @type {string}
     * @memberof ParameterTypeDto
     */
    'englishName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterTypeDto
     */
    'germanName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ParameterTypeDto
     */
    'unitOfMeasureType'?: number;
    /**
     * 
     * @type {string}
     * @memberof ParameterTypeDto
     */
    'shortName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ParameterTypeDto
     */
    'canBeOverwritten'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ParameterTypeDto
     */
    'hierarchyOrderId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ParameterTypeDto
     */
    'isDisplayShortName'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ParameterTypeDto
     */
    'englishAutomaticNotice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterTypeDto
     */
    'germanAutomaticNotice'?: string | null;
}
/**
 * 
 * @export
 * @interface PingGetResponse
 */
export interface PingGetResponse {
    /**
     * 
     * @type {number}
     * @memberof PingGetResponse
     */
    'timestamp'?: number;
}
/**
 * 
 * @export
 * @interface PingGetResponseOkResponse
 */
export interface PingGetResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof PingGetResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof PingGetResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PingGetResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {PingGetResponse}
     * @memberof PingGetResponseOkResponse
     */
    'result'?: PingGetResponse;
}
/**
 * 
 * @export
 * @interface PlantGroupDto
 */
export interface PlantGroupDto {
    /**
     * 
     * @type {number}
     * @memberof PlantGroupDto
     */
    'sid'?: number;
    /**
     * 
     * @type {string}
     * @memberof PlantGroupDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<AssetDto>}
     * @memberof PlantGroupDto
     */
    'plants'?: Array<AssetDto> | null;
}
/**
 * 
 * @export
 * @interface PlantGroupWithGeneratorHierarchyDto
 */
export interface PlantGroupWithGeneratorHierarchyDto {
    /**
     * 
     * @type {number}
     * @memberof PlantGroupWithGeneratorHierarchyDto
     */
    'sid'?: number;
    /**
     * 
     * @type {string}
     * @memberof PlantGroupWithGeneratorHierarchyDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<PlantWithGeneratorsDto>}
     * @memberof PlantGroupWithGeneratorHierarchyDto
     */
    'plants'?: Array<PlantWithGeneratorsDto> | null;
}
/**
 * 
 * @export
 * @interface PlantGroupWithTransformerHierarchyDto
 */
export interface PlantGroupWithTransformerHierarchyDto {
    /**
     * 
     * @type {number}
     * @memberof PlantGroupWithTransformerHierarchyDto
     */
    'sid'?: number;
    /**
     * 
     * @type {string}
     * @memberof PlantGroupWithTransformerHierarchyDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<PlantWithTransformersDto>}
     * @memberof PlantGroupWithTransformerHierarchyDto
     */
    'plants'?: Array<PlantWithTransformersDto> | null;
}
/**
 * 
 * @export
 * @interface PlantOverviewToolTipDto
 */
export interface PlantOverviewToolTipDto {
    /**
     * 
     * @type {string}
     * @memberof PlantOverviewToolTipDto
     */
    'componentSid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlantOverviewToolTipDto
     */
    'componentName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlantOverviewToolTipDto
     */
    'componentStatusLink'?: string | null;
}
/**
 * 
 * @export
 * @interface PlantWithGeneratorsDto
 */
export interface PlantWithGeneratorsDto {
    /**
     * 
     * @type {number}
     * @memberof PlantWithGeneratorsDto
     */
    'sid'?: number;
    /**
     * 
     * @type {string}
     * @memberof PlantWithGeneratorsDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<GeneratorIdDto>}
     * @memberof PlantWithGeneratorsDto
     */
    'generators'?: Array<GeneratorIdDto> | null;
}
/**
 * 
 * @export
 * @interface PlantWithTransformersDto
 */
export interface PlantWithTransformersDto {
    /**
     * 
     * @type {number}
     * @memberof PlantWithTransformersDto
     */
    'sid'?: number;
    /**
     * 
     * @type {string}
     * @memberof PlantWithTransformersDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<TransformerIdDto>}
     * @memberof PlantWithTransformersDto
     */
    'transformers'?: Array<TransformerIdDto> | null;
}
/**
 * 
 * @export
 * @interface RecommendationAddDto
 */
export interface RecommendationAddDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof RecommendationAddDto
     */
    'comments'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof RecommendationAddDto
     */
    'recommendationTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RecommendationAddDto
     */
    'freeText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationAddDto
     */
    'sapNotificationNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationAddDto
     */
    'ptRiskId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationAddDto
     */
    'pspNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationAddDto
     */
    'sapNotificationUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationAddDto
     */
    'ptRiskUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationAddDto
     */
    'pspNumberUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface RecommendationCommentDto
 */
export interface RecommendationCommentDto {
    /**
     * 
     * @type {number}
     * @memberof RecommendationCommentDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof RecommendationCommentDto
     */
    'text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationCommentDto
     */
    'kid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationCommentDto
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface RecommendationCommentEditDto
 */
export interface RecommendationCommentEditDto {
    /**
     * 
     * @type {number}
     * @memberof RecommendationCommentEditDto
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationCommentEditDto
     */
    'text'?: string | null;
}
/**
 * 
 * @export
 * @interface RecommendationComponentListDto
 */
export interface RecommendationComponentListDto {
    /**
     * 
     * @type {number}
     * @memberof RecommendationComponentListDto
     */
    'recommendationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RecommendationComponentListDto
     */
    'plantGroupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationComponentListDto
     */
    'plantName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RecommendationComponentListDto
     */
    'componentType'?: number;
    /**
     * 
     * @type {string}
     * @memberof RecommendationComponentListDto
     */
    'componentSid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationComponentListDto
     */
    'componentName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationComponentListDto
     */
    'componentLink'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationComponentListDto
     */
    'date'?: string;
    /**
     * 
     * @type {RecommendationCommentDto}
     * @memberof RecommendationComponentListDto
     */
    'recommendationComment'?: RecommendationCommentDto;
    /**
     * 
     * @type {number}
     * @memberof RecommendationComponentListDto
     */
    'recommendationTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RecommendationComponentListDto
     */
    'sapNotificationNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationComponentListDto
     */
    'sapNotificationUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationComponentListDto
     */
    'ptRiskId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationComponentListDto
     */
    'ptRiskUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationComponentListDto
     */
    'pspNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationComponentListDto
     */
    'pspNumberUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationComponentListDto
     */
    'freeText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationComponentListDto
     */
    'createdByKid'?: string | null;
}
/**
 * 
 * @export
 * @interface RecommendationDto
 */
export interface RecommendationDto {
    /**
     * 
     * @type {number}
     * @memberof RecommendationDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof RecommendationDto
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof RecommendationDto
     */
    'recommendationTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RecommendationDto
     */
    'freeText'?: string | null;
    /**
     * 
     * @type {RecommendationCommentDto}
     * @memberof RecommendationDto
     */
    'comment'?: RecommendationCommentDto;
    /**
     * 
     * @type {RecommendationSapNotificationDto}
     * @memberof RecommendationDto
     */
    'sapNotifcation'?: RecommendationSapNotificationDto;
    /**
     * 
     * @type {string}
     * @memberof RecommendationDto
     */
    'sapNotificationNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationDto
     */
    'pspNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationDto
     */
    'ptRiskId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationDto
     */
    'sapNotificationUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationDto
     */
    'ptRiskUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationDto
     */
    'pspNumberUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationDto
     */
    'kid'?: string | null;
}
/**
 * 
 * @export
 * @interface RecommendationEditDto
 */
export interface RecommendationEditDto {
    /**
     * 
     * @type {Array<RecommendationCommentEditDto>}
     * @memberof RecommendationEditDto
     */
    'comments'?: Array<RecommendationCommentEditDto> | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationEditDto
     */
    'ptRiskId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationEditDto
     */
    'pspNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationEditDto
     */
    'sapNotificationNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationEditDto
     */
    'sapNotificationUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationEditDto
     */
    'ptRiskUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationEditDto
     */
    'pspNumberUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface RecommendationSapNotificationDto
 */
export interface RecommendationSapNotificationDto {
    /**
     * 
     * @type {string}
     * @memberof RecommendationSapNotificationDto
     */
    'notificationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationSapNotificationDto
     */
    'notificationDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationSapNotificationDto
     */
    'author'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationSapNotificationDto
     */
    'creationDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationSapNotificationDto
     */
    'systemStatusTextDe'?: string | null;
}
/**
 * 
 * @export
 * @interface RecommendationTypeRequestDto
 */
export interface RecommendationTypeRequestDto {
    /**
     * 
     * @type {string}
     * @memberof RecommendationTypeRequestDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationTypeRequestDto
     */
    'germanName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RecommendationTypeRequestDto
     */
    'componentType'?: number;
}
/**
 * 
 * @export
 * @interface RecommendationTypesDto
 */
export interface RecommendationTypesDto {
    /**
     * 
     * @type {number}
     * @memberof RecommendationTypesDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof RecommendationTypesDto
     */
    'englishName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationTypesDto
     */
    'germanName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RecommendationTypesDto
     */
    'componentType'?: number;
}
/**
 * 
 * @export
 * @interface RecommendationTypesDtoPaginatedResponseDto
 */
export interface RecommendationTypesDtoPaginatedResponseDto {
    /**
     * 
     * @type {Array<RecommendationTypesDto>}
     * @memberof RecommendationTypesDtoPaginatedResponseDto
     */
    'items'?: Array<RecommendationTypesDto> | null;
    /**
     * 
     * @type {number}
     * @memberof RecommendationTypesDtoPaginatedResponseDto
     */
    'totalCount'?: number;
}
/**
 * 
 * @export
 * @interface RegisteredServicesResponse
 */
export interface RegisteredServicesResponse {
    /**
     * 
     * @type {Array<ServiceDto>}
     * @memberof RegisteredServicesResponse
     */
    'items'?: Array<ServiceDto> | null;
}
/**
 * 
 * @export
 * @interface RegisteredServicesResponseOkResponse
 */
export interface RegisteredServicesResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof RegisteredServicesResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof RegisteredServicesResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisteredServicesResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {RegisteredServicesResponse}
     * @memberof RegisteredServicesResponseOkResponse
     */
    'result'?: RegisteredServicesResponse;
}
/**
 * 
 * @export
 * @interface ReportDataDto
 */
export interface ReportDataDto {
    /**
     * 
     * @type {string}
     * @memberof ReportDataDto
     */
    'analyticalNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportDataDto
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportDataDto
     */
    'samplingPoint'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportDataDto
     */
    'temperature'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportDataDto
     */
    'status'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportDataDto
     */
    'referenceStartDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportDataDto
     */
    'referenceEndDate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReportDataDto
     */
    'isCurrentReference'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReportDataDto
     */
    'comment'?: string | null;
    /**
     * 
     * @type {Array<ParameterDto>}
     * @memberof ReportDataDto
     */
    'parameters'?: Array<ParameterDto> | null;
}
/**
 * 
 * @export
 * @interface ReportDto
 */
export interface ReportDto {
    /**
     * 
     * @type {string}
     * @memberof ReportDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportDto
     */
    'plantName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportDto
     */
    'componentSid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportDto
     */
    'componentName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportDto
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReportDto
     */
    'reportType'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportDto
     */
    'status'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportDto
     */
    'reportNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReportDto
     */
    'isExcluded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReportDto
     */
    'canBeExcluded'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ReportDto
     */
    'componentType'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReportDto
     */
    'isCurrentReference'?: boolean;
}
/**
 * 
 * @export
 * @interface ReportNumberDto
 */
export interface ReportNumberDto {
    /**
     * 
     * @type {string}
     * @memberof ReportNumberDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportNumberDto
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface ServiceDto
 */
export interface ServiceDto {
    /**
     * 
     * @type {string}
     * @memberof ServiceDto
     */
    'serviceType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceDto
     */
    'implementationType'?: string | null;
    /**
     * 
     * @type {ServiceLifetime}
     * @memberof ServiceDto
     */
    'lifetime'?: ServiceLifetime;
}


/**
 *   0 = Singleton  1 = Scoped  2 = Transient
 * @export
 * @enum {string}
 */

export const ServiceLifetime = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type ServiceLifetime = typeof ServiceLifetime[keyof typeof ServiceLifetime];


/**
 * 
 * @export
 * @interface SetIsExcludedResponse
 */
export interface SetIsExcludedResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SetIsExcludedResponse
     */
    'isExcluded'?: boolean;
}
/**
 * 
 * @export
 * @interface SetIsExcludedResponseOkResponse
 */
export interface SetIsExcludedResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof SetIsExcludedResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof SetIsExcludedResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SetIsExcludedResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {SetIsExcludedResponse}
     * @memberof SetIsExcludedResponseOkResponse
     */
    'result'?: SetIsExcludedResponse;
}
/**
 * 
 * @export
 * @interface SetIsReferenceResponse
 */
export interface SetIsReferenceResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SetIsReferenceResponse
     */
    'isCurrentReference'?: boolean;
}
/**
 * 
 * @export
 * @interface SetIsReferenceResponseOkResponse
 */
export interface SetIsReferenceResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof SetIsReferenceResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof SetIsReferenceResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SetIsReferenceResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {SetIsReferenceResponse}
     * @memberof SetIsReferenceResponseOkResponse
     */
    'result'?: SetIsReferenceResponse;
}
/**
 *   1 = Plant  2 = ReportType  3 = Status  4 = Excluded
 * @export
 * @enum {string}
 */

export const SortProjectType = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
} as const;

export type SortProjectType = typeof SortProjectType[keyof typeof SortProjectType];


/**
 * 
 * @export
 * @interface SyncDataResponse
 */
export interface SyncDataResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SyncDataResponse
     */
    'importWasSuccessful'?: boolean;
}
/**
 * 
 * @export
 * @interface SyncDataResponseOkResponse
 */
export interface SyncDataResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof SyncDataResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof SyncDataResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SyncDataResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {SyncDataResponse}
     * @memberof SyncDataResponseOkResponse
     */
    'result'?: SyncDataResponse;
}
/**
 * 
 * @export
 * @interface ThresholdEditDto
 */
export interface ThresholdEditDto {
    /**
     * 
     * @type {number}
     * @memberof ThresholdEditDto
     */
    'normalValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof ThresholdEditDto
     */
    'normalOperatorType'?: number;
    /**
     * 
     * @type {number}
     * @memberof ThresholdEditDto
     */
    'inferiorOperatorType'?: number;
    /**
     * 
     * @type {number}
     * @memberof ThresholdEditDto
     */
    'criticalValue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ThresholdEditDto
     */
    'criticalOperatorType'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ThresholdEditDto
     */
    'criticalLastValue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ThresholdEditDto
     */
    'criticalLastOperatorType'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ThresholdEditDto
     */
    'inferiorLastValue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ThresholdEditDto
     */
    'inferiorLastOperatorType'?: number | null;
}
/**
 * 
 * @export
 * @interface ThresholdListDto
 */
export interface ThresholdListDto {
    /**
     * 
     * @type {number}
     * @memberof ThresholdListDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ThresholdListDto
     */
    'parameterId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ThresholdListDto
     */
    'criteriaFieldType'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ThresholdListDto
     */
    'criteriaOperatorType'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ThresholdListDto
     */
    'criteriaDescription'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ThresholdListDto
     */
    'criteriaValue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ThresholdListDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof ThresholdListDto
     */
    'normalValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ThresholdListDto
     */
    'inferiorValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ThresholdListDto
     */
    'criticalValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ThresholdListDto
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThresholdListDto
     */
    'validTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof ThresholdListDto
     */
    'analysisType'?: number | null;
}
/**
 * 
 * @export
 * @interface ThresholdsAnalysisDto
 */
export interface ThresholdsAnalysisDto {
    /**
     * 
     * @type {number}
     * @memberof ThresholdsAnalysisDto
     */
    'analysisType'?: number;
    /**
     * 
     * @type {number}
     * @memberof ThresholdsAnalysisDto
     */
    'cycleYears'?: number;
    /**
     * 
     * @type {Array<ThresholdListDto>}
     * @memberof ThresholdsAnalysisDto
     */
    'thresholds'?: Array<ThresholdListDto> | null;
}
/**
 * 
 * @export
 * @interface TooManyRequestsResponse
 */
export interface TooManyRequestsResponse {
    /**
     * 
     * @type {number}
     * @memberof TooManyRequestsResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof TooManyRequestsResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TooManyRequestsResponse
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface TransformerIdDto
 */
export interface TransformerIdDto {
    /**
     * 
     * @type {string}
     * @memberof TransformerIdDto
     */
    'transformerSid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransformerIdDto
     */
    'functionalLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransformerIdDto
     */
    'transformerName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TransformerIdDto
     */
    'bookmarkId'?: number | null;
}
/**
 * 
 * @export
 * @interface UpdateBookmarksRequest
 */
export interface UpdateBookmarksRequest {
    /**
     * The updated data.
     * @type {Array<BookmarkUpdateDto>}
     * @memberof UpdateBookmarksRequest
     */
    'bookmarks'?: Array<BookmarkUpdateDto> | null;
}
/**
 * 
 * @export
 * @interface UpdateBookmarksResponse
 */
export interface UpdateBookmarksResponse {
    /**
     * The updated data.
     * @type {Array<BookmarkDto>}
     * @memberof UpdateBookmarksResponse
     */
    'updatedData'?: Array<BookmarkDto> | null;
}
/**
 * 
 * @export
 * @interface UpdateBookmarksResponseOkResponse
 */
export interface UpdateBookmarksResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof UpdateBookmarksResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBookmarksResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateBookmarksResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {UpdateBookmarksResponse}
     * @memberof UpdateBookmarksResponseOkResponse
     */
    'result'?: UpdateBookmarksResponse;
}
/**
 * 
 * @export
 * @interface UploadFileResponse
 */
export interface UploadFileResponse {
    /**
     * 
     * @type {number}
     * @memberof UploadFileResponse
     */
    'generalCommentId'?: number;
}
/**
 * 
 * @export
 * @interface UploadFileResponseOkResponse
 */
export interface UploadFileResponseOkResponse {
    /**
     * 
     * @type {number}
     * @memberof UploadFileResponseOkResponse
     */
    'statusCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof UploadFileResponseOkResponse
     */
    'statusDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UploadFileResponseOkResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {UploadFileResponse}
     * @memberof UploadFileResponseOkResponse
     */
    'result'?: UploadFileResponse;
}
/**
 * 
 * @export
 * @interface VisualInspectionDataDto
 */
export interface VisualInspectionDataDto {
    /**
     * 
     * @type {number}
     * @memberof VisualInspectionDataDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionDataDto
     */
    'analyticalNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionDataDto
     */
    'reportLink'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VisualInspectionDataDto
     */
    'isExcluded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionDataDto
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionDataDto
     */
    'inspectionComment'?: string | null;
    /**
     * 
     * @type {OverrideCommentDto}
     * @memberof VisualInspectionDataDto
     */
    'overrideComment'?: OverrideCommentDto;
    /**
     * 
     * @type {boolean}
     * @memberof VisualInspectionDataDto
     */
    'hasImages'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VisualInspectionDataDto
     */
    'status'?: number;
    /**
     * 
     * @type {Array<VisualInspectionParameterValueDto>}
     * @memberof VisualInspectionDataDto
     */
    'inspectionParameterValues'?: Array<VisualInspectionParameterValueDto> | null;
}
/**
 * 
 * @export
 * @interface VisualInspectionParameterDto
 */
export interface VisualInspectionParameterDto {
    /**
     * 
     * @type {number}
     * @memberof VisualInspectionParameterDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionParameterDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionParameterDto
     */
    'sapName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VisualInspectionParameterDto
     */
    'componentType'?: number;
    /**
     * 
     * @type {number}
     * @memberof VisualInspectionParameterDto
     */
    'hierarchyOrderId'?: number | null;
}
/**
 * 
 * @export
 * @interface VisualInspectionParameterValueDto
 */
export interface VisualInspectionParameterValueDto {
    /**
     * 
     * @type {number}
     * @memberof VisualInspectionParameterValueDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof VisualInspectionParameterValueDto
     */
    'parameterId'?: number;
    /**
     * 
     * @type {number}
     * @memberof VisualInspectionParameterValueDto
     */
    'hierarchyOrderId'?: number;
    /**
     * 
     * @type {number}
     * @memberof VisualInspectionParameterValueDto
     */
    'status'?: number;
    /**
     * 
     * @type {CommentParameterDto}
     * @memberof VisualInspectionParameterValueDto
     */
    'latestComment'?: CommentParameterDto;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionParameterValueDto
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionParameterValueDto
     */
    'imageRef'?: string | null;
}

/**
 * BookmarksApi - axios parameter creator
 * @export
 */
export const BookmarksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a bookmark for a transformer.
         * @summary Add a bookmark for a transformer.
         * @param {AddBookmarkRequest} [addBookmarkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBookmark: async (addBookmarkRequest?: AddBookmarkRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/bookmarks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addBookmarkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk update bookmarks by id.
         * @summary Bulk update bookmarks by id.
         * @param {UpdateBookmarksRequest} [updateBookmarksRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateBookmarks: async (updateBookmarksRequest?: UpdateBookmarksRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/bookmarks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBookmarksRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a bookmark by id.
         * @summary Deletes a bookmark by id.
         * @param {number} bookmarkId The id of the bookmark to be deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBookmark: async (bookmarkId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookmarkId' is not null or undefined
            assertParamExists('deleteBookmark', 'bookmarkId', bookmarkId)
            const localVarPath = `/api/v1/bookmarks/{bookmarkId}`
                .replace(`{${"bookmarkId"}}`, encodeURIComponent(String(bookmarkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List bookmarks.
         * @summary List bookmarks.
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBookmarks: async (request?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/bookmarks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (request !== undefined) {
                for (const [key, value] of Object.entries(request)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BookmarksApi - functional programming interface
 * @export
 */
export const BookmarksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BookmarksApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a bookmark for a transformer.
         * @summary Add a bookmark for a transformer.
         * @param {AddBookmarkRequest} [addBookmarkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addBookmark(addBookmarkRequest?: AddBookmarkRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddBookmarkResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addBookmark(addBookmarkRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['BookmarksApi.addBookmark']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Bulk update bookmarks by id.
         * @summary Bulk update bookmarks by id.
         * @param {UpdateBookmarksRequest} [updateBookmarksRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateBookmarks(updateBookmarksRequest?: UpdateBookmarksRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateBookmarksResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateBookmarks(updateBookmarksRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['BookmarksApi.bulkUpdateBookmarks']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Deletes a bookmark by id.
         * @summary Deletes a bookmark by id.
         * @param {number} bookmarkId The id of the bookmark to be deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBookmark(bookmarkId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteBookmarkResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBookmark(bookmarkId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['BookmarksApi.deleteBookmark']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List bookmarks.
         * @summary List bookmarks.
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBookmarks(request?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListBookmarksResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBookmarks(request, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['BookmarksApi.listBookmarks']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * BookmarksApi - factory interface
 * @export
 */
export const BookmarksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BookmarksApiFp(configuration)
    return {
        /**
         * Add a bookmark for a transformer.
         * @summary Add a bookmark for a transformer.
         * @param {AddBookmarkRequest} [addBookmarkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBookmark(addBookmarkRequest?: AddBookmarkRequest, options?: any): AxiosPromise<AddBookmarkResponseOkResponse> {
            return localVarFp.addBookmark(addBookmarkRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk update bookmarks by id.
         * @summary Bulk update bookmarks by id.
         * @param {UpdateBookmarksRequest} [updateBookmarksRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateBookmarks(updateBookmarksRequest?: UpdateBookmarksRequest, options?: any): AxiosPromise<UpdateBookmarksResponseOkResponse> {
            return localVarFp.bulkUpdateBookmarks(updateBookmarksRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a bookmark by id.
         * @summary Deletes a bookmark by id.
         * @param {number} bookmarkId The id of the bookmark to be deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBookmark(bookmarkId: number, options?: any): AxiosPromise<DeleteBookmarkResponseOkResponse> {
            return localVarFp.deleteBookmark(bookmarkId, options).then((request) => request(axios, basePath));
        },
        /**
         * List bookmarks.
         * @summary List bookmarks.
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBookmarks(request?: object, options?: any): AxiosPromise<ListBookmarksResponseOkResponse> {
            return localVarFp.listBookmarks(request, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BookmarksApi - interface
 * @export
 * @interface BookmarksApi
 */
export interface BookmarksApiInterface {
    /**
     * Add a bookmark for a transformer.
     * @summary Add a bookmark for a transformer.
     * @param {AddBookmarkRequest} [addBookmarkRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookmarksApiInterface
     */
    addBookmark(addBookmarkRequest?: AddBookmarkRequest, options?: AxiosRequestConfig): AxiosPromise<AddBookmarkResponseOkResponse>;

    /**
     * Bulk update bookmarks by id.
     * @summary Bulk update bookmarks by id.
     * @param {UpdateBookmarksRequest} [updateBookmarksRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookmarksApiInterface
     */
    bulkUpdateBookmarks(updateBookmarksRequest?: UpdateBookmarksRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateBookmarksResponseOkResponse>;

    /**
     * Deletes a bookmark by id.
     * @summary Deletes a bookmark by id.
     * @param {number} bookmarkId The id of the bookmark to be deleted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookmarksApiInterface
     */
    deleteBookmark(bookmarkId: number, options?: AxiosRequestConfig): AxiosPromise<DeleteBookmarkResponseOkResponse>;

    /**
     * List bookmarks.
     * @summary List bookmarks.
     * @param {object} [request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookmarksApiInterface
     */
    listBookmarks(request?: object, options?: AxiosRequestConfig): AxiosPromise<ListBookmarksResponseOkResponse>;

}

/**
 * BookmarksApi - object-oriented interface
 * @export
 * @class BookmarksApi
 * @extends {BaseAPI}
 */
export class BookmarksApi extends BaseAPI implements BookmarksApiInterface {
    /**
     * Add a bookmark for a transformer.
     * @summary Add a bookmark for a transformer.
     * @param {AddBookmarkRequest} [addBookmarkRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookmarksApi
     */
    public addBookmark(addBookmarkRequest?: AddBookmarkRequest, options?: AxiosRequestConfig) {
        return BookmarksApiFp(this.configuration).addBookmark(addBookmarkRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bulk update bookmarks by id.
     * @summary Bulk update bookmarks by id.
     * @param {UpdateBookmarksRequest} [updateBookmarksRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookmarksApi
     */
    public bulkUpdateBookmarks(updateBookmarksRequest?: UpdateBookmarksRequest, options?: AxiosRequestConfig) {
        return BookmarksApiFp(this.configuration).bulkUpdateBookmarks(updateBookmarksRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a bookmark by id.
     * @summary Deletes a bookmark by id.
     * @param {number} bookmarkId The id of the bookmark to be deleted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookmarksApi
     */
    public deleteBookmark(bookmarkId: number, options?: AxiosRequestConfig) {
        return BookmarksApiFp(this.configuration).deleteBookmark(bookmarkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List bookmarks.
     * @summary List bookmarks.
     * @param {object} [request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookmarksApi
     */
    public listBookmarks(request?: object, options?: AxiosRequestConfig) {
        return BookmarksApiFp(this.configuration).listBookmarks(request, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CommentsApi - axios parameter creator
 * @export
 */
export const CommentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a comment to a component.
         * @summary Add a comment to a component.
         * @param {AddCommentRequest} [addCommentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addComment: async (addCommentRequest?: AddCommentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/comments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCommentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a comment by id.
         * @summary Deletes a comment by id.
         * @param {number} commentId The id of the comment to be deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComment: async (commentId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commentId' is not null or undefined
            assertParamExists('deleteComment', 'commentId', commentId)
            const localVarPath = `/api/v1/comments/{commentId}`
                .replace(`{${"commentId"}}`, encodeURIComponent(String(commentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a comment by id.
         * @summary Updates a comment by id.
         * @param {EditCommentRequest} [editCommentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editComment: async (editCommentRequest?: EditCommentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/comments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editCommentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List comments by component sid.
         * @summary List comments by component sid.
         * @param {string} componentSid 
         * @param {number} componentType 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listComments: async (componentSid: string, componentType: number, page?: number, size?: number, requestedOffset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentSid' is not null or undefined
            assertParamExists('listComments', 'componentSid', componentSid)
            // verify required parameter 'componentType' is not null or undefined
            assertParamExists('listComments', 'componentType', componentType)
            const localVarPath = `/api/v1/comments/{componentType}/{componentSid}`
                .replace(`{${"componentSid"}}`, encodeURIComponent(String(componentSid)))
                .replace(`{${"componentType"}}`, encodeURIComponent(String(componentType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (requestedOffset !== undefined) {
                localVarQueryParameter['requestedOffset'] = requestedOffset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List report numbers by term search.
         * @summary List report numbers by term search.
         * @param {string} componentSid 
         * @param {number} componentType 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReportNumbers: async (componentSid: string, componentType: number, page?: number, size?: number, requestedOffset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentSid' is not null or undefined
            assertParamExists('listReportNumbers', 'componentSid', componentSid)
            // verify required parameter 'componentType' is not null or undefined
            assertParamExists('listReportNumbers', 'componentType', componentType)
            const localVarPath = `/api/v1/comments/{componentType}/{componentSid}/reports`
                .replace(`{${"componentSid"}}`, encodeURIComponent(String(componentSid)))
                .replace(`{${"componentType"}}`, encodeURIComponent(String(componentType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (requestedOffset !== undefined) {
                localVarQueryParameter['requestedOffset'] = requestedOffset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommentsApi - functional programming interface
 * @export
 */
export const CommentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a comment to a component.
         * @summary Add a comment to a component.
         * @param {AddCommentRequest} [addCommentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addComment(addCommentRequest?: AddCommentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddCommentResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addComment(addCommentRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommentsApi.addComment']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Deletes a comment by id.
         * @summary Deletes a comment by id.
         * @param {number} commentId The id of the comment to be deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteComment(commentId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteCommentResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteComment(commentId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommentsApi.deleteComment']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Updates a comment by id.
         * @summary Updates a comment by id.
         * @param {EditCommentRequest} [editCommentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editComment(editCommentRequest?: EditCommentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EditCommentResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editComment(editCommentRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommentsApi.editComment']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List comments by component sid.
         * @summary List comments by component sid.
         * @param {string} componentSid 
         * @param {number} componentType 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listComments(componentSid: string, componentType: number, page?: number, size?: number, requestedOffset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCommentsResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listComments(componentSid, componentType, page, size, requestedOffset, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommentsApi.listComments']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List report numbers by term search.
         * @summary List report numbers by term search.
         * @param {string} componentSid 
         * @param {number} componentType 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listReportNumbers(componentSid: string, componentType: number, page?: number, size?: number, requestedOffset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListReportNumbersResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listReportNumbers(componentSid, componentType, page, size, requestedOffset, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommentsApi.listReportNumbers']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * CommentsApi - factory interface
 * @export
 */
export const CommentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommentsApiFp(configuration)
    return {
        /**
         * Add a comment to a component.
         * @summary Add a comment to a component.
         * @param {AddCommentRequest} [addCommentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addComment(addCommentRequest?: AddCommentRequest, options?: any): AxiosPromise<AddCommentResponseOkResponse> {
            return localVarFp.addComment(addCommentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a comment by id.
         * @summary Deletes a comment by id.
         * @param {number} commentId The id of the comment to be deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComment(commentId: number, options?: any): AxiosPromise<DeleteCommentResponseOkResponse> {
            return localVarFp.deleteComment(commentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a comment by id.
         * @summary Updates a comment by id.
         * @param {EditCommentRequest} [editCommentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editComment(editCommentRequest?: EditCommentRequest, options?: any): AxiosPromise<EditCommentResponseOkResponse> {
            return localVarFp.editComment(editCommentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * List comments by component sid.
         * @summary List comments by component sid.
         * @param {string} componentSid 
         * @param {number} componentType 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listComments(componentSid: string, componentType: number, page?: number, size?: number, requestedOffset?: number, options?: any): AxiosPromise<ListCommentsResponseOkResponse> {
            return localVarFp.listComments(componentSid, componentType, page, size, requestedOffset, options).then((request) => request(axios, basePath));
        },
        /**
         * List report numbers by term search.
         * @summary List report numbers by term search.
         * @param {string} componentSid 
         * @param {number} componentType 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReportNumbers(componentSid: string, componentType: number, page?: number, size?: number, requestedOffset?: number, options?: any): AxiosPromise<ListReportNumbersResponseOkResponse> {
            return localVarFp.listReportNumbers(componentSid, componentType, page, size, requestedOffset, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommentsApi - interface
 * @export
 * @interface CommentsApi
 */
export interface CommentsApiInterface {
    /**
     * Add a comment to a component.
     * @summary Add a comment to a component.
     * @param {AddCommentRequest} [addCommentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApiInterface
     */
    addComment(addCommentRequest?: AddCommentRequest, options?: AxiosRequestConfig): AxiosPromise<AddCommentResponseOkResponse>;

    /**
     * Deletes a comment by id.
     * @summary Deletes a comment by id.
     * @param {number} commentId The id of the comment to be deleted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApiInterface
     */
    deleteComment(commentId: number, options?: AxiosRequestConfig): AxiosPromise<DeleteCommentResponseOkResponse>;

    /**
     * Updates a comment by id.
     * @summary Updates a comment by id.
     * @param {EditCommentRequest} [editCommentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApiInterface
     */
    editComment(editCommentRequest?: EditCommentRequest, options?: AxiosRequestConfig): AxiosPromise<EditCommentResponseOkResponse>;

    /**
     * List comments by component sid.
     * @summary List comments by component sid.
     * @param {string} componentSid 
     * @param {number} componentType 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {number} [requestedOffset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApiInterface
     */
    listComments(componentSid: string, componentType: number, page?: number, size?: number, requestedOffset?: number, options?: AxiosRequestConfig): AxiosPromise<ListCommentsResponseOkResponse>;

    /**
     * List report numbers by term search.
     * @summary List report numbers by term search.
     * @param {string} componentSid 
     * @param {number} componentType 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {number} [requestedOffset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApiInterface
     */
    listReportNumbers(componentSid: string, componentType: number, page?: number, size?: number, requestedOffset?: number, options?: AxiosRequestConfig): AxiosPromise<ListReportNumbersResponseOkResponse>;

}

/**
 * CommentsApi - object-oriented interface
 * @export
 * @class CommentsApi
 * @extends {BaseAPI}
 */
export class CommentsApi extends BaseAPI implements CommentsApiInterface {
    /**
     * Add a comment to a component.
     * @summary Add a comment to a component.
     * @param {AddCommentRequest} [addCommentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public addComment(addCommentRequest?: AddCommentRequest, options?: AxiosRequestConfig) {
        return CommentsApiFp(this.configuration).addComment(addCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a comment by id.
     * @summary Deletes a comment by id.
     * @param {number} commentId The id of the comment to be deleted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public deleteComment(commentId: number, options?: AxiosRequestConfig) {
        return CommentsApiFp(this.configuration).deleteComment(commentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a comment by id.
     * @summary Updates a comment by id.
     * @param {EditCommentRequest} [editCommentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public editComment(editCommentRequest?: EditCommentRequest, options?: AxiosRequestConfig) {
        return CommentsApiFp(this.configuration).editComment(editCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List comments by component sid.
     * @summary List comments by component sid.
     * @param {string} componentSid 
     * @param {number} componentType 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {number} [requestedOffset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public listComments(componentSid: string, componentType: number, page?: number, size?: number, requestedOffset?: number, options?: AxiosRequestConfig) {
        return CommentsApiFp(this.configuration).listComments(componentSid, componentType, page, size, requestedOffset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List report numbers by term search.
     * @summary List report numbers by term search.
     * @param {string} componentSid 
     * @param {number} componentType 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {number} [requestedOffset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public listReportNumbers(componentSid: string, componentType: number, page?: number, size?: number, requestedOffset?: number, options?: AxiosRequestConfig) {
        return CommentsApiFp(this.configuration).listReportNumbers(componentSid, componentType, page, size, requestedOffset, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ComponentStatusApi - axios parameter creator
 * @export
 */
export const ComponentStatusApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Edit next transformer report date .
         * @summary Edit next transformer  report date.
         * @param {string} componentSid 
         * @param {number} reportType 
         * @param {string} reportId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editNextReportDate: async (componentSid: string, reportType: number, reportId: string, date: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentSid' is not null or undefined
            assertParamExists('editNextReportDate', 'componentSid', componentSid)
            // verify required parameter 'reportType' is not null or undefined
            assertParamExists('editNextReportDate', 'reportType', reportType)
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('editNextReportDate', 'reportId', reportId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('editNextReportDate', 'date', date)
            const localVarPath = `/api/v1/edit-next-report/{componentSid}`
                .replace(`{${"componentSid"}}`, encodeURIComponent(String(componentSid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (reportType !== undefined) {
                localVarQueryParameter['reportType'] = reportType;
            }

            if (reportId !== undefined) {
                localVarQueryParameter['reportId'] = reportId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get condition status by component.
         * @summary Get condition status by component.
         * @param {string} componentSid 
         * @param {number} componentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConditionStatusByComponent: async (componentSid: string, componentType: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentSid' is not null or undefined
            assertParamExists('getConditionStatusByComponent', 'componentSid', componentSid)
            // verify required parameter 'componentType' is not null or undefined
            assertParamExists('getConditionStatusByComponent', 'componentType', componentType)
            const localVarPath = `/api/v1/component-status/{componentSid}`
                .replace(`{${"componentSid"}}`, encodeURIComponent(String(componentSid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (componentType !== undefined) {
                localVarQueryParameter['componentType'] = componentType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get historical trends of an analysis in a given timeframe.
         * @summary Get historical trends of an analyisis. (Auth policies: CanViewGeneratorsData)
         * @param {string} componentSid 
         * @param {number} [analysisType] 
         * @param {number} [measurementType] 
         * @param {number} [languageId] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneratorHistoricalTrends: async (componentSid: string, analysisType?: number, measurementType?: number, languageId?: number, startDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentSid' is not null or undefined
            assertParamExists('getGeneratorHistoricalTrends', 'componentSid', componentSid)
            const localVarPath = `/api/v1/component-status/generator/{componentSid}/historical-trends`
                .replace(`{${"componentSid"}}`, encodeURIComponent(String(componentSid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (analysisType !== undefined) {
                localVarQueryParameter['AnalysisType'] = analysisType;
            }

            if (measurementType !== undefined) {
                localVarQueryParameter['MeasurementType'] = measurementType;
            }

            if (languageId !== undefined) {
                localVarQueryParameter['LanguageId'] = languageId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['StartDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['EndDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get historical trends of a parameter for a transformer in a given timeframe.
         * @summary Get historical trends of a parameter. (Auth policies: CanViewTransformerData)
         * @param {string} transformerSid 
         * @param {number} [languageType] 
         * @param {boolean} [mustIncludeTemperature] 
         * @param {Array<number>} [parameterIds] 
         * @param {Array<number>} [denominatorParameterIds] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOilHistoricalTrends: async (transformerSid: string, languageType?: number, mustIncludeTemperature?: boolean, parameterIds?: Array<number>, denominatorParameterIds?: Array<number>, startDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transformerSid' is not null or undefined
            assertParamExists('getOilHistoricalTrends', 'transformerSid', transformerSid)
            const localVarPath = `/api/v1/component-status/{transformerSid}/historical-trends`
                .replace(`{${"transformerSid"}}`, encodeURIComponent(String(transformerSid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (languageType !== undefined) {
                localVarQueryParameter['LanguageType'] = languageType;
            }

            if (mustIncludeTemperature !== undefined) {
                localVarQueryParameter['MustIncludeTemperature'] = mustIncludeTemperature;
            }

            if (parameterIds) {
                localVarQueryParameter['ParameterIds'] = parameterIds;
            }

            if (denominatorParameterIds) {
                localVarQueryParameter['DenominatorParameterIds'] = denominatorParameterIds;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['StartDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['EndDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List generator analysis by sid and analysis type.
         * @summary List generator analysis by sid and analysis type. (Auth policies: CanViewGeneratorsData)
         * @param {string} componentSid 
         * @param {number} analysisType 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGeneratorAnalysisByType: async (componentSid: string, analysisType: number, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentSid' is not null or undefined
            assertParamExists('listGeneratorAnalysisByType', 'componentSid', componentSid)
            // verify required parameter 'analysisType' is not null or undefined
            assertParamExists('listGeneratorAnalysisByType', 'analysisType', analysisType)
            const localVarPath = `/api/v1/component-status/{componentSid}/generator`
                .replace(`{${"componentSid"}}`, encodeURIComponent(String(componentSid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (analysisType !== undefined) {
                localVarQueryParameter['analysisType'] = analysisType;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (requestedOffset !== undefined) {
                localVarQueryParameter['requestedOffset'] = requestedOffset;
            }

            if (term !== undefined) {
                localVarQueryParameter['Term'] = term;
            }

            if (termToLower !== undefined) {
                localVarQueryParameter['TermToLower'] = termToLower;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List oil analysis reports by transformer id and analysis type.
         * @summary List oil analysis reports by transformer id and analysis type. (Auth policies: CanViewTransformerData)
         * @param {string} transformerSid 
         * @param {number} [analysisType] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOilAnalysisReportsByTransformer: async (transformerSid: string, analysisType?: number, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transformerSid' is not null or undefined
            assertParamExists('listOilAnalysisReportsByTransformer', 'transformerSid', transformerSid)
            const localVarPath = `/api/v1/component-status/{transformerSid}/reports`
                .replace(`{${"transformerSid"}}`, encodeURIComponent(String(transformerSid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (analysisType !== undefined) {
                localVarQueryParameter['analysisType'] = analysisType;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (requestedOffset !== undefined) {
                localVarQueryParameter['requestedOffset'] = requestedOffset;
            }

            if (term !== undefined) {
                localVarQueryParameter['Term'] = term;
            }

            if (termToLower !== undefined) {
                localVarQueryParameter['TermToLower'] = termToLower;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List visual inspections by generator id.
         * @summary List visual inspections by generator sid. (Auth policies: CanViewGeneratorsData)
         * @param {string} componentSid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVisualInspectionsByGeneratorSid: async (componentSid: string, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentSid' is not null or undefined
            assertParamExists('listVisualInspectionsByGeneratorSid', 'componentSid', componentSid)
            const localVarPath = `/api/v1/component-status/{componentSid}/generator/visual-inspections`
                .replace(`{${"componentSid"}}`, encodeURIComponent(String(componentSid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (requestedOffset !== undefined) {
                localVarQueryParameter['requestedOffset'] = requestedOffset;
            }

            if (term !== undefined) {
                localVarQueryParameter['Term'] = term;
            }

            if (termToLower !== undefined) {
                localVarQueryParameter['TermToLower'] = termToLower;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List visual inspections by transformer id.
         * @summary List visual inspections by transformer id. (Auth policies: CanViewTransformerData)
         * @param {string} transformerSid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVisualInspectionsByTransformerSid: async (transformerSid: string, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transformerSid' is not null or undefined
            assertParamExists('listVisualInspectionsByTransformerSid', 'transformerSid', transformerSid)
            const localVarPath = `/api/v1/component-status/{transformerSid}/visual-inspections`
                .replace(`{${"transformerSid"}}`, encodeURIComponent(String(transformerSid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (requestedOffset !== undefined) {
                localVarQueryParameter['requestedOffset'] = requestedOffset;
            }

            if (term !== undefined) {
                localVarQueryParameter['Term'] = term;
            }

            if (termToLower !== undefined) {
                localVarQueryParameter['TermToLower'] = termToLower;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Override status of a parameter value.
         * @summary Override status of a parameter value.
         * @param {OverrideParameterStatusRequest} [overrideParameterStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overrideParameterStatusById: async (overrideParameterStatusRequest?: OverrideParameterStatusRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/component-status/override-parameter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(overrideParameterStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Override condition status of a report (e.g. Visual Inspection). Dispatches by ReportType.
         * @summary Override condition status of a report.
         * @param {OverrideReportStatusRequest} [overrideReportStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overrideReportStatus: async (overrideReportStatusRequest?: OverrideReportStatusRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/component-status/override-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(overrideReportStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComponentStatusApi - functional programming interface
 * @export
 */
export const ComponentStatusApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComponentStatusApiAxiosParamCreator(configuration)
    return {
        /**
         * Edit next transformer report date .
         * @summary Edit next transformer  report date.
         * @param {string} componentSid 
         * @param {number} reportType 
         * @param {string} reportId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editNextReportDate(componentSid: string, reportType: number, reportId: string, date: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EditNextReportDateResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editNextReportDate(componentSid, reportType, reportId, date, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ComponentStatusApi.editNextReportDate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get condition status by component.
         * @summary Get condition status by component.
         * @param {string} componentSid 
         * @param {number} componentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConditionStatusByComponent(componentSid: string, componentType: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetConditionStatusByComponentResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConditionStatusByComponent(componentSid, componentType, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ComponentStatusApi.getConditionStatusByComponent']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get historical trends of an analysis in a given timeframe.
         * @summary Get historical trends of an analyisis. (Auth policies: CanViewGeneratorsData)
         * @param {string} componentSid 
         * @param {number} [analysisType] 
         * @param {number} [measurementType] 
         * @param {number} [languageId] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGeneratorHistoricalTrends(componentSid: string, analysisType?: number, measurementType?: number, languageId?: number, startDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGeneratorHistoricalTrendsResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGeneratorHistoricalTrends(componentSid, analysisType, measurementType, languageId, startDate, endDate, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ComponentStatusApi.getGeneratorHistoricalTrends']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get historical trends of a parameter for a transformer in a given timeframe.
         * @summary Get historical trends of a parameter. (Auth policies: CanViewTransformerData)
         * @param {string} transformerSid 
         * @param {number} [languageType] 
         * @param {boolean} [mustIncludeTemperature] 
         * @param {Array<number>} [parameterIds] 
         * @param {Array<number>} [denominatorParameterIds] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOilHistoricalTrends(transformerSid: string, languageType?: number, mustIncludeTemperature?: boolean, parameterIds?: Array<number>, denominatorParameterIds?: Array<number>, startDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOilHistoricalTrendsResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOilHistoricalTrends(transformerSid, languageType, mustIncludeTemperature, parameterIds, denominatorParameterIds, startDate, endDate, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ComponentStatusApi.getOilHistoricalTrends']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List generator analysis by sid and analysis type.
         * @summary List generator analysis by sid and analysis type. (Auth policies: CanViewGeneratorsData)
         * @param {string} componentSid 
         * @param {number} analysisType 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listGeneratorAnalysisByType(componentSid: string, analysisType: number, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListGeneratorAnalysisByTypeResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGeneratorAnalysisByType(componentSid, analysisType, page, size, requestedOffset, term, termToLower, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ComponentStatusApi.listGeneratorAnalysisByType']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List oil analysis reports by transformer id and analysis type.
         * @summary List oil analysis reports by transformer id and analysis type. (Auth policies: CanViewTransformerData)
         * @param {string} transformerSid 
         * @param {number} [analysisType] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOilAnalysisReportsByTransformer(transformerSid: string, analysisType?: number, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListOilAnalysisReportsByTransformerResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOilAnalysisReportsByTransformer(transformerSid, analysisType, page, size, requestedOffset, term, termToLower, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ComponentStatusApi.listOilAnalysisReportsByTransformer']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List visual inspections by generator id.
         * @summary List visual inspections by generator sid. (Auth policies: CanViewGeneratorsData)
         * @param {string} componentSid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listVisualInspectionsByGeneratorSid(componentSid: string, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListGeneratorVisualInspectionsResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listVisualInspectionsByGeneratorSid(componentSid, page, size, requestedOffset, term, termToLower, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ComponentStatusApi.listVisualInspectionsByGeneratorSid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List visual inspections by transformer id.
         * @summary List visual inspections by transformer id. (Auth policies: CanViewTransformerData)
         * @param {string} transformerSid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listVisualInspectionsByTransformerSid(transformerSid: string, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListVisualInspectionsResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listVisualInspectionsByTransformerSid(transformerSid, page, size, requestedOffset, term, termToLower, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ComponentStatusApi.listVisualInspectionsByTransformerSid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Override status of a parameter value.
         * @summary Override status of a parameter value.
         * @param {OverrideParameterStatusRequest} [overrideParameterStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overrideParameterStatusById(overrideParameterStatusRequest?: OverrideParameterStatusRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OverrideParameterStatusResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overrideParameterStatusById(overrideParameterStatusRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ComponentStatusApi.overrideParameterStatusById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Override condition status of a report (e.g. Visual Inspection). Dispatches by ReportType.
         * @summary Override condition status of a report.
         * @param {OverrideReportStatusRequest} [overrideReportStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overrideReportStatus(overrideReportStatusRequest?: OverrideReportStatusRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OverrideReportStatusResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overrideReportStatus(overrideReportStatusRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ComponentStatusApi.overrideReportStatus']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ComponentStatusApi - factory interface
 * @export
 */
export const ComponentStatusApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComponentStatusApiFp(configuration)
    return {
        /**
         * Edit next transformer report date .
         * @summary Edit next transformer  report date.
         * @param {string} componentSid 
         * @param {number} reportType 
         * @param {string} reportId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editNextReportDate(componentSid: string, reportType: number, reportId: string, date: string, options?: any): AxiosPromise<EditNextReportDateResponseOkResponse> {
            return localVarFp.editNextReportDate(componentSid, reportType, reportId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * Get condition status by component.
         * @summary Get condition status by component.
         * @param {string} componentSid 
         * @param {number} componentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConditionStatusByComponent(componentSid: string, componentType: number, options?: any): AxiosPromise<GetConditionStatusByComponentResponseOkResponse> {
            return localVarFp.getConditionStatusByComponent(componentSid, componentType, options).then((request) => request(axios, basePath));
        },
        /**
         * Get historical trends of an analysis in a given timeframe.
         * @summary Get historical trends of an analyisis. (Auth policies: CanViewGeneratorsData)
         * @param {string} componentSid 
         * @param {number} [analysisType] 
         * @param {number} [measurementType] 
         * @param {number} [languageId] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneratorHistoricalTrends(componentSid: string, analysisType?: number, measurementType?: number, languageId?: number, startDate?: string, endDate?: string, options?: any): AxiosPromise<GetGeneratorHistoricalTrendsResponseOkResponse> {
            return localVarFp.getGeneratorHistoricalTrends(componentSid, analysisType, measurementType, languageId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Get historical trends of a parameter for a transformer in a given timeframe.
         * @summary Get historical trends of a parameter. (Auth policies: CanViewTransformerData)
         * @param {string} transformerSid 
         * @param {number} [languageType] 
         * @param {boolean} [mustIncludeTemperature] 
         * @param {Array<number>} [parameterIds] 
         * @param {Array<number>} [denominatorParameterIds] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOilHistoricalTrends(transformerSid: string, languageType?: number, mustIncludeTemperature?: boolean, parameterIds?: Array<number>, denominatorParameterIds?: Array<number>, startDate?: string, endDate?: string, options?: any): AxiosPromise<GetOilHistoricalTrendsResponseOkResponse> {
            return localVarFp.getOilHistoricalTrends(transformerSid, languageType, mustIncludeTemperature, parameterIds, denominatorParameterIds, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * List generator analysis by sid and analysis type.
         * @summary List generator analysis by sid and analysis type. (Auth policies: CanViewGeneratorsData)
         * @param {string} componentSid 
         * @param {number} analysisType 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGeneratorAnalysisByType(componentSid: string, analysisType: number, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: any): AxiosPromise<ListGeneratorAnalysisByTypeResponseOkResponse> {
            return localVarFp.listGeneratorAnalysisByType(componentSid, analysisType, page, size, requestedOffset, term, termToLower, options).then((request) => request(axios, basePath));
        },
        /**
         * List oil analysis reports by transformer id and analysis type.
         * @summary List oil analysis reports by transformer id and analysis type. (Auth policies: CanViewTransformerData)
         * @param {string} transformerSid 
         * @param {number} [analysisType] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOilAnalysisReportsByTransformer(transformerSid: string, analysisType?: number, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: any): AxiosPromise<ListOilAnalysisReportsByTransformerResponseOkResponse> {
            return localVarFp.listOilAnalysisReportsByTransformer(transformerSid, analysisType, page, size, requestedOffset, term, termToLower, options).then((request) => request(axios, basePath));
        },
        /**
         * List visual inspections by generator id.
         * @summary List visual inspections by generator sid. (Auth policies: CanViewGeneratorsData)
         * @param {string} componentSid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVisualInspectionsByGeneratorSid(componentSid: string, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: any): AxiosPromise<ListGeneratorVisualInspectionsResponseOkResponse> {
            return localVarFp.listVisualInspectionsByGeneratorSid(componentSid, page, size, requestedOffset, term, termToLower, options).then((request) => request(axios, basePath));
        },
        /**
         * List visual inspections by transformer id.
         * @summary List visual inspections by transformer id. (Auth policies: CanViewTransformerData)
         * @param {string} transformerSid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVisualInspectionsByTransformerSid(transformerSid: string, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: any): AxiosPromise<ListVisualInspectionsResponseOkResponse> {
            return localVarFp.listVisualInspectionsByTransformerSid(transformerSid, page, size, requestedOffset, term, termToLower, options).then((request) => request(axios, basePath));
        },
        /**
         * Override status of a parameter value.
         * @summary Override status of a parameter value.
         * @param {OverrideParameterStatusRequest} [overrideParameterStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overrideParameterStatusById(overrideParameterStatusRequest?: OverrideParameterStatusRequest, options?: any): AxiosPromise<OverrideParameterStatusResponseOkResponse> {
            return localVarFp.overrideParameterStatusById(overrideParameterStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Override condition status of a report (e.g. Visual Inspection). Dispatches by ReportType.
         * @summary Override condition status of a report.
         * @param {OverrideReportStatusRequest} [overrideReportStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overrideReportStatus(overrideReportStatusRequest?: OverrideReportStatusRequest, options?: any): AxiosPromise<OverrideReportStatusResponseOkResponse> {
            return localVarFp.overrideReportStatus(overrideReportStatusRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComponentStatusApi - interface
 * @export
 * @interface ComponentStatusApi
 */
export interface ComponentStatusApiInterface {
    /**
     * Edit next transformer report date .
     * @summary Edit next transformer  report date.
     * @param {string} componentSid 
     * @param {number} reportType 
     * @param {string} reportId 
     * @param {string} date 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentStatusApiInterface
     */
    editNextReportDate(componentSid: string, reportType: number, reportId: string, date: string, options?: AxiosRequestConfig): AxiosPromise<EditNextReportDateResponseOkResponse>;

    /**
     * Get condition status by component.
     * @summary Get condition status by component.
     * @param {string} componentSid 
     * @param {number} componentType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentStatusApiInterface
     */
    getConditionStatusByComponent(componentSid: string, componentType: number, options?: AxiosRequestConfig): AxiosPromise<GetConditionStatusByComponentResponseOkResponse>;

    /**
     * Get historical trends of an analysis in a given timeframe.
     * @summary Get historical trends of an analyisis. (Auth policies: CanViewGeneratorsData)
     * @param {string} componentSid 
     * @param {number} [analysisType] 
     * @param {number} [measurementType] 
     * @param {number} [languageId] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentStatusApiInterface
     */
    getGeneratorHistoricalTrends(componentSid: string, analysisType?: number, measurementType?: number, languageId?: number, startDate?: string, endDate?: string, options?: AxiosRequestConfig): AxiosPromise<GetGeneratorHistoricalTrendsResponseOkResponse>;

    /**
     * Get historical trends of a parameter for a transformer in a given timeframe.
     * @summary Get historical trends of a parameter. (Auth policies: CanViewTransformerData)
     * @param {string} transformerSid 
     * @param {number} [languageType] 
     * @param {boolean} [mustIncludeTemperature] 
     * @param {Array<number>} [parameterIds] 
     * @param {Array<number>} [denominatorParameterIds] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentStatusApiInterface
     */
    getOilHistoricalTrends(transformerSid: string, languageType?: number, mustIncludeTemperature?: boolean, parameterIds?: Array<number>, denominatorParameterIds?: Array<number>, startDate?: string, endDate?: string, options?: AxiosRequestConfig): AxiosPromise<GetOilHistoricalTrendsResponseOkResponse>;

    /**
     * List generator analysis by sid and analysis type.
     * @summary List generator analysis by sid and analysis type. (Auth policies: CanViewGeneratorsData)
     * @param {string} componentSid 
     * @param {number} analysisType 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {number} [requestedOffset] 
     * @param {string} [term] 
     * @param {string} [termToLower] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentStatusApiInterface
     */
    listGeneratorAnalysisByType(componentSid: string, analysisType: number, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig): AxiosPromise<ListGeneratorAnalysisByTypeResponseOkResponse>;

    /**
     * List oil analysis reports by transformer id and analysis type.
     * @summary List oil analysis reports by transformer id and analysis type. (Auth policies: CanViewTransformerData)
     * @param {string} transformerSid 
     * @param {number} [analysisType] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {number} [requestedOffset] 
     * @param {string} [term] 
     * @param {string} [termToLower] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentStatusApiInterface
     */
    listOilAnalysisReportsByTransformer(transformerSid: string, analysisType?: number, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig): AxiosPromise<ListOilAnalysisReportsByTransformerResponseOkResponse>;

    /**
     * List visual inspections by generator id.
     * @summary List visual inspections by generator sid. (Auth policies: CanViewGeneratorsData)
     * @param {string} componentSid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {number} [requestedOffset] 
     * @param {string} [term] 
     * @param {string} [termToLower] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentStatusApiInterface
     */
    listVisualInspectionsByGeneratorSid(componentSid: string, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig): AxiosPromise<ListGeneratorVisualInspectionsResponseOkResponse>;

    /**
     * List visual inspections by transformer id.
     * @summary List visual inspections by transformer id. (Auth policies: CanViewTransformerData)
     * @param {string} transformerSid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {number} [requestedOffset] 
     * @param {string} [term] 
     * @param {string} [termToLower] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentStatusApiInterface
     */
    listVisualInspectionsByTransformerSid(transformerSid: string, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig): AxiosPromise<ListVisualInspectionsResponseOkResponse>;

    /**
     * Override status of a parameter value.
     * @summary Override status of a parameter value.
     * @param {OverrideParameterStatusRequest} [overrideParameterStatusRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentStatusApiInterface
     */
    overrideParameterStatusById(overrideParameterStatusRequest?: OverrideParameterStatusRequest, options?: AxiosRequestConfig): AxiosPromise<OverrideParameterStatusResponseOkResponse>;

    /**
     * Override condition status of a report (e.g. Visual Inspection). Dispatches by ReportType.
     * @summary Override condition status of a report.
     * @param {OverrideReportStatusRequest} [overrideReportStatusRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentStatusApiInterface
     */
    overrideReportStatus(overrideReportStatusRequest?: OverrideReportStatusRequest, options?: AxiosRequestConfig): AxiosPromise<OverrideReportStatusResponseOkResponse>;

}

/**
 * ComponentStatusApi - object-oriented interface
 * @export
 * @class ComponentStatusApi
 * @extends {BaseAPI}
 */
export class ComponentStatusApi extends BaseAPI implements ComponentStatusApiInterface {
    /**
     * Edit next transformer report date .
     * @summary Edit next transformer  report date.
     * @param {string} componentSid 
     * @param {number} reportType 
     * @param {string} reportId 
     * @param {string} date 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentStatusApi
     */
    public editNextReportDate(componentSid: string, reportType: number, reportId: string, date: string, options?: AxiosRequestConfig) {
        return ComponentStatusApiFp(this.configuration).editNextReportDate(componentSid, reportType, reportId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get condition status by component.
     * @summary Get condition status by component.
     * @param {string} componentSid 
     * @param {number} componentType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentStatusApi
     */
    public getConditionStatusByComponent(componentSid: string, componentType: number, options?: AxiosRequestConfig) {
        return ComponentStatusApiFp(this.configuration).getConditionStatusByComponent(componentSid, componentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get historical trends of an analysis in a given timeframe.
     * @summary Get historical trends of an analyisis. (Auth policies: CanViewGeneratorsData)
     * @param {string} componentSid 
     * @param {number} [analysisType] 
     * @param {number} [measurementType] 
     * @param {number} [languageId] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentStatusApi
     */
    public getGeneratorHistoricalTrends(componentSid: string, analysisType?: number, measurementType?: number, languageId?: number, startDate?: string, endDate?: string, options?: AxiosRequestConfig) {
        return ComponentStatusApiFp(this.configuration).getGeneratorHistoricalTrends(componentSid, analysisType, measurementType, languageId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get historical trends of a parameter for a transformer in a given timeframe.
     * @summary Get historical trends of a parameter. (Auth policies: CanViewTransformerData)
     * @param {string} transformerSid 
     * @param {number} [languageType] 
     * @param {boolean} [mustIncludeTemperature] 
     * @param {Array<number>} [parameterIds] 
     * @param {Array<number>} [denominatorParameterIds] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentStatusApi
     */
    public getOilHistoricalTrends(transformerSid: string, languageType?: number, mustIncludeTemperature?: boolean, parameterIds?: Array<number>, denominatorParameterIds?: Array<number>, startDate?: string, endDate?: string, options?: AxiosRequestConfig) {
        return ComponentStatusApiFp(this.configuration).getOilHistoricalTrends(transformerSid, languageType, mustIncludeTemperature, parameterIds, denominatorParameterIds, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List generator analysis by sid and analysis type.
     * @summary List generator analysis by sid and analysis type. (Auth policies: CanViewGeneratorsData)
     * @param {string} componentSid 
     * @param {number} analysisType 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {number} [requestedOffset] 
     * @param {string} [term] 
     * @param {string} [termToLower] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentStatusApi
     */
    public listGeneratorAnalysisByType(componentSid: string, analysisType: number, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig) {
        return ComponentStatusApiFp(this.configuration).listGeneratorAnalysisByType(componentSid, analysisType, page, size, requestedOffset, term, termToLower, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List oil analysis reports by transformer id and analysis type.
     * @summary List oil analysis reports by transformer id and analysis type. (Auth policies: CanViewTransformerData)
     * @param {string} transformerSid 
     * @param {number} [analysisType] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {number} [requestedOffset] 
     * @param {string} [term] 
     * @param {string} [termToLower] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentStatusApi
     */
    public listOilAnalysisReportsByTransformer(transformerSid: string, analysisType?: number, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig) {
        return ComponentStatusApiFp(this.configuration).listOilAnalysisReportsByTransformer(transformerSid, analysisType, page, size, requestedOffset, term, termToLower, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List visual inspections by generator id.
     * @summary List visual inspections by generator sid. (Auth policies: CanViewGeneratorsData)
     * @param {string} componentSid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {number} [requestedOffset] 
     * @param {string} [term] 
     * @param {string} [termToLower] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentStatusApi
     */
    public listVisualInspectionsByGeneratorSid(componentSid: string, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig) {
        return ComponentStatusApiFp(this.configuration).listVisualInspectionsByGeneratorSid(componentSid, page, size, requestedOffset, term, termToLower, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List visual inspections by transformer id.
     * @summary List visual inspections by transformer id. (Auth policies: CanViewTransformerData)
     * @param {string} transformerSid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {number} [requestedOffset] 
     * @param {string} [term] 
     * @param {string} [termToLower] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentStatusApi
     */
    public listVisualInspectionsByTransformerSid(transformerSid: string, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig) {
        return ComponentStatusApiFp(this.configuration).listVisualInspectionsByTransformerSid(transformerSid, page, size, requestedOffset, term, termToLower, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Override status of a parameter value.
     * @summary Override status of a parameter value.
     * @param {OverrideParameterStatusRequest} [overrideParameterStatusRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentStatusApi
     */
    public overrideParameterStatusById(overrideParameterStatusRequest?: OverrideParameterStatusRequest, options?: AxiosRequestConfig) {
        return ComponentStatusApiFp(this.configuration).overrideParameterStatusById(overrideParameterStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Override condition status of a report (e.g. Visual Inspection). Dispatches by ReportType.
     * @summary Override condition status of a report.
     * @param {OverrideReportStatusRequest} [overrideReportStatusRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentStatusApi
     */
    public overrideReportStatus(overrideReportStatusRequest?: OverrideReportStatusRequest, options?: AxiosRequestConfig) {
        return ComponentStatusApiFp(this.configuration).overrideReportStatus(overrideReportStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DashboardApi - axios parameter creator
 * @export
 */
export const DashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List portfolio events.
         * @summary List portfolio events.
         * @param {number} componentType 
         * @param {Array<number>} [plantSids] 
         * @param {Array<number>} [plantGroupSids] 
         * @param {Array<number>} [notificationTypes] 
         * @param {number} [pastDays] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvents: async (componentType: number, plantSids?: Array<number>, plantGroupSids?: Array<number>, notificationTypes?: Array<number>, pastDays?: number, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentType' is not null or undefined
            assertParamExists('listEvents', 'componentType', componentType)
            const localVarPath = `/api/v1/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (componentType !== undefined) {
                localVarQueryParameter['ComponentType'] = componentType;
            }

            if (plantSids) {
                localVarQueryParameter['PlantSids'] = plantSids;
            }

            if (plantGroupSids) {
                localVarQueryParameter['PlantGroupSids'] = plantGroupSids;
            }

            if (notificationTypes) {
                localVarQueryParameter['NotificationTypes'] = notificationTypes;
            }

            if (pastDays !== undefined) {
                localVarQueryParameter['PastDays'] = pastDays;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (requestedOffset !== undefined) {
                localVarQueryParameter['requestedOffset'] = requestedOffset;
            }

            if (term !== undefined) {
                localVarQueryParameter['Term'] = term;
            }

            if (termToLower !== undefined) {
                localVarQueryParameter['TermToLower'] = termToLower;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardApi - functional programming interface
 * @export
 */
export const DashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * List portfolio events.
         * @summary List portfolio events.
         * @param {number} componentType 
         * @param {Array<number>} [plantSids] 
         * @param {Array<number>} [plantGroupSids] 
         * @param {Array<number>} [notificationTypes] 
         * @param {number} [pastDays] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEvents(componentType: number, plantSids?: Array<number>, plantGroupSids?: Array<number>, notificationTypes?: Array<number>, pastDays?: number, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPortfolioEventsResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEvents(componentType, plantSids, plantGroupSids, notificationTypes, pastDays, page, size, requestedOffset, term, termToLower, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DashboardApi.listEvents']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * DashboardApi - factory interface
 * @export
 */
export const DashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardApiFp(configuration)
    return {
        /**
         * List portfolio events.
         * @summary List portfolio events.
         * @param {number} componentType 
         * @param {Array<number>} [plantSids] 
         * @param {Array<number>} [plantGroupSids] 
         * @param {Array<number>} [notificationTypes] 
         * @param {number} [pastDays] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvents(componentType: number, plantSids?: Array<number>, plantGroupSids?: Array<number>, notificationTypes?: Array<number>, pastDays?: number, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: any): AxiosPromise<ListPortfolioEventsResponseOkResponse> {
            return localVarFp.listEvents(componentType, plantSids, plantGroupSids, notificationTypes, pastDays, page, size, requestedOffset, term, termToLower, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardApi - interface
 * @export
 * @interface DashboardApi
 */
export interface DashboardApiInterface {
    /**
     * List portfolio events.
     * @summary List portfolio events.
     * @param {number} componentType 
     * @param {Array<number>} [plantSids] 
     * @param {Array<number>} [plantGroupSids] 
     * @param {Array<number>} [notificationTypes] 
     * @param {number} [pastDays] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {number} [requestedOffset] 
     * @param {string} [term] 
     * @param {string} [termToLower] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApiInterface
     */
    listEvents(componentType: number, plantSids?: Array<number>, plantGroupSids?: Array<number>, notificationTypes?: Array<number>, pastDays?: number, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig): AxiosPromise<ListPortfolioEventsResponseOkResponse>;

}

/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
export class DashboardApi extends BaseAPI implements DashboardApiInterface {
    /**
     * List portfolio events.
     * @summary List portfolio events.
     * @param {number} componentType 
     * @param {Array<number>} [plantSids] 
     * @param {Array<number>} [plantGroupSids] 
     * @param {Array<number>} [notificationTypes] 
     * @param {number} [pastDays] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {number} [requestedOffset] 
     * @param {string} [term] 
     * @param {string} [termToLower] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public listEvents(componentType: number, plantSids?: Array<number>, plantGroupSids?: Array<number>, notificationTypes?: Array<number>, pastDays?: number, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).listEvents(componentType, plantSids, plantGroupSids, notificationTypes, pastDays, page, size, requestedOffset, term, termToLower, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DataImportApi - axios parameter creator
 * @export
 */
export const DataImportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets the data from snowflake and imports it in the sql database.
         * @summary Gets the data from snowflake and imports it in the sql database. (Auth)
         * @param {Array<string>} [componentSids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncData: async (componentSids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/data-sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (componentSids) {
                localVarQueryParameter['ComponentSids'] = componentSids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataImportApi - functional programming interface
 * @export
 */
export const DataImportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataImportApiAxiosParamCreator(configuration)
    return {
        /**
         * Gets the data from snowflake and imports it in the sql database.
         * @summary Gets the data from snowflake and imports it in the sql database. (Auth)
         * @param {Array<string>} [componentSids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncData(componentSids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncDataResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncData(componentSids, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DataImportApi.syncData']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * DataImportApi - factory interface
 * @export
 */
export const DataImportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataImportApiFp(configuration)
    return {
        /**
         * Gets the data from snowflake and imports it in the sql database.
         * @summary Gets the data from snowflake and imports it in the sql database. (Auth)
         * @param {Array<string>} [componentSids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncData(componentSids?: Array<string>, options?: any): AxiosPromise<SyncDataResponseOkResponse> {
            return localVarFp.syncData(componentSids, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataImportApi - interface
 * @export
 * @interface DataImportApi
 */
export interface DataImportApiInterface {
    /**
     * Gets the data from snowflake and imports it in the sql database.
     * @summary Gets the data from snowflake and imports it in the sql database. (Auth)
     * @param {Array<string>} [componentSids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataImportApiInterface
     */
    syncData(componentSids?: Array<string>, options?: AxiosRequestConfig): AxiosPromise<SyncDataResponseOkResponse>;

}

/**
 * DataImportApi - object-oriented interface
 * @export
 * @class DataImportApi
 * @extends {BaseAPI}
 */
export class DataImportApi extends BaseAPI implements DataImportApiInterface {
    /**
     * Gets the data from snowflake and imports it in the sql database.
     * @summary Gets the data from snowflake and imports it in the sql database. (Auth)
     * @param {Array<string>} [componentSids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataImportApi
     */
    public syncData(componentSids?: Array<string>, options?: AxiosRequestConfig) {
        return DataImportApiFp(this.configuration).syncData(componentSids, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GeneralApi - axios parameter creator
 * @export
 */
export const GeneralApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add component as no action.
         * @summary Add component as no action. (Auth)
         * @param {string} componentSid 
         * @param {NoActionComponentDto} [noActionComponentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNoAction: async (componentSid: string, noActionComponentDto?: NoActionComponentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentSid' is not null or undefined
            assertParamExists('addNoAction', 'componentSid', componentSid)
            const localVarPath = `/api/v1/no-action/{componentSid}`
                .replace(`{${"componentSid"}}`, encodeURIComponent(String(componentSid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(noActionComponentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete component as no action.
         * @summary Delete component as no action. (Auth)
         * @param {string} componentSid 
         * @param {NoActionComponentDto} [noActionComponentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNoAction: async (componentSid: string, noActionComponentDto?: NoActionComponentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentSid' is not null or undefined
            assertParamExists('deleteNoAction', 'componentSid', componentSid)
            const localVarPath = `/api/v1/no-action/{componentSid}`
                .replace(`{${"componentSid"}}`, encodeURIComponent(String(componentSid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(noActionComponentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get constants.
         * @summary Get constants. (Auth)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConstants: async (request?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/constants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (request !== undefined) {
                for (const [key, value] of Object.entries(request)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeneralApi - functional programming interface
 * @export
 */
export const GeneralApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeneralApiAxiosParamCreator(configuration)
    return {
        /**
         * Add component as no action.
         * @summary Add component as no action. (Auth)
         * @param {string} componentSid 
         * @param {NoActionComponentDto} [noActionComponentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addNoAction(componentSid: string, noActionComponentDto?: NoActionComponentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddNoActionResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addNoAction(componentSid, noActionComponentDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GeneralApi.addNoAction']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Delete component as no action.
         * @summary Delete component as no action. (Auth)
         * @param {string} componentSid 
         * @param {NoActionComponentDto} [noActionComponentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNoAction(componentSid: string, noActionComponentDto?: NoActionComponentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteNoActionResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNoAction(componentSid, noActionComponentDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GeneralApi.deleteNoAction']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get constants.
         * @summary Get constants. (Auth)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConstants(request?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetConstantsResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConstants(request, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GeneralApi.getConstants']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * GeneralApi - factory interface
 * @export
 */
export const GeneralApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeneralApiFp(configuration)
    return {
        /**
         * Add component as no action.
         * @summary Add component as no action. (Auth)
         * @param {string} componentSid 
         * @param {NoActionComponentDto} [noActionComponentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNoAction(componentSid: string, noActionComponentDto?: NoActionComponentDto, options?: any): AxiosPromise<AddNoActionResponseOkResponse> {
            return localVarFp.addNoAction(componentSid, noActionComponentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete component as no action.
         * @summary Delete component as no action. (Auth)
         * @param {string} componentSid 
         * @param {NoActionComponentDto} [noActionComponentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNoAction(componentSid: string, noActionComponentDto?: NoActionComponentDto, options?: any): AxiosPromise<DeleteNoActionResponseOkResponse> {
            return localVarFp.deleteNoAction(componentSid, noActionComponentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Get constants.
         * @summary Get constants. (Auth)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConstants(request?: object, options?: any): AxiosPromise<GetConstantsResponseOkResponse> {
            return localVarFp.getConstants(request, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GeneralApi - interface
 * @export
 * @interface GeneralApi
 */
export interface GeneralApiInterface {
    /**
     * Add component as no action.
     * @summary Add component as no action. (Auth)
     * @param {string} componentSid 
     * @param {NoActionComponentDto} [noActionComponentDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralApiInterface
     */
    addNoAction(componentSid: string, noActionComponentDto?: NoActionComponentDto, options?: AxiosRequestConfig): AxiosPromise<AddNoActionResponseOkResponse>;

    /**
     * Delete component as no action.
     * @summary Delete component as no action. (Auth)
     * @param {string} componentSid 
     * @param {NoActionComponentDto} [noActionComponentDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralApiInterface
     */
    deleteNoAction(componentSid: string, noActionComponentDto?: NoActionComponentDto, options?: AxiosRequestConfig): AxiosPromise<DeleteNoActionResponseOkResponse>;

    /**
     * Get constants.
     * @summary Get constants. (Auth)
     * @param {object} [request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralApiInterface
     */
    getConstants(request?: object, options?: AxiosRequestConfig): AxiosPromise<GetConstantsResponseOkResponse>;

}

/**
 * GeneralApi - object-oriented interface
 * @export
 * @class GeneralApi
 * @extends {BaseAPI}
 */
export class GeneralApi extends BaseAPI implements GeneralApiInterface {
    /**
     * Add component as no action.
     * @summary Add component as no action. (Auth)
     * @param {string} componentSid 
     * @param {NoActionComponentDto} [noActionComponentDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralApi
     */
    public addNoAction(componentSid: string, noActionComponentDto?: NoActionComponentDto, options?: AxiosRequestConfig) {
        return GeneralApiFp(this.configuration).addNoAction(componentSid, noActionComponentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete component as no action.
     * @summary Delete component as no action. (Auth)
     * @param {string} componentSid 
     * @param {NoActionComponentDto} [noActionComponentDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralApi
     */
    public deleteNoAction(componentSid: string, noActionComponentDto?: NoActionComponentDto, options?: AxiosRequestConfig) {
        return GeneralApiFp(this.configuration).deleteNoAction(componentSid, noActionComponentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get constants.
     * @summary Get constants. (Auth)
     * @param {object} [request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralApi
     */
    public getConstants(request?: object, options?: AxiosRequestConfig) {
        return GeneralApiFp(this.configuration).getConstants(request, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GeneralCommentsApi - axios parameter creator
 * @export
 */
export const GeneralCommentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a general comment to a component.
         * @summary Add a general comment to a component.
         * @param {File} [file] 
         * @param {string} [generalCommentText] 
         * @param {string} [generalCommentComponentSid] 
         * @param {number} [generalCommentComponentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGeneralComments: async (file?: File, generalCommentText?: string, generalCommentComponentSid?: string, generalCommentComponentType?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/general-comments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
    
            if (generalCommentText !== undefined) { 
                localVarFormParams.append('GeneralComment.Text', generalCommentText as any);
            }
    
            if (generalCommentComponentSid !== undefined) { 
                localVarFormParams.append('GeneralComment.ComponentSid', generalCommentComponentSid as any);
            }
    
            if (generalCommentComponentType !== undefined) { 
                localVarFormParams.append('GeneralComment.ComponentType', generalCommentComponentType as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates file share folder.
         * @summary Creates file share folder. (Auth policies: CanEditTransformerRecommendations)
         * @param {string} [folderName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolder: async (folderName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/general-comments/create-folder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (folderName !== undefined) { 
                localVarFormParams.append('FolderName', folderName as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a general comment by id.
         * @summary Deletes a general comment by id. (Auth)
         * @param {number} generalCommentId The id of the general comment to be deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGeneralComment: async (generalCommentId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generalCommentId' is not null or undefined
            assertParamExists('deleteGeneralComment', 'generalCommentId', generalCommentId)
            const localVarPath = `/api/v1/general-comments/{generalCommentId}`
                .replace(`{${"generalCommentId"}}`, encodeURIComponent(String(generalCommentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a general comment file by id.
         * @summary Deletes a general comment file by id. (Auth policies: CanEditTransformerComments)
         * @param {number} [fileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGeneralCommentFile: async (fileId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/general-comments/file/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (fileId !== undefined) {
                localVarQueryParameter['FileId'] = fileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Downloads general comment file.
         * @summary Downloads general comment file.
         * @param {number} [fileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadGeneralCommentFile: async (fileId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/general-comments/file/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (fileId !== undefined) {
                localVarQueryParameter['FileId'] = fileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates general comment by id.
         * @summary Updates general comment by id. (Auth)
         * @param {number} [generalCommentId] 
         * @param {string} [text] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editGeneralComments: async (generalCommentId?: number, text?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/general-comments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (generalCommentId !== undefined) {
                localVarQueryParameter['GeneralCommentId'] = generalCommentId;
            }

            if (text !== undefined) {
                localVarQueryParameter['Text'] = text;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get general comments by componentSid.
         * @summary Get general comments by componentSid. (Auth)
         * @param {string} [componentSid] 
         * @param {number} [componentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneralComments: async (componentSid?: string, componentType?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/general-comments/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (componentSid !== undefined) {
                localVarQueryParameter['ComponentSid'] = componentSid;
            }

            if (componentType !== undefined) {
                localVarQueryParameter['ComponentType'] = componentType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a general comment attachment.
         * @summary Add a general comment attachment. (Auth policies: CanEditTransformerRecommendations)
         * @param {File} [file] 
         * @param {number} [generalCommentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadGeneralCommentFile: async (file?: File, generalCommentId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/general-comments/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
    
            if (generalCommentId !== undefined) { 
                localVarFormParams.append('GeneralCommentId', generalCommentId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeneralCommentsApi - functional programming interface
 * @export
 */
export const GeneralCommentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeneralCommentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a general comment to a component.
         * @summary Add a general comment to a component.
         * @param {File} [file] 
         * @param {string} [generalCommentText] 
         * @param {string} [generalCommentComponentSid] 
         * @param {number} [generalCommentComponentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addGeneralComments(file?: File, generalCommentText?: string, generalCommentComponentSid?: string, generalCommentComponentType?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddGeneralCommentResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addGeneralComments(file, generalCommentText, generalCommentComponentSid, generalCommentComponentType, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GeneralCommentsApi.addGeneralComments']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Creates file share folder.
         * @summary Creates file share folder. (Auth policies: CanEditTransformerRecommendations)
         * @param {string} [folderName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFolder(folderName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateFolderResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFolder(folderName, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GeneralCommentsApi.createFolder']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Deletes a general comment by id.
         * @summary Deletes a general comment by id. (Auth)
         * @param {number} generalCommentId The id of the general comment to be deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGeneralComment(generalCommentId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteGeneralCommentResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGeneralComment(generalCommentId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GeneralCommentsApi.deleteGeneralComment']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Deletes a general comment file by id.
         * @summary Deletes a general comment file by id. (Auth policies: CanEditTransformerComments)
         * @param {number} [fileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGeneralCommentFile(fileId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteFileResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGeneralCommentFile(fileId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GeneralCommentsApi.deleteGeneralCommentFile']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Downloads general comment file.
         * @summary Downloads general comment file.
         * @param {number} [fileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadGeneralCommentFile(fileId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadGeneralCommentFile(fileId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GeneralCommentsApi.downloadGeneralCommentFile']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Updates general comment by id.
         * @summary Updates general comment by id. (Auth)
         * @param {number} [generalCommentId] 
         * @param {string} [text] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editGeneralComments(generalCommentId?: number, text?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EditGeneralCommentResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editGeneralComments(generalCommentId, text, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GeneralCommentsApi.editGeneralComments']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get general comments by componentSid.
         * @summary Get general comments by componentSid. (Auth)
         * @param {string} [componentSid] 
         * @param {number} [componentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGeneralComments(componentSid?: string, componentType?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGeneralCommentsResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGeneralComments(componentSid, componentType, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GeneralCommentsApi.getGeneralComments']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Add a general comment attachment.
         * @summary Add a general comment attachment. (Auth policies: CanEditTransformerRecommendations)
         * @param {File} [file] 
         * @param {number} [generalCommentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadGeneralCommentFile(file?: File, generalCommentId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadFileResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadGeneralCommentFile(file, generalCommentId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GeneralCommentsApi.uploadGeneralCommentFile']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * GeneralCommentsApi - factory interface
 * @export
 */
export const GeneralCommentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeneralCommentsApiFp(configuration)
    return {
        /**
         * Add a general comment to a component.
         * @summary Add a general comment to a component.
         * @param {File} [file] 
         * @param {string} [generalCommentText] 
         * @param {string} [generalCommentComponentSid] 
         * @param {number} [generalCommentComponentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGeneralComments(file?: File, generalCommentText?: string, generalCommentComponentSid?: string, generalCommentComponentType?: number, options?: any): AxiosPromise<AddGeneralCommentResponseOkResponse> {
            return localVarFp.addGeneralComments(file, generalCommentText, generalCommentComponentSid, generalCommentComponentType, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates file share folder.
         * @summary Creates file share folder. (Auth policies: CanEditTransformerRecommendations)
         * @param {string} [folderName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolder(folderName?: string, options?: any): AxiosPromise<CreateFolderResponseOkResponse> {
            return localVarFp.createFolder(folderName, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a general comment by id.
         * @summary Deletes a general comment by id. (Auth)
         * @param {number} generalCommentId The id of the general comment to be deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGeneralComment(generalCommentId: number, options?: any): AxiosPromise<DeleteGeneralCommentResponseOkResponse> {
            return localVarFp.deleteGeneralComment(generalCommentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a general comment file by id.
         * @summary Deletes a general comment file by id. (Auth policies: CanEditTransformerComments)
         * @param {number} [fileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGeneralCommentFile(fileId?: number, options?: any): AxiosPromise<DeleteFileResponseOkResponse> {
            return localVarFp.deleteGeneralCommentFile(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Downloads general comment file.
         * @summary Downloads general comment file.
         * @param {number} [fileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadGeneralCommentFile(fileId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.downloadGeneralCommentFile(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates general comment by id.
         * @summary Updates general comment by id. (Auth)
         * @param {number} [generalCommentId] 
         * @param {string} [text] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editGeneralComments(generalCommentId?: number, text?: string, options?: any): AxiosPromise<EditGeneralCommentResponseOkResponse> {
            return localVarFp.editGeneralComments(generalCommentId, text, options).then((request) => request(axios, basePath));
        },
        /**
         * Get general comments by componentSid.
         * @summary Get general comments by componentSid. (Auth)
         * @param {string} [componentSid] 
         * @param {number} [componentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneralComments(componentSid?: string, componentType?: number, options?: any): AxiosPromise<GetGeneralCommentsResponseOkResponse> {
            return localVarFp.getGeneralComments(componentSid, componentType, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a general comment attachment.
         * @summary Add a general comment attachment. (Auth policies: CanEditTransformerRecommendations)
         * @param {File} [file] 
         * @param {number} [generalCommentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadGeneralCommentFile(file?: File, generalCommentId?: number, options?: any): AxiosPromise<UploadFileResponseOkResponse> {
            return localVarFp.uploadGeneralCommentFile(file, generalCommentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GeneralCommentsApi - interface
 * @export
 * @interface GeneralCommentsApi
 */
export interface GeneralCommentsApiInterface {
    /**
     * Add a general comment to a component.
     * @summary Add a general comment to a component.
     * @param {File} [file] 
     * @param {string} [generalCommentText] 
     * @param {string} [generalCommentComponentSid] 
     * @param {number} [generalCommentComponentType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralCommentsApiInterface
     */
    addGeneralComments(file?: File, generalCommentText?: string, generalCommentComponentSid?: string, generalCommentComponentType?: number, options?: AxiosRequestConfig): AxiosPromise<AddGeneralCommentResponseOkResponse>;

    /**
     * Creates file share folder.
     * @summary Creates file share folder. (Auth policies: CanEditTransformerRecommendations)
     * @param {string} [folderName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralCommentsApiInterface
     */
    createFolder(folderName?: string, options?: AxiosRequestConfig): AxiosPromise<CreateFolderResponseOkResponse>;

    /**
     * Deletes a general comment by id.
     * @summary Deletes a general comment by id. (Auth)
     * @param {number} generalCommentId The id of the general comment to be deleted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralCommentsApiInterface
     */
    deleteGeneralComment(generalCommentId: number, options?: AxiosRequestConfig): AxiosPromise<DeleteGeneralCommentResponseOkResponse>;

    /**
     * Deletes a general comment file by id.
     * @summary Deletes a general comment file by id. (Auth policies: CanEditTransformerComments)
     * @param {number} [fileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralCommentsApiInterface
     */
    deleteGeneralCommentFile(fileId?: number, options?: AxiosRequestConfig): AxiosPromise<DeleteFileResponseOkResponse>;

    /**
     * Downloads general comment file.
     * @summary Downloads general comment file.
     * @param {number} [fileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralCommentsApiInterface
     */
    downloadGeneralCommentFile(fileId?: number, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * Updates general comment by id.
     * @summary Updates general comment by id. (Auth)
     * @param {number} [generalCommentId] 
     * @param {string} [text] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralCommentsApiInterface
     */
    editGeneralComments(generalCommentId?: number, text?: string, options?: AxiosRequestConfig): AxiosPromise<EditGeneralCommentResponseOkResponse>;

    /**
     * Get general comments by componentSid.
     * @summary Get general comments by componentSid. (Auth)
     * @param {string} [componentSid] 
     * @param {number} [componentType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralCommentsApiInterface
     */
    getGeneralComments(componentSid?: string, componentType?: number, options?: AxiosRequestConfig): AxiosPromise<GetGeneralCommentsResponseOkResponse>;

    /**
     * Add a general comment attachment.
     * @summary Add a general comment attachment. (Auth policies: CanEditTransformerRecommendations)
     * @param {File} [file] 
     * @param {number} [generalCommentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralCommentsApiInterface
     */
    uploadGeneralCommentFile(file?: File, generalCommentId?: number, options?: AxiosRequestConfig): AxiosPromise<UploadFileResponseOkResponse>;

}

/**
 * GeneralCommentsApi - object-oriented interface
 * @export
 * @class GeneralCommentsApi
 * @extends {BaseAPI}
 */
export class GeneralCommentsApi extends BaseAPI implements GeneralCommentsApiInterface {
    /**
     * Add a general comment to a component.
     * @summary Add a general comment to a component.
     * @param {File} [file] 
     * @param {string} [generalCommentText] 
     * @param {string} [generalCommentComponentSid] 
     * @param {number} [generalCommentComponentType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralCommentsApi
     */
    public addGeneralComments(file?: File, generalCommentText?: string, generalCommentComponentSid?: string, generalCommentComponentType?: number, options?: AxiosRequestConfig) {
        return GeneralCommentsApiFp(this.configuration).addGeneralComments(file, generalCommentText, generalCommentComponentSid, generalCommentComponentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates file share folder.
     * @summary Creates file share folder. (Auth policies: CanEditTransformerRecommendations)
     * @param {string} [folderName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralCommentsApi
     */
    public createFolder(folderName?: string, options?: AxiosRequestConfig) {
        return GeneralCommentsApiFp(this.configuration).createFolder(folderName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a general comment by id.
     * @summary Deletes a general comment by id. (Auth)
     * @param {number} generalCommentId The id of the general comment to be deleted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralCommentsApi
     */
    public deleteGeneralComment(generalCommentId: number, options?: AxiosRequestConfig) {
        return GeneralCommentsApiFp(this.configuration).deleteGeneralComment(generalCommentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a general comment file by id.
     * @summary Deletes a general comment file by id. (Auth policies: CanEditTransformerComments)
     * @param {number} [fileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralCommentsApi
     */
    public deleteGeneralCommentFile(fileId?: number, options?: AxiosRequestConfig) {
        return GeneralCommentsApiFp(this.configuration).deleteGeneralCommentFile(fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Downloads general comment file.
     * @summary Downloads general comment file.
     * @param {number} [fileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralCommentsApi
     */
    public downloadGeneralCommentFile(fileId?: number, options?: AxiosRequestConfig) {
        return GeneralCommentsApiFp(this.configuration).downloadGeneralCommentFile(fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates general comment by id.
     * @summary Updates general comment by id. (Auth)
     * @param {number} [generalCommentId] 
     * @param {string} [text] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralCommentsApi
     */
    public editGeneralComments(generalCommentId?: number, text?: string, options?: AxiosRequestConfig) {
        return GeneralCommentsApiFp(this.configuration).editGeneralComments(generalCommentId, text, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get general comments by componentSid.
     * @summary Get general comments by componentSid. (Auth)
     * @param {string} [componentSid] 
     * @param {number} [componentType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralCommentsApi
     */
    public getGeneralComments(componentSid?: string, componentType?: number, options?: AxiosRequestConfig) {
        return GeneralCommentsApiFp(this.configuration).getGeneralComments(componentSid, componentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a general comment attachment.
     * @summary Add a general comment attachment. (Auth policies: CanEditTransformerRecommendations)
     * @param {File} [file] 
     * @param {number} [generalCommentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralCommentsApi
     */
    public uploadGeneralCommentFile(file?: File, generalCommentId?: number, options?: AxiosRequestConfig) {
        return GeneralCommentsApiFp(this.configuration).uploadGeneralCommentFile(file, generalCommentId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HistoricalDataApi - axios parameter creator
 * @export
 */
export const HistoricalDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get home index
         * @summary Get home index (Auth policies: CanEditThresholdsAndRecommendations)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merge: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/historical-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HistoricalDataApi - functional programming interface
 * @export
 */
export const HistoricalDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HistoricalDataApiAxiosParamCreator(configuration)
    return {
        /**
         * Get home index
         * @summary Get home index (Auth policies: CanEditThresholdsAndRecommendations)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merge(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.merge(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['HistoricalDataApi.merge']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * HistoricalDataApi - factory interface
 * @export
 */
export const HistoricalDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HistoricalDataApiFp(configuration)
    return {
        /**
         * Get home index
         * @summary Get home index (Auth policies: CanEditThresholdsAndRecommendations)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merge(options?: any): AxiosPromise<void> {
            return localVarFp.merge(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HistoricalDataApi - interface
 * @export
 * @interface HistoricalDataApi
 */
export interface HistoricalDataApiInterface {
    /**
     * Get home index
     * @summary Get home index (Auth policies: CanEditThresholdsAndRecommendations)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoricalDataApiInterface
     */
    merge(options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * HistoricalDataApi - object-oriented interface
 * @export
 * @class HistoricalDataApi
 * @extends {BaseAPI}
 */
export class HistoricalDataApi extends BaseAPI implements HistoricalDataApiInterface {
    /**
     * Get home index
     * @summary Get home index (Auth policies: CanEditThresholdsAndRecommendations)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoricalDataApi
     */
    public merge(options?: AxiosRequestConfig) {
        return HistoricalDataApiFp(this.configuration).merge(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ImagesApi - axios parameter creator
 * @export
 */
export const ImagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Downloads analysis image file.
         * @summary Downloads analysis image file. (Auth policies: CanViewGeneratorsData)
         * @param {DownloadImageRequest} [downloadImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadImage: async (downloadImageRequest?: DownloadImageRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/images/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadImageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Downloads analysis images as zip file.
         * @summary Downloads analysis images as zip file. (Auth policies: CanViewGeneratorsData)
         * @param {DownloadImagesAsZipRequest} [downloadImagesAsZipRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadImagesZip: async (downloadImagesAsZipRequest?: DownloadImagesAsZipRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/images/download-zip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadImagesAsZipRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves analysis images grouped by analysis type.
         * @summary Retrieves analysis images grouped by analysis type. (Auth policies: CanViewGeneratorsData)
         * @param {string} [analysisNumber] 
         * @param {string} [componentSid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAnalysisImages: async (analysisNumber?: string, componentSid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/images`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (analysisNumber !== undefined) {
                localVarQueryParameter['analysisNumber'] = analysisNumber;
            }

            if (componentSid !== undefined) {
                localVarQueryParameter['componentSid'] = componentSid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImagesApi - functional programming interface
 * @export
 */
export const ImagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImagesApiAxiosParamCreator(configuration)
    return {
        /**
         * Downloads analysis image file.
         * @summary Downloads analysis image file. (Auth policies: CanViewGeneratorsData)
         * @param {DownloadImageRequest} [downloadImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadImage(downloadImageRequest?: DownloadImageRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadImage(downloadImageRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ImagesApi.downloadImage']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Downloads analysis images as zip file.
         * @summary Downloads analysis images as zip file. (Auth policies: CanViewGeneratorsData)
         * @param {DownloadImagesAsZipRequest} [downloadImagesAsZipRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadImagesZip(downloadImagesAsZipRequest?: DownloadImagesAsZipRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadImagesZip(downloadImagesAsZipRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ImagesApi.downloadImagesZip']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Retrieves analysis images grouped by analysis type.
         * @summary Retrieves analysis images grouped by analysis type. (Auth policies: CanViewGeneratorsData)
         * @param {string} [analysisNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAnalysisImages(analysisNumber?: string, componentSid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetImagesResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAnalysisImages(analysisNumber, componentSid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ImagesApi.listAnalysisImages']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ImagesApi - factory interface
 * @export
 */
export const ImagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImagesApiFp(configuration)
    return {
        /**
         * Downloads analysis image file.
         * @summary Downloads analysis image file. (Auth policies: CanViewGeneratorsData)
         * @param {DownloadImageRequest} [downloadImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadImage(downloadImageRequest?: DownloadImageRequest, options?: any): AxiosPromise<void> {
            return localVarFp.downloadImage(downloadImageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Downloads analysis images as zip file.
         * @summary Downloads analysis images as zip file. (Auth policies: CanViewGeneratorsData)
         * @param {DownloadImagesAsZipRequest} [downloadImagesAsZipRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadImagesZip(downloadImagesAsZipRequest?: DownloadImagesAsZipRequest, options?: any): AxiosPromise<void> {
            return localVarFp.downloadImagesZip(downloadImagesAsZipRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves analysis images grouped by analysis type.
         * @summary Retrieves analysis images grouped by analysis type. (Auth policies: CanViewGeneratorsData)
         * @param {string} [analysisNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAnalysisImages(analysisNumber?: string, componentSid?: string, options?: any): AxiosPromise<GetImagesResponseOkResponse> {
            return localVarFp.listAnalysisImages(analysisNumber, componentSid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ImagesApi - interface
 * @export
 * @interface ImagesApi
 */
export interface ImagesApiInterface {
    /**
     * Downloads analysis image file.
     * @summary Downloads analysis image file. (Auth policies: CanViewGeneratorsData)
     * @param {DownloadImageRequest} [downloadImageRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApiInterface
     */
    downloadImage(downloadImageRequest?: DownloadImageRequest, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * Downloads analysis images as zip file.
     * @summary Downloads analysis images as zip file. (Auth policies: CanViewGeneratorsData)
     * @param {DownloadImagesAsZipRequest} [downloadImagesAsZipRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApiInterface
     */
    downloadImagesZip(downloadImagesAsZipRequest?: DownloadImagesAsZipRequest, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * Retrieves analysis images grouped by analysis type.
     * @summary Retrieves analysis images grouped by analysis type. (Auth policies: CanViewGeneratorsData)
     * @param {string} [analysisNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApiInterface
     */
    listAnalysisImages(analysisNumber?: string, componentSid?: string, options?: AxiosRequestConfig): AxiosPromise<GetImagesResponseOkResponse>;

}

/**
 * ImagesApi - object-oriented interface
 * @export
 * @class ImagesApi
 * @extends {BaseAPI}
 */
export class ImagesApi extends BaseAPI implements ImagesApiInterface {
    /**
     * Downloads analysis image file.
     * @summary Downloads analysis image file. (Auth policies: CanViewGeneratorsData)
     * @param {DownloadImageRequest} [downloadImageRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApi
     */
    public downloadImage(downloadImageRequest?: DownloadImageRequest, options?: AxiosRequestConfig) {
        return ImagesApiFp(this.configuration).downloadImage(downloadImageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Downloads analysis images as zip file.
     * @summary Downloads analysis images as zip file. (Auth policies: CanViewGeneratorsData)
     * @param {DownloadImagesAsZipRequest} [downloadImagesAsZipRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApi
     */
    public downloadImagesZip(downloadImagesAsZipRequest?: DownloadImagesAsZipRequest, options?: AxiosRequestConfig) {
        return ImagesApiFp(this.configuration).downloadImagesZip(downloadImagesAsZipRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves analysis images grouped by analysis type.
     * @summary Retrieves analysis images grouped by analysis type. (Auth policies: CanViewGeneratorsData)
     * @param {string} [analysisNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApi
     */
    public listAnalysisImages(analysisNumber?: string, componentSid?: string, options?: AxiosRequestConfig) {
        return ImagesApiFp(this.configuration).listAnalysisImages(analysisNumber, componentSid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MaintenancesApi - axios parameter creator
 * @export
 */
export const MaintenancesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get registered services
         * @summary Get registered services
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegisteredServices: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/maintenance/registered-services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MaintenancesApi - functional programming interface
 * @export
 */
export const MaintenancesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MaintenancesApiAxiosParamCreator(configuration)
    return {
        /**
         * Get registered services
         * @summary Get registered services
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegisteredServices(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisteredServicesResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegisteredServices(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MaintenancesApi.getRegisteredServices']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * MaintenancesApi - factory interface
 * @export
 */
export const MaintenancesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MaintenancesApiFp(configuration)
    return {
        /**
         * Get registered services
         * @summary Get registered services
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegisteredServices(options?: any): AxiosPromise<RegisteredServicesResponseOkResponse> {
            return localVarFp.getRegisteredServices(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MaintenancesApi - interface
 * @export
 * @interface MaintenancesApi
 */
export interface MaintenancesApiInterface {
    /**
     * Get registered services
     * @summary Get registered services
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenancesApiInterface
     */
    getRegisteredServices(options?: AxiosRequestConfig): AxiosPromise<RegisteredServicesResponseOkResponse>;

}

/**
 * MaintenancesApi - object-oriented interface
 * @export
 * @class MaintenancesApi
 * @extends {BaseAPI}
 */
export class MaintenancesApi extends BaseAPI implements MaintenancesApiInterface {
    /**
     * Get registered services
     * @summary Get registered services
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenancesApi
     */
    public getRegisteredServices(options?: AxiosRequestConfig) {
        return MaintenancesApiFp(this.configuration).getRegisteredServices(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MasterDataApi - axios parameter creator
 * @export
 */
export const MasterDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get generator master data.
         * @summary Get generator master data. (Auth policies: CanViewGeneratorsData)
         * @param {string} generatorSid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneratorDetails: async (generatorSid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generatorSid' is not null or undefined
            assertParamExists('getGeneratorDetails', 'generatorSid', generatorSid)
            const localVarPath = `/api/v1/master-data/generators/{generatorSid}`
                .replace(`{${"generatorSid"}}`, encodeURIComponent(String(generatorSid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get master data generators based on user\'s asset permissions.
         * @summary Get master data generators based on user\'s asset permissions. (Auth policies: CanViewGeneratorsData)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGenerators: async (request?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/master-data/generators`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (request !== undefined) {
                for (const [key, value] of Object.entries(request)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists master data plants based on user\'s asset permissions.
         * @summary Lists master data plants based on user\'s asset permissions. (Auth)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlants: async (request?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/master-data/plants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (request !== undefined) {
                for (const [key, value] of Object.entries(request)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get transformer master data.
         * @summary Get transformer master data. (Auth policies: CanViewTransformerData)
         * @param {string} transformerSid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransformerDetails: async (transformerSid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transformerSid' is not null or undefined
            assertParamExists('getTransformerDetails', 'transformerSid', transformerSid)
            const localVarPath = `/api/v1/master-data/transformers/{transformerSid}`
                .replace(`{${"transformerSid"}}`, encodeURIComponent(String(transformerSid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get master data transformers based on user\'s asset permissions.
         * @summary Get master data transformers based on user\'s asset permissions. (Auth policies: CanViewTransformerData)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransformers: async (request?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/master-data/transformers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (request !== undefined) {
                for (const [key, value] of Object.entries(request)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import master data generators.
         * @summary Import master data generators. (Auth policies: CanEditTransformerRecommendations)
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importGenerators: async (file?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/master-data/import-generators`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MasterDataApi - functional programming interface
 * @export
 */
export const MasterDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MasterDataApiAxiosParamCreator(configuration)
    return {
        /**
         * Get generator master data.
         * @summary Get generator master data. (Auth policies: CanViewGeneratorsData)
         * @param {string} generatorSid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGeneratorDetails(generatorSid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMasterDataGeneratorDetailsResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGeneratorDetails(generatorSid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MasterDataApi.getGeneratorDetails']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get master data generators based on user\'s asset permissions.
         * @summary Get master data generators based on user\'s asset permissions. (Auth policies: CanViewGeneratorsData)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGenerators(request?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMasterDataGeneratorsResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGenerators(request, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MasterDataApi.getGenerators']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Lists master data plants based on user\'s asset permissions.
         * @summary Lists master data plants based on user\'s asset permissions. (Auth)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlants(request?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMasterDataPlantsResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlants(request, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MasterDataApi.getPlants']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get transformer master data.
         * @summary Get transformer master data. (Auth policies: CanViewTransformerData)
         * @param {string} transformerSid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransformerDetails(transformerSid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMasterDataTransformerDetailsResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransformerDetails(transformerSid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MasterDataApi.getTransformerDetails']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get master data transformers based on user\'s asset permissions.
         * @summary Get master data transformers based on user\'s asset permissions. (Auth policies: CanViewTransformerData)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransformers(request?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMasterDataTransformersResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransformers(request, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MasterDataApi.getTransformers']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Import master data generators.
         * @summary Import master data generators. (Auth policies: CanEditTransformerRecommendations)
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importGenerators(file?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportGeneratorsResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importGenerators(file, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MasterDataApi.importGenerators']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * MasterDataApi - factory interface
 * @export
 */
export const MasterDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MasterDataApiFp(configuration)
    return {
        /**
         * Get generator master data.
         * @summary Get generator master data. (Auth policies: CanViewGeneratorsData)
         * @param {string} generatorSid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneratorDetails(generatorSid: string, options?: any): AxiosPromise<GetMasterDataGeneratorDetailsResponseOkResponse> {
            return localVarFp.getGeneratorDetails(generatorSid, options).then((request) => request(axios, basePath));
        },
        /**
         * Get master data generators based on user\'s asset permissions.
         * @summary Get master data generators based on user\'s asset permissions. (Auth policies: CanViewGeneratorsData)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGenerators(request?: object, options?: any): AxiosPromise<GetMasterDataGeneratorsResponseOkResponse> {
            return localVarFp.getGenerators(request, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists master data plants based on user\'s asset permissions.
         * @summary Lists master data plants based on user\'s asset permissions. (Auth)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlants(request?: object, options?: any): AxiosPromise<GetMasterDataPlantsResponseOkResponse> {
            return localVarFp.getPlants(request, options).then((request) => request(axios, basePath));
        },
        /**
         * Get transformer master data.
         * @summary Get transformer master data. (Auth policies: CanViewTransformerData)
         * @param {string} transformerSid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransformerDetails(transformerSid: string, options?: any): AxiosPromise<GetMasterDataTransformerDetailsResponseOkResponse> {
            return localVarFp.getTransformerDetails(transformerSid, options).then((request) => request(axios, basePath));
        },
        /**
         * Get master data transformers based on user\'s asset permissions.
         * @summary Get master data transformers based on user\'s asset permissions. (Auth policies: CanViewTransformerData)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransformers(request?: object, options?: any): AxiosPromise<GetMasterDataTransformersResponseOkResponse> {
            return localVarFp.getTransformers(request, options).then((request) => request(axios, basePath));
        },
        /**
         * Import master data generators.
         * @summary Import master data generators. (Auth policies: CanEditTransformerRecommendations)
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importGenerators(file?: File, options?: any): AxiosPromise<ImportGeneratorsResponseOkResponse> {
            return localVarFp.importGenerators(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MasterDataApi - interface
 * @export
 * @interface MasterDataApi
 */
export interface MasterDataApiInterface {
    /**
     * Get generator master data.
     * @summary Get generator master data. (Auth policies: CanViewGeneratorsData)
     * @param {string} generatorSid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterDataApiInterface
     */
    getGeneratorDetails(generatorSid: string, options?: AxiosRequestConfig): AxiosPromise<GetMasterDataGeneratorDetailsResponseOkResponse>;

    /**
     * Get master data generators based on user\'s asset permissions.
     * @summary Get master data generators based on user\'s asset permissions. (Auth policies: CanViewGeneratorsData)
     * @param {object} [request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterDataApiInterface
     */
    getGenerators(request?: object, options?: AxiosRequestConfig): AxiosPromise<GetMasterDataGeneratorsResponseOkResponse>;

    /**
     * Lists master data plants based on user\'s asset permissions.
     * @summary Lists master data plants based on user\'s asset permissions. (Auth)
     * @param {object} [request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterDataApiInterface
     */
    getPlants(request?: object, options?: AxiosRequestConfig): AxiosPromise<GetMasterDataPlantsResponseOkResponse>;

    /**
     * Get transformer master data.
     * @summary Get transformer master data. (Auth policies: CanViewTransformerData)
     * @param {string} transformerSid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterDataApiInterface
     */
    getTransformerDetails(transformerSid: string, options?: AxiosRequestConfig): AxiosPromise<GetMasterDataTransformerDetailsResponseOkResponse>;

    /**
     * Get master data transformers based on user\'s asset permissions.
     * @summary Get master data transformers based on user\'s asset permissions. (Auth policies: CanViewTransformerData)
     * @param {object} [request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterDataApiInterface
     */
    getTransformers(request?: object, options?: AxiosRequestConfig): AxiosPromise<GetMasterDataTransformersResponseOkResponse>;

    /**
     * Import master data generators.
     * @summary Import master data generators. (Auth policies: CanEditTransformerRecommendations)
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterDataApiInterface
     */
    importGenerators(file?: File, options?: AxiosRequestConfig): AxiosPromise<ImportGeneratorsResponseOkResponse>;

}

/**
 * MasterDataApi - object-oriented interface
 * @export
 * @class MasterDataApi
 * @extends {BaseAPI}
 */
export class MasterDataApi extends BaseAPI implements MasterDataApiInterface {
    /**
     * Get generator master data.
     * @summary Get generator master data. (Auth policies: CanViewGeneratorsData)
     * @param {string} generatorSid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterDataApi
     */
    public getGeneratorDetails(generatorSid: string, options?: AxiosRequestConfig) {
        return MasterDataApiFp(this.configuration).getGeneratorDetails(generatorSid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get master data generators based on user\'s asset permissions.
     * @summary Get master data generators based on user\'s asset permissions. (Auth policies: CanViewGeneratorsData)
     * @param {object} [request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterDataApi
     */
    public getGenerators(request?: object, options?: AxiosRequestConfig) {
        return MasterDataApiFp(this.configuration).getGenerators(request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists master data plants based on user\'s asset permissions.
     * @summary Lists master data plants based on user\'s asset permissions. (Auth)
     * @param {object} [request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterDataApi
     */
    public getPlants(request?: object, options?: AxiosRequestConfig) {
        return MasterDataApiFp(this.configuration).getPlants(request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get transformer master data.
     * @summary Get transformer master data. (Auth policies: CanViewTransformerData)
     * @param {string} transformerSid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterDataApi
     */
    public getTransformerDetails(transformerSid: string, options?: AxiosRequestConfig) {
        return MasterDataApiFp(this.configuration).getTransformerDetails(transformerSid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get master data transformers based on user\'s asset permissions.
     * @summary Get master data transformers based on user\'s asset permissions. (Auth policies: CanViewTransformerData)
     * @param {object} [request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterDataApi
     */
    public getTransformers(request?: object, options?: AxiosRequestConfig) {
        return MasterDataApiFp(this.configuration).getTransformers(request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import master data generators.
     * @summary Import master data generators. (Auth policies: CanEditTransformerRecommendations)
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterDataApi
     */
    public importGenerators(file?: File, options?: AxiosRequestConfig) {
        return MasterDataApiFp(this.configuration).importGenerators(file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PingApi - axios parameter creator
 * @export
 */
export const PingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get ping
         * @summary Get ping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ping: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PingApi - functional programming interface
 * @export
 */
export const PingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PingApiAxiosParamCreator(configuration)
    return {
        /**
         * Get ping
         * @summary Get ping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ping(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PingGetResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ping(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PingApi.ping']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PingApi - factory interface
 * @export
 */
export const PingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PingApiFp(configuration)
    return {
        /**
         * Get ping
         * @summary Get ping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ping(options?: any): AxiosPromise<PingGetResponseOkResponse> {
            return localVarFp.ping(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PingApi - interface
 * @export
 * @interface PingApi
 */
export interface PingApiInterface {
    /**
     * Get ping
     * @summary Get ping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PingApiInterface
     */
    ping(options?: AxiosRequestConfig): AxiosPromise<PingGetResponseOkResponse>;

}

/**
 * PingApi - object-oriented interface
 * @export
 * @class PingApi
 * @extends {BaseAPI}
 */
export class PingApi extends BaseAPI implements PingApiInterface {
    /**
     * Get ping
     * @summary Get ping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PingApi
     */
    public ping(options?: AxiosRequestConfig) {
        return PingApiFp(this.configuration).ping(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PortfolioOverviewApi - axios parameter creator
 * @export
 */
export const PortfolioOverviewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get portfolio status summary at a plant group level for generators.
         * @summary Get portfolio status summary at a plant group level for generators. (Auth policies: CanViewGeneratorsData)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneratorPlantGroupPortfolioSummary: async (request?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/portfolio-overview/generator/summary/plant-group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (request !== undefined) {
                for (const [key, value] of Object.entries(request)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get portfolio status summary at a plant level.
         * @summary Get portfolio status summary at a plant level. (Auth policies: CanViewGeneratorsData)
         * @param {number} plantGroupSid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneratorPlantPortfolioSummary: async (plantGroupSid: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'plantGroupSid' is not null or undefined
            assertParamExists('getGeneratorPlantPortfolioSummary', 'plantGroupSid', plantGroupSid)
            const localVarPath = `/api/v1/portfolio-overview/generator/summary/plant/{plantGroupSid}`
                .replace(`{${"plantGroupSid"}}`, encodeURIComponent(String(plantGroupSid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get generator portfolio status summary.
         * @summary Get generator portfolio status summary. (Auth policies: CanViewGeneratorsData)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneratorPortfolioSummary: async (request?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/portfolio-overview/generator/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (request !== undefined) {
                for (const [key, value] of Object.entries(request)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get portfolio status summary at a plant group level.
         * @summary Get portfolio status summary at a plant group level. (Auth policies: CanViewTransformerData)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlantGroupPortfolioSummary: async (request?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/portfolio-overview/transformer/summary/plant-group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (request !== undefined) {
                for (const [key, value] of Object.entries(request)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get portfolio status summary at a plant level.
         * @summary Get portfolio status summary at a plant level. (Auth policies: CanViewTransformerData)
         * @param {number} plantGroupSid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlantPortfolioSummary: async (plantGroupSid: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'plantGroupSid' is not null or undefined
            assertParamExists('getPlantPortfolioSummary', 'plantGroupSid', plantGroupSid)
            const localVarPath = `/api/v1/portfolio-overview/transformer/summary/plant/{plantGroupSid}`
                .replace(`{${"plantGroupSid"}}`, encodeURIComponent(String(plantGroupSid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get portfolio status summary.
         * @summary Get portfolio status summary. (Auth policies: CanViewTransformerData)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransformerPortfolioSummary: async (request?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/portfolio-overview/transformer/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (request !== undefined) {
                for (const [key, value] of Object.entries(request)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List flagged generators by plant sids and issue type.
         * @summary List flagged generators by plant sids and issue type. (Auth policies: CanViewGeneratorsData)
         * @param {Array<number>} [plantSids] 
         * @param {number} [issueType] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFlaggedGenerators: async (plantSids?: Array<number>, issueType?: number, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/portfolio-overview/generator/flagged`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (plantSids) {
                localVarQueryParameter['plantSids'] = plantSids;
            }

            if (issueType !== undefined) {
                localVarQueryParameter['issueType'] = issueType;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (requestedOffset !== undefined) {
                localVarQueryParameter['requestedOffset'] = requestedOffset;
            }

            if (term !== undefined) {
                localVarQueryParameter['Term'] = term;
            }

            if (termToLower !== undefined) {
                localVarQueryParameter['TermToLower'] = termToLower;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List flagged transformers by plant sids and issue type.
         * @summary List flagged transformers by plant sids and issue type. (Auth policies: CanViewTransformerData)
         * @param {Array<number>} [plantSids] 
         * @param {number} [issueType] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFlaggedTransformers: async (plantSids?: Array<number>, issueType?: number, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/portfolio-overview/transformer/flagged`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (plantSids) {
                localVarQueryParameter['plantSids'] = plantSids;
            }

            if (issueType !== undefined) {
                localVarQueryParameter['issueType'] = issueType;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (requestedOffset !== undefined) {
                localVarQueryParameter['requestedOffset'] = requestedOffset;
            }

            if (term !== undefined) {
                localVarQueryParameter['Term'] = term;
            }

            if (termToLower !== undefined) {
                localVarQueryParameter['TermToLower'] = termToLower;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PortfolioOverviewApi - functional programming interface
 * @export
 */
export const PortfolioOverviewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PortfolioOverviewApiAxiosParamCreator(configuration)
    return {
        /**
         * Get portfolio status summary at a plant group level for generators.
         * @summary Get portfolio status summary at a plant group level for generators. (Auth policies: CanViewGeneratorsData)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGeneratorPlantGroupPortfolioSummary(request?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGeneratorPlantGroupStatusSummaryResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGeneratorPlantGroupPortfolioSummary(request, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PortfolioOverviewApi.getGeneratorPlantGroupPortfolioSummary']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get portfolio status summary at a plant level.
         * @summary Get portfolio status summary at a plant level. (Auth policies: CanViewGeneratorsData)
         * @param {number} plantGroupSid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGeneratorPlantPortfolioSummary(plantGroupSid: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGeneratorPlantStatusSummaryResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGeneratorPlantPortfolioSummary(plantGroupSid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PortfolioOverviewApi.getGeneratorPlantPortfolioSummary']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get generator portfolio status summary.
         * @summary Get generator portfolio status summary. (Auth policies: CanViewGeneratorsData)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGeneratorPortfolioSummary(request?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGeneratorStatusSummaryResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGeneratorPortfolioSummary(request, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PortfolioOverviewApi.getGeneratorPortfolioSummary']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get portfolio status summary at a plant group level.
         * @summary Get portfolio status summary at a plant group level. (Auth policies: CanViewTransformerData)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlantGroupPortfolioSummary(request?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPlantGroupStatusSummaryResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlantGroupPortfolioSummary(request, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PortfolioOverviewApi.getPlantGroupPortfolioSummary']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get portfolio status summary at a plant level.
         * @summary Get portfolio status summary at a plant level. (Auth policies: CanViewTransformerData)
         * @param {number} plantGroupSid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlantPortfolioSummary(plantGroupSid: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPlantStatusSummaryResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlantPortfolioSummary(plantGroupSid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PortfolioOverviewApi.getPlantPortfolioSummary']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get portfolio status summary.
         * @summary Get portfolio status summary. (Auth policies: CanViewTransformerData)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransformerPortfolioSummary(request?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStatusSummaryResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransformerPortfolioSummary(request, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PortfolioOverviewApi.getTransformerPortfolioSummary']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List flagged generators by plant sids and issue type.
         * @summary List flagged generators by plant sids and issue type. (Auth policies: CanViewGeneratorsData)
         * @param {Array<number>} [plantSids] 
         * @param {number} [issueType] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFlaggedGenerators(plantSids?: Array<number>, issueType?: number, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListFlaggedGeneratorsResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFlaggedGenerators(plantSids, issueType, page, size, requestedOffset, term, termToLower, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PortfolioOverviewApi.listFlaggedGenerators']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List flagged transformers by plant sids and issue type.
         * @summary List flagged transformers by plant sids and issue type. (Auth policies: CanViewTransformerData)
         * @param {Array<number>} [plantSids] 
         * @param {number} [issueType] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFlaggedTransformers(plantSids?: Array<number>, issueType?: number, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListFlaggedTransformersResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFlaggedTransformers(plantSids, issueType, page, size, requestedOffset, term, termToLower, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PortfolioOverviewApi.listFlaggedTransformers']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PortfolioOverviewApi - factory interface
 * @export
 */
export const PortfolioOverviewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PortfolioOverviewApiFp(configuration)
    return {
        /**
         * Get portfolio status summary at a plant group level for generators.
         * @summary Get portfolio status summary at a plant group level for generators. (Auth policies: CanViewGeneratorsData)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneratorPlantGroupPortfolioSummary(request?: object, options?: any): AxiosPromise<GetGeneratorPlantGroupStatusSummaryResponseOkResponse> {
            return localVarFp.getGeneratorPlantGroupPortfolioSummary(request, options).then((request) => request(axios, basePath));
        },
        /**
         * Get portfolio status summary at a plant level.
         * @summary Get portfolio status summary at a plant level. (Auth policies: CanViewGeneratorsData)
         * @param {number} plantGroupSid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneratorPlantPortfolioSummary(plantGroupSid: number, options?: any): AxiosPromise<GetGeneratorPlantStatusSummaryResponseOkResponse> {
            return localVarFp.getGeneratorPlantPortfolioSummary(plantGroupSid, options).then((request) => request(axios, basePath));
        },
        /**
         * Get generator portfolio status summary.
         * @summary Get generator portfolio status summary. (Auth policies: CanViewGeneratorsData)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneratorPortfolioSummary(request?: object, options?: any): AxiosPromise<GetGeneratorStatusSummaryResponseOkResponse> {
            return localVarFp.getGeneratorPortfolioSummary(request, options).then((request) => request(axios, basePath));
        },
        /**
         * Get portfolio status summary at a plant group level.
         * @summary Get portfolio status summary at a plant group level. (Auth policies: CanViewTransformerData)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlantGroupPortfolioSummary(request?: object, options?: any): AxiosPromise<GetPlantGroupStatusSummaryResponseOkResponse> {
            return localVarFp.getPlantGroupPortfolioSummary(request, options).then((request) => request(axios, basePath));
        },
        /**
         * Get portfolio status summary at a plant level.
         * @summary Get portfolio status summary at a plant level. (Auth policies: CanViewTransformerData)
         * @param {number} plantGroupSid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlantPortfolioSummary(plantGroupSid: number, options?: any): AxiosPromise<GetPlantStatusSummaryResponseOkResponse> {
            return localVarFp.getPlantPortfolioSummary(plantGroupSid, options).then((request) => request(axios, basePath));
        },
        /**
         * Get portfolio status summary.
         * @summary Get portfolio status summary. (Auth policies: CanViewTransformerData)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransformerPortfolioSummary(request?: object, options?: any): AxiosPromise<GetStatusSummaryResponseOkResponse> {
            return localVarFp.getTransformerPortfolioSummary(request, options).then((request) => request(axios, basePath));
        },
        /**
         * List flagged generators by plant sids and issue type.
         * @summary List flagged generators by plant sids and issue type. (Auth policies: CanViewGeneratorsData)
         * @param {Array<number>} [plantSids] 
         * @param {number} [issueType] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFlaggedGenerators(plantSids?: Array<number>, issueType?: number, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: any): AxiosPromise<ListFlaggedGeneratorsResponseOkResponse> {
            return localVarFp.listFlaggedGenerators(plantSids, issueType, page, size, requestedOffset, term, termToLower, options).then((request) => request(axios, basePath));
        },
        /**
         * List flagged transformers by plant sids and issue type.
         * @summary List flagged transformers by plant sids and issue type. (Auth policies: CanViewTransformerData)
         * @param {Array<number>} [plantSids] 
         * @param {number} [issueType] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFlaggedTransformers(plantSids?: Array<number>, issueType?: number, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: any): AxiosPromise<ListFlaggedTransformersResponseOkResponse> {
            return localVarFp.listFlaggedTransformers(plantSids, issueType, page, size, requestedOffset, term, termToLower, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PortfolioOverviewApi - interface
 * @export
 * @interface PortfolioOverviewApi
 */
export interface PortfolioOverviewApiInterface {
    /**
     * Get portfolio status summary at a plant group level for generators.
     * @summary Get portfolio status summary at a plant group level for generators. (Auth policies: CanViewGeneratorsData)
     * @param {object} [request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioOverviewApiInterface
     */
    getGeneratorPlantGroupPortfolioSummary(request?: object, options?: AxiosRequestConfig): AxiosPromise<GetGeneratorPlantGroupStatusSummaryResponseOkResponse>;

    /**
     * Get portfolio status summary at a plant level.
     * @summary Get portfolio status summary at a plant level. (Auth policies: CanViewGeneratorsData)
     * @param {number} plantGroupSid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioOverviewApiInterface
     */
    getGeneratorPlantPortfolioSummary(plantGroupSid: number, options?: AxiosRequestConfig): AxiosPromise<GetGeneratorPlantStatusSummaryResponseOkResponse>;

    /**
     * Get generator portfolio status summary.
     * @summary Get generator portfolio status summary. (Auth policies: CanViewGeneratorsData)
     * @param {object} [request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioOverviewApiInterface
     */
    getGeneratorPortfolioSummary(request?: object, options?: AxiosRequestConfig): AxiosPromise<GetGeneratorStatusSummaryResponseOkResponse>;

    /**
     * Get portfolio status summary at a plant group level.
     * @summary Get portfolio status summary at a plant group level. (Auth policies: CanViewTransformerData)
     * @param {object} [request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioOverviewApiInterface
     */
    getPlantGroupPortfolioSummary(request?: object, options?: AxiosRequestConfig): AxiosPromise<GetPlantGroupStatusSummaryResponseOkResponse>;

    /**
     * Get portfolio status summary at a plant level.
     * @summary Get portfolio status summary at a plant level. (Auth policies: CanViewTransformerData)
     * @param {number} plantGroupSid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioOverviewApiInterface
     */
    getPlantPortfolioSummary(plantGroupSid: number, options?: AxiosRequestConfig): AxiosPromise<GetPlantStatusSummaryResponseOkResponse>;

    /**
     * Get portfolio status summary.
     * @summary Get portfolio status summary. (Auth policies: CanViewTransformerData)
     * @param {object} [request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioOverviewApiInterface
     */
    getTransformerPortfolioSummary(request?: object, options?: AxiosRequestConfig): AxiosPromise<GetStatusSummaryResponseOkResponse>;

    /**
     * List flagged generators by plant sids and issue type.
     * @summary List flagged generators by plant sids and issue type. (Auth policies: CanViewGeneratorsData)
     * @param {Array<number>} [plantSids] 
     * @param {number} [issueType] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {number} [requestedOffset] 
     * @param {string} [term] 
     * @param {string} [termToLower] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioOverviewApiInterface
     */
    listFlaggedGenerators(plantSids?: Array<number>, issueType?: number, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig): AxiosPromise<ListFlaggedGeneratorsResponseOkResponse>;

    /**
     * List flagged transformers by plant sids and issue type.
     * @summary List flagged transformers by plant sids and issue type. (Auth policies: CanViewTransformerData)
     * @param {Array<number>} [plantSids] 
     * @param {number} [issueType] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {number} [requestedOffset] 
     * @param {string} [term] 
     * @param {string} [termToLower] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioOverviewApiInterface
     */
    listFlaggedTransformers(plantSids?: Array<number>, issueType?: number, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig): AxiosPromise<ListFlaggedTransformersResponseOkResponse>;

}

/**
 * PortfolioOverviewApi - object-oriented interface
 * @export
 * @class PortfolioOverviewApi
 * @extends {BaseAPI}
 */
export class PortfolioOverviewApi extends BaseAPI implements PortfolioOverviewApiInterface {
    /**
     * Get portfolio status summary at a plant group level for generators.
     * @summary Get portfolio status summary at a plant group level for generators. (Auth policies: CanViewGeneratorsData)
     * @param {object} [request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioOverviewApi
     */
    public getGeneratorPlantGroupPortfolioSummary(request?: object, options?: AxiosRequestConfig) {
        return PortfolioOverviewApiFp(this.configuration).getGeneratorPlantGroupPortfolioSummary(request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get portfolio status summary at a plant level.
     * @summary Get portfolio status summary at a plant level. (Auth policies: CanViewGeneratorsData)
     * @param {number} plantGroupSid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioOverviewApi
     */
    public getGeneratorPlantPortfolioSummary(plantGroupSid: number, options?: AxiosRequestConfig) {
        return PortfolioOverviewApiFp(this.configuration).getGeneratorPlantPortfolioSummary(plantGroupSid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get generator portfolio status summary.
     * @summary Get generator portfolio status summary. (Auth policies: CanViewGeneratorsData)
     * @param {object} [request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioOverviewApi
     */
    public getGeneratorPortfolioSummary(request?: object, options?: AxiosRequestConfig) {
        return PortfolioOverviewApiFp(this.configuration).getGeneratorPortfolioSummary(request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get portfolio status summary at a plant group level.
     * @summary Get portfolio status summary at a plant group level. (Auth policies: CanViewTransformerData)
     * @param {object} [request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioOverviewApi
     */
    public getPlantGroupPortfolioSummary(request?: object, options?: AxiosRequestConfig) {
        return PortfolioOverviewApiFp(this.configuration).getPlantGroupPortfolioSummary(request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get portfolio status summary at a plant level.
     * @summary Get portfolio status summary at a plant level. (Auth policies: CanViewTransformerData)
     * @param {number} plantGroupSid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioOverviewApi
     */
    public getPlantPortfolioSummary(plantGroupSid: number, options?: AxiosRequestConfig) {
        return PortfolioOverviewApiFp(this.configuration).getPlantPortfolioSummary(plantGroupSid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get portfolio status summary.
     * @summary Get portfolio status summary. (Auth policies: CanViewTransformerData)
     * @param {object} [request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioOverviewApi
     */
    public getTransformerPortfolioSummary(request?: object, options?: AxiosRequestConfig) {
        return PortfolioOverviewApiFp(this.configuration).getTransformerPortfolioSummary(request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List flagged generators by plant sids and issue type.
     * @summary List flagged generators by plant sids and issue type. (Auth policies: CanViewGeneratorsData)
     * @param {Array<number>} [plantSids] 
     * @param {number} [issueType] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {number} [requestedOffset] 
     * @param {string} [term] 
     * @param {string} [termToLower] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioOverviewApi
     */
    public listFlaggedGenerators(plantSids?: Array<number>, issueType?: number, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig) {
        return PortfolioOverviewApiFp(this.configuration).listFlaggedGenerators(plantSids, issueType, page, size, requestedOffset, term, termToLower, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List flagged transformers by plant sids and issue type.
     * @summary List flagged transformers by plant sids and issue type. (Auth policies: CanViewTransformerData)
     * @param {Array<number>} [plantSids] 
     * @param {number} [issueType] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {number} [requestedOffset] 
     * @param {string} [term] 
     * @param {string} [termToLower] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioOverviewApi
     */
    public listFlaggedTransformers(plantSids?: Array<number>, issueType?: number, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig) {
        return PortfolioOverviewApiFp(this.configuration).listFlaggedTransformers(plantSids, issueType, page, size, requestedOffset, term, termToLower, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PortfolioTrendsApi - axios parameter creator
 * @export
 */
export const PortfolioTrendsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get status number of the generators by age.
         * @summary Get status number of the generators by age. (Auth policies: CanViewGeneratorsData)
         * @param {string} endDate 
         * @param {Array<number>} [plantSids] 
         * @param {number} [generatorAgeType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneratorStatusesByAge: async (endDate: string, plantSids?: Array<number>, generatorAgeType?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getGeneratorStatusesByAge', 'endDate', endDate)
            const localVarPath = `/api/v1/portfolio-trends/generator/condition-status-by-age`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (plantSids) {
                localVarQueryParameter['PlantSids'] = plantSids;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['EndDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (generatorAgeType !== undefined) {
                localVarQueryParameter['GeneratorAgeType'] = generatorAgeType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the yearly status number of the generators.
         * @summary Get the yearly status number of the generators. (Auth policies: CanViewGeneratorsData)
         * @param {Array<number>} [plantSids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneratorYearlyStatuses: async (plantSids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/portfolio-trends/generator/condition-status-yearly`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (plantSids) {
                localVarQueryParameter['PlantSids'] = plantSids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get status number of the transformers by age.
         * @summary Get status number of the transformers by age. (Auth policies: CanViewTransformerData)
         * @param {string} endDate 
         * @param {Array<number>} [plantSids] 
         * @param {number} [transformerAgeType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransformerStatusesByAge: async (endDate: string, plantSids?: Array<number>, transformerAgeType?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getTransformerStatusesByAge', 'endDate', endDate)
            const localVarPath = `/api/v1/portfolio-trends/transformer/condition-status-by-age`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (plantSids) {
                localVarQueryParameter['PlantSids'] = plantSids;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['EndDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (transformerAgeType !== undefined) {
                localVarQueryParameter['TransformerAgeType'] = transformerAgeType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the yearly status number of the transformers.
         * @summary Get the yearly status number of the transformers. (Auth policies: CanViewTransformerData)
         * @param {Array<number>} [plantSids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransformerYearlyStatuses: async (plantSids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/portfolio-trends/transformer/condition-status-yearly`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (plantSids) {
                localVarQueryParameter['PlantSids'] = plantSids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PortfolioTrendsApi - functional programming interface
 * @export
 */
export const PortfolioTrendsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PortfolioTrendsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get status number of the generators by age.
         * @summary Get status number of the generators by age. (Auth policies: CanViewGeneratorsData)
         * @param {string} endDate 
         * @param {Array<number>} [plantSids] 
         * @param {number} [generatorAgeType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGeneratorStatusesByAge(endDate: string, plantSids?: Array<number>, generatorAgeType?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGeneratorConditionStatusByAgeResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGeneratorStatusesByAge(endDate, plantSids, generatorAgeType, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PortfolioTrendsApi.getGeneratorStatusesByAge']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get the yearly status number of the generators.
         * @summary Get the yearly status number of the generators. (Auth policies: CanViewGeneratorsData)
         * @param {Array<number>} [plantSids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGeneratorYearlyStatuses(plantSids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGeneratorConditionStatusYearlyResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGeneratorYearlyStatuses(plantSids, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PortfolioTrendsApi.getGeneratorYearlyStatuses']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get status number of the transformers by age.
         * @summary Get status number of the transformers by age. (Auth policies: CanViewTransformerData)
         * @param {string} endDate 
         * @param {Array<number>} [plantSids] 
         * @param {number} [transformerAgeType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransformerStatusesByAge(endDate: string, plantSids?: Array<number>, transformerAgeType?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetConditionStatusByAgeResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransformerStatusesByAge(endDate, plantSids, transformerAgeType, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PortfolioTrendsApi.getTransformerStatusesByAge']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get the yearly status number of the transformers.
         * @summary Get the yearly status number of the transformers. (Auth policies: CanViewTransformerData)
         * @param {Array<number>} [plantSids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransformerYearlyStatuses(plantSids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetConditionStatusYearlyResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransformerYearlyStatuses(plantSids, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PortfolioTrendsApi.getTransformerYearlyStatuses']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PortfolioTrendsApi - factory interface
 * @export
 */
export const PortfolioTrendsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PortfolioTrendsApiFp(configuration)
    return {
        /**
         * Get status number of the generators by age.
         * @summary Get status number of the generators by age. (Auth policies: CanViewGeneratorsData)
         * @param {string} endDate 
         * @param {Array<number>} [plantSids] 
         * @param {number} [generatorAgeType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneratorStatusesByAge(endDate: string, plantSids?: Array<number>, generatorAgeType?: number, options?: any): AxiosPromise<GetGeneratorConditionStatusByAgeResponseOkResponse> {
            return localVarFp.getGeneratorStatusesByAge(endDate, plantSids, generatorAgeType, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the yearly status number of the generators.
         * @summary Get the yearly status number of the generators. (Auth policies: CanViewGeneratorsData)
         * @param {Array<number>} [plantSids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneratorYearlyStatuses(plantSids?: Array<number>, options?: any): AxiosPromise<GetGeneratorConditionStatusYearlyResponseOkResponse> {
            return localVarFp.getGeneratorYearlyStatuses(plantSids, options).then((request) => request(axios, basePath));
        },
        /**
         * Get status number of the transformers by age.
         * @summary Get status number of the transformers by age. (Auth policies: CanViewTransformerData)
         * @param {string} endDate 
         * @param {Array<number>} [plantSids] 
         * @param {number} [transformerAgeType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransformerStatusesByAge(endDate: string, plantSids?: Array<number>, transformerAgeType?: number, options?: any): AxiosPromise<GetConditionStatusByAgeResponseOkResponse> {
            return localVarFp.getTransformerStatusesByAge(endDate, plantSids, transformerAgeType, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the yearly status number of the transformers.
         * @summary Get the yearly status number of the transformers. (Auth policies: CanViewTransformerData)
         * @param {Array<number>} [plantSids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransformerYearlyStatuses(plantSids?: Array<number>, options?: any): AxiosPromise<GetConditionStatusYearlyResponseOkResponse> {
            return localVarFp.getTransformerYearlyStatuses(plantSids, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PortfolioTrendsApi - interface
 * @export
 * @interface PortfolioTrendsApi
 */
export interface PortfolioTrendsApiInterface {
    /**
     * Get status number of the generators by age.
     * @summary Get status number of the generators by age. (Auth policies: CanViewGeneratorsData)
     * @param {string} endDate 
     * @param {Array<number>} [plantSids] 
     * @param {number} [generatorAgeType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioTrendsApiInterface
     */
    getGeneratorStatusesByAge(endDate: string, plantSids?: Array<number>, generatorAgeType?: number, options?: AxiosRequestConfig): AxiosPromise<GetGeneratorConditionStatusByAgeResponseOkResponse>;

    /**
     * Get the yearly status number of the generators.
     * @summary Get the yearly status number of the generators. (Auth policies: CanViewGeneratorsData)
     * @param {Array<number>} [plantSids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioTrendsApiInterface
     */
    getGeneratorYearlyStatuses(plantSids?: Array<number>, options?: AxiosRequestConfig): AxiosPromise<GetGeneratorConditionStatusYearlyResponseOkResponse>;

    /**
     * Get status number of the transformers by age.
     * @summary Get status number of the transformers by age. (Auth policies: CanViewTransformerData)
     * @param {string} endDate 
     * @param {Array<number>} [plantSids] 
     * @param {number} [transformerAgeType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioTrendsApiInterface
     */
    getTransformerStatusesByAge(endDate: string, plantSids?: Array<number>, transformerAgeType?: number, options?: AxiosRequestConfig): AxiosPromise<GetConditionStatusByAgeResponseOkResponse>;

    /**
     * Get the yearly status number of the transformers.
     * @summary Get the yearly status number of the transformers. (Auth policies: CanViewTransformerData)
     * @param {Array<number>} [plantSids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioTrendsApiInterface
     */
    getTransformerYearlyStatuses(plantSids?: Array<number>, options?: AxiosRequestConfig): AxiosPromise<GetConditionStatusYearlyResponseOkResponse>;

}

/**
 * PortfolioTrendsApi - object-oriented interface
 * @export
 * @class PortfolioTrendsApi
 * @extends {BaseAPI}
 */
export class PortfolioTrendsApi extends BaseAPI implements PortfolioTrendsApiInterface {
    /**
     * Get status number of the generators by age.
     * @summary Get status number of the generators by age. (Auth policies: CanViewGeneratorsData)
     * @param {string} endDate 
     * @param {Array<number>} [plantSids] 
     * @param {number} [generatorAgeType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioTrendsApi
     */
    public getGeneratorStatusesByAge(endDate: string, plantSids?: Array<number>, generatorAgeType?: number, options?: AxiosRequestConfig) {
        return PortfolioTrendsApiFp(this.configuration).getGeneratorStatusesByAge(endDate, plantSids, generatorAgeType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the yearly status number of the generators.
     * @summary Get the yearly status number of the generators. (Auth policies: CanViewGeneratorsData)
     * @param {Array<number>} [plantSids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioTrendsApi
     */
    public getGeneratorYearlyStatuses(plantSids?: Array<number>, options?: AxiosRequestConfig) {
        return PortfolioTrendsApiFp(this.configuration).getGeneratorYearlyStatuses(plantSids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get status number of the transformers by age.
     * @summary Get status number of the transformers by age. (Auth policies: CanViewTransformerData)
     * @param {string} endDate 
     * @param {Array<number>} [plantSids] 
     * @param {number} [transformerAgeType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioTrendsApi
     */
    public getTransformerStatusesByAge(endDate: string, plantSids?: Array<number>, transformerAgeType?: number, options?: AxiosRequestConfig) {
        return PortfolioTrendsApiFp(this.configuration).getTransformerStatusesByAge(endDate, plantSids, transformerAgeType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the yearly status number of the transformers.
     * @summary Get the yearly status number of the transformers. (Auth policies: CanViewTransformerData)
     * @param {Array<number>} [plantSids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioTrendsApi
     */
    public getTransformerYearlyStatuses(plantSids?: Array<number>, options?: AxiosRequestConfig) {
        return PortfolioTrendsApiFp(this.configuration).getTransformerYearlyStatuses(plantSids, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RecommendationTypesApi - axios parameter creator
 * @export
 */
export const RecommendationTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new recommendation type.
         * @summary Add a new recommendation type. (Auth policies: CanEditThresholdsAndRecommendations)
         * @param {AddRecommendationTypeRequest} [addRecommendationTypeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRecommendationType: async (addRecommendationTypeRequest?: AddRecommendationTypeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/recommendation-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addRecommendationTypeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edits a recommendation type.
         * @summary Edits a recommendation type. (Auth policies: CanEditThresholdsAndRecommendations)
         * @param {number} recommendationTypeId 
         * @param {RecommendationTypeRequestDto} [recommendationTypeRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editRecommendationType: async (recommendationTypeId: number, recommendationTypeRequestDto?: RecommendationTypeRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recommendationTypeId' is not null or undefined
            assertParamExists('editRecommendationType', 'recommendationTypeId', recommendationTypeId)
            const localVarPath = `/api/v1/recommendation-types/{recommendationTypeId}`
                .replace(`{${"recommendationTypeId"}}`, encodeURIComponent(String(recommendationTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recommendationTypeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get recommendation type details by id.
         * @summary Get recommendation type details by id.
         * @param {number} recommendationTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecommendationType: async (recommendationTypeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recommendationTypeId' is not null or undefined
            assertParamExists('getRecommendationType', 'recommendationTypeId', recommendationTypeId)
            const localVarPath = `/api/v1/recommendation-types/{recommendationTypeId}`
                .replace(`{${"recommendationTypeId"}}`, encodeURIComponent(String(recommendationTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List recommendation types.
         * @summary List recommendation types.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecommendationTypes: async (page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/recommendation-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (requestedOffset !== undefined) {
                localVarQueryParameter['requestedOffset'] = requestedOffset;
            }

            if (term !== undefined) {
                localVarQueryParameter['Term'] = term;
            }

            if (termToLower !== undefined) {
                localVarQueryParameter['TermToLower'] = termToLower;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RecommendationTypesApi - functional programming interface
 * @export
 */
export const RecommendationTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RecommendationTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new recommendation type.
         * @summary Add a new recommendation type. (Auth policies: CanEditThresholdsAndRecommendations)
         * @param {AddRecommendationTypeRequest} [addRecommendationTypeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addRecommendationType(addRecommendationTypeRequest?: AddRecommendationTypeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddRecommendationTypeResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addRecommendationType(addRecommendationTypeRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RecommendationTypesApi.addRecommendationType']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Edits a recommendation type.
         * @summary Edits a recommendation type. (Auth policies: CanEditThresholdsAndRecommendations)
         * @param {number} recommendationTypeId 
         * @param {RecommendationTypeRequestDto} [recommendationTypeRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editRecommendationType(recommendationTypeId: number, recommendationTypeRequestDto?: RecommendationTypeRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EditRecommendationTypeResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editRecommendationType(recommendationTypeId, recommendationTypeRequestDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RecommendationTypesApi.editRecommendationType']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get recommendation type details by id.
         * @summary Get recommendation type details by id.
         * @param {number} recommendationTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecommendationType(recommendationTypeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRecommendationTypeResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecommendationType(recommendationTypeId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RecommendationTypesApi.getRecommendationType']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List recommendation types.
         * @summary List recommendation types.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRecommendationTypes(page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListRecommendationTypesResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRecommendationTypes(page, size, requestedOffset, term, termToLower, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RecommendationTypesApi.listRecommendationTypes']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * RecommendationTypesApi - factory interface
 * @export
 */
export const RecommendationTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RecommendationTypesApiFp(configuration)
    return {
        /**
         * Add a new recommendation type.
         * @summary Add a new recommendation type. (Auth policies: CanEditThresholdsAndRecommendations)
         * @param {AddRecommendationTypeRequest} [addRecommendationTypeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRecommendationType(addRecommendationTypeRequest?: AddRecommendationTypeRequest, options?: any): AxiosPromise<AddRecommendationTypeResponseOkResponse> {
            return localVarFp.addRecommendationType(addRecommendationTypeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Edits a recommendation type.
         * @summary Edits a recommendation type. (Auth policies: CanEditThresholdsAndRecommendations)
         * @param {number} recommendationTypeId 
         * @param {RecommendationTypeRequestDto} [recommendationTypeRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editRecommendationType(recommendationTypeId: number, recommendationTypeRequestDto?: RecommendationTypeRequestDto, options?: any): AxiosPromise<EditRecommendationTypeResponseOkResponse> {
            return localVarFp.editRecommendationType(recommendationTypeId, recommendationTypeRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Get recommendation type details by id.
         * @summary Get recommendation type details by id.
         * @param {number} recommendationTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecommendationType(recommendationTypeId: number, options?: any): AxiosPromise<GetRecommendationTypeResponseOkResponse> {
            return localVarFp.getRecommendationType(recommendationTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * List recommendation types.
         * @summary List recommendation types.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecommendationTypes(page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: any): AxiosPromise<ListRecommendationTypesResponseOkResponse> {
            return localVarFp.listRecommendationTypes(page, size, requestedOffset, term, termToLower, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RecommendationTypesApi - interface
 * @export
 * @interface RecommendationTypesApi
 */
export interface RecommendationTypesApiInterface {
    /**
     * Add a new recommendation type.
     * @summary Add a new recommendation type. (Auth policies: CanEditThresholdsAndRecommendations)
     * @param {AddRecommendationTypeRequest} [addRecommendationTypeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationTypesApiInterface
     */
    addRecommendationType(addRecommendationTypeRequest?: AddRecommendationTypeRequest, options?: AxiosRequestConfig): AxiosPromise<AddRecommendationTypeResponseOkResponse>;

    /**
     * Edits a recommendation type.
     * @summary Edits a recommendation type. (Auth policies: CanEditThresholdsAndRecommendations)
     * @param {number} recommendationTypeId 
     * @param {RecommendationTypeRequestDto} [recommendationTypeRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationTypesApiInterface
     */
    editRecommendationType(recommendationTypeId: number, recommendationTypeRequestDto?: RecommendationTypeRequestDto, options?: AxiosRequestConfig): AxiosPromise<EditRecommendationTypeResponseOkResponse>;

    /**
     * Get recommendation type details by id.
     * @summary Get recommendation type details by id.
     * @param {number} recommendationTypeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationTypesApiInterface
     */
    getRecommendationType(recommendationTypeId: number, options?: AxiosRequestConfig): AxiosPromise<GetRecommendationTypeResponseOkResponse>;

    /**
     * List recommendation types.
     * @summary List recommendation types.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {number} [requestedOffset] 
     * @param {string} [term] 
     * @param {string} [termToLower] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationTypesApiInterface
     */
    listRecommendationTypes(page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig): AxiosPromise<ListRecommendationTypesResponseOkResponse>;

}

/**
 * RecommendationTypesApi - object-oriented interface
 * @export
 * @class RecommendationTypesApi
 * @extends {BaseAPI}
 */
export class RecommendationTypesApi extends BaseAPI implements RecommendationTypesApiInterface {
    /**
     * Add a new recommendation type.
     * @summary Add a new recommendation type. (Auth policies: CanEditThresholdsAndRecommendations)
     * @param {AddRecommendationTypeRequest} [addRecommendationTypeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationTypesApi
     */
    public addRecommendationType(addRecommendationTypeRequest?: AddRecommendationTypeRequest, options?: AxiosRequestConfig) {
        return RecommendationTypesApiFp(this.configuration).addRecommendationType(addRecommendationTypeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edits a recommendation type.
     * @summary Edits a recommendation type. (Auth policies: CanEditThresholdsAndRecommendations)
     * @param {number} recommendationTypeId 
     * @param {RecommendationTypeRequestDto} [recommendationTypeRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationTypesApi
     */
    public editRecommendationType(recommendationTypeId: number, recommendationTypeRequestDto?: RecommendationTypeRequestDto, options?: AxiosRequestConfig) {
        return RecommendationTypesApiFp(this.configuration).editRecommendationType(recommendationTypeId, recommendationTypeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get recommendation type details by id.
     * @summary Get recommendation type details by id.
     * @param {number} recommendationTypeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationTypesApi
     */
    public getRecommendationType(recommendationTypeId: number, options?: AxiosRequestConfig) {
        return RecommendationTypesApiFp(this.configuration).getRecommendationType(recommendationTypeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List recommendation types.
     * @summary List recommendation types.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {number} [requestedOffset] 
     * @param {string} [term] 
     * @param {string} [termToLower] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationTypesApi
     */
    public listRecommendationTypes(page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig) {
        return RecommendationTypesApiFp(this.configuration).listRecommendationTypes(page, size, requestedOffset, term, termToLower, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RecommendationsApi - axios parameter creator
 * @export
 */
export const RecommendationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a recommendation to a component.
         * @summary Add a recommendation to a component.
         * @param {string} componentSid The sid of the transformer to which the recommendation is added.
         * @param {RecommendationAddDto} [recommendationAddDto] The data needed for the new recommendation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRecommendation: async (componentSid: string, recommendationAddDto?: RecommendationAddDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentSid' is not null or undefined
            assertParamExists('addRecommendation', 'componentSid', componentSid)
            const localVarPath = `/api/v1/recommendations/{componentSid}`
                .replace(`{${"componentSid"}}`, encodeURIComponent(String(componentSid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recommendationAddDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a recommendation by id.
         * @summary Updates a recommendation by id.
         * @param {number} recommendationId The id of the comment to be updated.
         * @param {RecommendationEditDto} [recommendationEditDto] The updated data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editRecommendation: async (recommendationId: number, recommendationEditDto?: RecommendationEditDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recommendationId' is not null or undefined
            assertParamExists('editRecommendation', 'recommendationId', recommendationId)
            const localVarPath = `/api/v1/recommendations/{recommendationId}`
                .replace(`{${"recommendationId"}}`, encodeURIComponent(String(recommendationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recommendationEditDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get recommendation by id.
         * @summary Get recommendation by id. (Auth)
         * @param {number} recommendationId 
         * @param {number} [componentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecommendation: async (recommendationId: number, componentType?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recommendationId' is not null or undefined
            assertParamExists('getRecommendation', 'recommendationId', recommendationId)
            const localVarPath = `/api/v1/recommendations/{recommendationId}`
                .replace(`{${"recommendationId"}}`, encodeURIComponent(String(recommendationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (componentType !== undefined) {
                localVarQueryParameter['ComponentType'] = componentType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List recommendations by component sid.
         * @summary List recommendations by component sid. (Auth)
         * @param {string} componentSid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listComponentRecommendations: async (componentSid: string, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentSid' is not null or undefined
            assertParamExists('listComponentRecommendations', 'componentSid', componentSid)
            const localVarPath = `/api/v1/recommendations/{componentSid}/components`
                .replace(`{${"componentSid"}}`, encodeURIComponent(String(componentSid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (requestedOffset !== undefined) {
                localVarQueryParameter['requestedOffset'] = requestedOffset;
            }

            if (term !== undefined) {
                localVarQueryParameter['Term'] = term;
            }

            if (termToLower !== undefined) {
                localVarQueryParameter['TermToLower'] = termToLower;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List recommendations for all requested plants and component types.
         * @summary List recommendations for all requested plants and component types.
         * @param {Array<number>} plantSids 
         * @param {Array<number>} componentTypes 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecommendations: async (plantSids: Array<number>, componentTypes: Array<number>, startDate?: string, endDate?: string, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'plantSids' is not null or undefined
            assertParamExists('listRecommendations', 'plantSids', plantSids)
            // verify required parameter 'componentTypes' is not null or undefined
            assertParamExists('listRecommendations', 'componentTypes', componentTypes)
            const localVarPath = `/api/v1/recommendations/component-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (plantSids) {
                localVarQueryParameter['PlantSids'] = plantSids;
            }

            if (componentTypes) {
                localVarQueryParameter['ComponentTypes'] = componentTypes;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['StartDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['EndDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (requestedOffset !== undefined) {
                localVarQueryParameter['requestedOffset'] = requestedOffset;
            }

            if (term !== undefined) {
                localVarQueryParameter['Term'] = term;
            }

            if (termToLower !== undefined) {
                localVarQueryParameter['TermToLower'] = termToLower;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RecommendationsApi - functional programming interface
 * @export
 */
export const RecommendationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RecommendationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a recommendation to a component.
         * @summary Add a recommendation to a component.
         * @param {string} componentSid The sid of the transformer to which the recommendation is added.
         * @param {RecommendationAddDto} [recommendationAddDto] The data needed for the new recommendation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addRecommendation(componentSid: string, recommendationAddDto?: RecommendationAddDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddRecommendationResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addRecommendation(componentSid, recommendationAddDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RecommendationsApi.addRecommendation']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Updates a recommendation by id.
         * @summary Updates a recommendation by id.
         * @param {number} recommendationId The id of the comment to be updated.
         * @param {RecommendationEditDto} [recommendationEditDto] The updated data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editRecommendation(recommendationId: number, recommendationEditDto?: RecommendationEditDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EditRecommendationResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editRecommendation(recommendationId, recommendationEditDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RecommendationsApi.editRecommendation']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get recommendation by id.
         * @summary Get recommendation by id. (Auth)
         * @param {number} recommendationId 
         * @param {number} [componentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecommendation(recommendationId: number, componentType?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRecommendationResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecommendation(recommendationId, componentType, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RecommendationsApi.getRecommendation']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List recommendations by component sid.
         * @summary List recommendations by component sid. (Auth)
         * @param {string} componentSid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listComponentRecommendations(componentSid: string, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListComponentRecommendationsResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listComponentRecommendations(componentSid, page, size, requestedOffset, term, termToLower, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RecommendationsApi.listComponentRecommendations']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List recommendations for all requested plants and component types.
         * @summary List recommendations for all requested plants and component types.
         * @param {Array<number>} plantSids 
         * @param {Array<number>} componentTypes 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRecommendations(plantSids: Array<number>, componentTypes: Array<number>, startDate?: string, endDate?: string, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListRecommendationsByComponentTypeResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRecommendations(plantSids, componentTypes, startDate, endDate, page, size, requestedOffset, term, termToLower, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RecommendationsApi.listRecommendations']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * RecommendationsApi - factory interface
 * @export
 */
export const RecommendationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RecommendationsApiFp(configuration)
    return {
        /**
         * Add a recommendation to a component.
         * @summary Add a recommendation to a component.
         * @param {string} componentSid The sid of the transformer to which the recommendation is added.
         * @param {RecommendationAddDto} [recommendationAddDto] The data needed for the new recommendation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRecommendation(componentSid: string, recommendationAddDto?: RecommendationAddDto, options?: any): AxiosPromise<AddRecommendationResponseOkResponse> {
            return localVarFp.addRecommendation(componentSid, recommendationAddDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a recommendation by id.
         * @summary Updates a recommendation by id.
         * @param {number} recommendationId The id of the comment to be updated.
         * @param {RecommendationEditDto} [recommendationEditDto] The updated data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editRecommendation(recommendationId: number, recommendationEditDto?: RecommendationEditDto, options?: any): AxiosPromise<EditRecommendationResponseOkResponse> {
            return localVarFp.editRecommendation(recommendationId, recommendationEditDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Get recommendation by id.
         * @summary Get recommendation by id. (Auth)
         * @param {number} recommendationId 
         * @param {number} [componentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecommendation(recommendationId: number, componentType?: number, options?: any): AxiosPromise<GetRecommendationResponseOkResponse> {
            return localVarFp.getRecommendation(recommendationId, componentType, options).then((request) => request(axios, basePath));
        },
        /**
         * List recommendations by component sid.
         * @summary List recommendations by component sid. (Auth)
         * @param {string} componentSid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listComponentRecommendations(componentSid: string, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: any): AxiosPromise<ListComponentRecommendationsResponseOkResponse> {
            return localVarFp.listComponentRecommendations(componentSid, page, size, requestedOffset, term, termToLower, options).then((request) => request(axios, basePath));
        },
        /**
         * List recommendations for all requested plants and component types.
         * @summary List recommendations for all requested plants and component types.
         * @param {Array<number>} plantSids 
         * @param {Array<number>} componentTypes 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecommendations(plantSids: Array<number>, componentTypes: Array<number>, startDate?: string, endDate?: string, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: any): AxiosPromise<ListRecommendationsByComponentTypeResponseOkResponse> {
            return localVarFp.listRecommendations(plantSids, componentTypes, startDate, endDate, page, size, requestedOffset, term, termToLower, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RecommendationsApi - interface
 * @export
 * @interface RecommendationsApi
 */
export interface RecommendationsApiInterface {
    /**
     * Add a recommendation to a component.
     * @summary Add a recommendation to a component.
     * @param {string} componentSid The sid of the transformer to which the recommendation is added.
     * @param {RecommendationAddDto} [recommendationAddDto] The data needed for the new recommendation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApiInterface
     */
    addRecommendation(componentSid: string, recommendationAddDto?: RecommendationAddDto, options?: AxiosRequestConfig): AxiosPromise<AddRecommendationResponseOkResponse>;

    /**
     * Updates a recommendation by id.
     * @summary Updates a recommendation by id.
     * @param {number} recommendationId The id of the comment to be updated.
     * @param {RecommendationEditDto} [recommendationEditDto] The updated data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApiInterface
     */
    editRecommendation(recommendationId: number, recommendationEditDto?: RecommendationEditDto, options?: AxiosRequestConfig): AxiosPromise<EditRecommendationResponseOkResponse>;

    /**
     * Get recommendation by id.
     * @summary Get recommendation by id. (Auth)
     * @param {number} recommendationId 
     * @param {number} [componentType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApiInterface
     */
    getRecommendation(recommendationId: number, componentType?: number, options?: AxiosRequestConfig): AxiosPromise<GetRecommendationResponseOkResponse>;

    /**
     * List recommendations by component sid.
     * @summary List recommendations by component sid. (Auth)
     * @param {string} componentSid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {number} [requestedOffset] 
     * @param {string} [term] 
     * @param {string} [termToLower] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApiInterface
     */
    listComponentRecommendations(componentSid: string, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig): AxiosPromise<ListComponentRecommendationsResponseOkResponse>;

    /**
     * List recommendations for all requested plants and component types.
     * @summary List recommendations for all requested plants and component types.
     * @param {Array<number>} plantSids 
     * @param {Array<number>} componentTypes 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {number} [requestedOffset] 
     * @param {string} [term] 
     * @param {string} [termToLower] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApiInterface
     */
    listRecommendations(plantSids: Array<number>, componentTypes: Array<number>, startDate?: string, endDate?: string, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig): AxiosPromise<ListRecommendationsByComponentTypeResponseOkResponse>;

}

/**
 * RecommendationsApi - object-oriented interface
 * @export
 * @class RecommendationsApi
 * @extends {BaseAPI}
 */
export class RecommendationsApi extends BaseAPI implements RecommendationsApiInterface {
    /**
     * Add a recommendation to a component.
     * @summary Add a recommendation to a component.
     * @param {string} componentSid The sid of the transformer to which the recommendation is added.
     * @param {RecommendationAddDto} [recommendationAddDto] The data needed for the new recommendation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    public addRecommendation(componentSid: string, recommendationAddDto?: RecommendationAddDto, options?: AxiosRequestConfig) {
        return RecommendationsApiFp(this.configuration).addRecommendation(componentSid, recommendationAddDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a recommendation by id.
     * @summary Updates a recommendation by id.
     * @param {number} recommendationId The id of the comment to be updated.
     * @param {RecommendationEditDto} [recommendationEditDto] The updated data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    public editRecommendation(recommendationId: number, recommendationEditDto?: RecommendationEditDto, options?: AxiosRequestConfig) {
        return RecommendationsApiFp(this.configuration).editRecommendation(recommendationId, recommendationEditDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get recommendation by id.
     * @summary Get recommendation by id. (Auth)
     * @param {number} recommendationId 
     * @param {number} [componentType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    public getRecommendation(recommendationId: number, componentType?: number, options?: AxiosRequestConfig) {
        return RecommendationsApiFp(this.configuration).getRecommendation(recommendationId, componentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List recommendations by component sid.
     * @summary List recommendations by component sid. (Auth)
     * @param {string} componentSid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {number} [requestedOffset] 
     * @param {string} [term] 
     * @param {string} [termToLower] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    public listComponentRecommendations(componentSid: string, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig) {
        return RecommendationsApiFp(this.configuration).listComponentRecommendations(componentSid, page, size, requestedOffset, term, termToLower, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List recommendations for all requested plants and component types.
     * @summary List recommendations for all requested plants and component types.
     * @param {Array<number>} plantSids 
     * @param {Array<number>} componentTypes 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {number} [requestedOffset] 
     * @param {string} [term] 
     * @param {string} [termToLower] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    public listRecommendations(plantSids: Array<number>, componentTypes: Array<number>, startDate?: string, endDate?: string, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig) {
        return RecommendationsApiFp(this.configuration).listRecommendations(plantSids, componentTypes, startDate, endDate, page, size, requestedOffset, term, termToLower, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportsApi - axios parameter creator
 * @export
 */
export const ReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Exports an excel according to the filters.
         * @summary Exports an excel according to the filters. (Auth)
         * @param {number} exportType 
         * @param {Array<number>} [groupSids] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<number>} [plantSids] 
         * @param {Array<number>} [componentTypes] 
         * @param {Array<string>} [componentSids] 
         * @param {number} [languageType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportReport: async (exportType: number, groupSids?: Array<number>, startDate?: string, endDate?: string, plantSids?: Array<number>, componentTypes?: Array<number>, componentSids?: Array<string>, languageType?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportType' is not null or undefined
            assertParamExists('exportReport', 'exportType', exportType)
            const localVarPath = `/api/v1/reports/{exportType}/export`
                .replace(`{${"exportType"}}`, encodeURIComponent(String(exportType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (groupSids) {
                localVarQueryParameter['groupSids'] = groupSids;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (plantSids) {
                localVarQueryParameter['plantSids'] = plantSids;
            }

            if (componentTypes) {
                localVarQueryParameter['componentTypes'] = componentTypes;
            }

            if (componentSids) {
                localVarQueryParameter['componentSids'] = componentSids;
            }

            if (languageType !== undefined) {
                localVarQueryParameter['languageType'] = languageType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List generator analysis data by sid and analytical number.
         * @summary List generator analysis data by sid and analytical number. (Auth policies: CanViewGeneratorReports)
         * @param {string} analyticalNumber 
         * @param {string} componentSid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneratorReport: async (analyticalNumber: string, componentSid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analyticalNumber' is not null or undefined
            assertParamExists('getGeneratorReport', 'analyticalNumber', analyticalNumber)
            // verify required parameter 'componentSid' is not null or undefined
            assertParamExists('getGeneratorReport', 'componentSid', componentSid)
            const localVarPath = `/api/v1/reports/generator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (analyticalNumber !== undefined) {
                localVarQueryParameter['analyticalNumber'] = analyticalNumber;
            }

            if (componentSid !== undefined) {
                localVarQueryParameter['componentSid'] = componentSid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get report details by id.
         * @summary Get report details by id.
         * @param {string} reportId 
         * @param {number} [reportType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReport: async (reportId: string, reportType?: number, componentSid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getReport', 'reportId', reportId)
            const localVarPath = `/api/v1/reports/{reportId}`
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (reportType !== undefined) {
                localVarQueryParameter['reportType'] = reportType;
            }

            if (componentSid !== undefined) {
                localVarQueryParameter['componentSid'] = componentSid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List reports by plant sids.
         * @summary List reports by plant sids. (Auth)
         * @param {Array<number>} componentTypes 
         * @param {Array<number>} [plantSids] 
         * @param {number} [reportType] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {SortProjectType} [sortingSortProjectType]   1 &#x3D; Plant  2 &#x3D; ReportType  3 &#x3D; Status  4 &#x3D; Excluded
         * @param {boolean} [sortingSortAscending] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReports: async (componentTypes: Array<number>, plantSids?: Array<number>, reportType?: number, fromDate?: string, toDate?: string, sortingSortProjectType?: SortProjectType, sortingSortAscending?: boolean, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentTypes' is not null or undefined
            assertParamExists('listReports', 'componentTypes', componentTypes)
            const localVarPath = `/api/v1/reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (plantSids) {
                localVarQueryParameter['plantSids'] = plantSids;
            }

            if (reportType !== undefined) {
                localVarQueryParameter['reportType'] = reportType;
            }

            if (componentTypes) {
                localVarQueryParameter['componentTypes'] = componentTypes;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }

            if (sortingSortProjectType !== undefined) {
                localVarQueryParameter['sorting.SortProjectType'] = sortingSortProjectType;
            }

            if (sortingSortAscending !== undefined) {
                localVarQueryParameter['sorting.SortAscending'] = sortingSortAscending;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (requestedOffset !== undefined) {
                localVarQueryParameter['requestedOffset'] = requestedOffset;
            }

            if (term !== undefined) {
                localVarQueryParameter['Term'] = term;
            }

            if (termToLower !== undefined) {
                localVarQueryParameter['TermToLower'] = termToLower;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets the exclusion flag on a report.
         * @summary Sets the exclusion flag on a report. (Auth)
         * @param {string} analyticalNumber 
         * @param {number} [reportType] 
         * @param {boolean} [isExcluded] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setIsExcludeFlag: async (analyticalNumber: string, reportType?: number, isExcluded?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analyticalNumber' is not null or undefined
            assertParamExists('setIsExcludeFlag', 'analyticalNumber', analyticalNumber)
            const localVarPath = `/api/v1/reports/{analyticalNumber}/exclusion`
                .replace(`{${"analyticalNumber"}}`, encodeURIComponent(String(analyticalNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (reportType !== undefined) {
                localVarQueryParameter['ReportType'] = reportType;
            }

            if (isExcluded !== undefined) {
                localVarQueryParameter['IsExcluded'] = isExcluded;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets the reference dates on a report.
         * @summary Sets the reference dates on a report. (Auth policies: CanSetReferenceReports)
         * @param {string} analyticalNumber 
         * @param {string} componentSid 
         * @param {number} [analysisType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setIsReference: async (analyticalNumber: string, componentSid: string, analysisType?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analyticalNumber' is not null or undefined
            assertParamExists('setIsReference', 'analyticalNumber', analyticalNumber)
            // verify required parameter 'componentSid' is not null or undefined
            assertParamExists('setIsReference', 'componentSid', componentSid)
            const localVarPath = `/api/v1/reports/{componentSid}/{analyticalNumber}/reference`
                .replace(`{${"analyticalNumber"}}`, encodeURIComponent(String(analyticalNumber)))
                .replace(`{${"componentSid"}}`, encodeURIComponent(String(componentSid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (analysisType !== undefined) {
                localVarQueryParameter['AnalysisType'] = analysisType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportsApi - functional programming interface
 * @export
 */
export const ReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * Exports an excel according to the filters.
         * @summary Exports an excel according to the filters. (Auth)
         * @param {number} exportType 
         * @param {Array<number>} [groupSids] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<number>} [plantSids] 
         * @param {Array<number>} [componentTypes] 
         * @param {Array<string>} [componentSids] 
         * @param {number} [languageType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportReport(exportType: number, groupSids?: Array<number>, startDate?: string, endDate?: string, plantSids?: Array<number>, componentTypes?: Array<number>, componentSids?: Array<string>, languageType?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportReport(exportType, groupSids, startDate, endDate, plantSids, componentTypes, componentSids, languageType, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ReportsApi.exportReport']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List generator analysis data by sid and analytical number.
         * @summary List generator analysis data by sid and analytical number. (Auth policies: CanViewGeneratorReports)
         * @param {string} analyticalNumber 
         * @param {string} componentSid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGeneratorReport(analyticalNumber: string, componentSid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGeneratorReportResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGeneratorReport(analyticalNumber, componentSid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ReportsApi.getGeneratorReport']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get report details by id.
         * @summary Get report details by id.
         * @param {string} reportId 
         * @param {number} [reportType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReport(reportId: string, reportType?: number, componentSid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReportResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReport(reportId, reportType, componentSid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ReportsApi.getReport']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List reports by plant sids.
         * @summary List reports by plant sids. (Auth)
         * @param {Array<number>} componentTypes 
         * @param {Array<number>} [plantSids] 
         * @param {number} [reportType] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {SortProjectType} [sortingSortProjectType]   1 &#x3D; Plant  2 &#x3D; ReportType  3 &#x3D; Status  4 &#x3D; Excluded
         * @param {boolean} [sortingSortAscending] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listReports(componentTypes: Array<number>, plantSids?: Array<number>, reportType?: number, fromDate?: string, toDate?: string, sortingSortProjectType?: SortProjectType, sortingSortAscending?: boolean, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListReportsResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listReports(componentTypes, plantSids, reportType, fromDate, toDate, sortingSortProjectType, sortingSortAscending, page, size, requestedOffset, term, termToLower, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ReportsApi.listReports']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Sets the exclusion flag on a report.
         * @summary Sets the exclusion flag on a report. (Auth)
         * @param {string} analyticalNumber 
         * @param {number} [reportType] 
         * @param {boolean} [isExcluded] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setIsExcludeFlag(analyticalNumber: string, reportType?: number, isExcluded?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetIsExcludedResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setIsExcludeFlag(analyticalNumber, reportType, isExcluded, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ReportsApi.setIsExcludeFlag']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Sets the reference dates on a report.
         * @summary Sets the reference dates on a report. (Auth policies: CanSetReferenceReports)
         * @param {string} analyticalNumber 
         * @param {string} componentSid 
         * @param {number} [analysisType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setIsReference(analyticalNumber: string, componentSid: string, analysisType?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetIsReferenceResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setIsReference(analyticalNumber, componentSid, analysisType, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ReportsApi.setIsReference']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ReportsApi - factory interface
 * @export
 */
export const ReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportsApiFp(configuration)
    return {
        /**
         * Exports an excel according to the filters.
         * @summary Exports an excel according to the filters. (Auth)
         * @param {number} exportType 
         * @param {Array<number>} [groupSids] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<number>} [plantSids] 
         * @param {Array<number>} [componentTypes] 
         * @param {Array<string>} [componentSids] 
         * @param {number} [languageType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportReport(exportType: number, groupSids?: Array<number>, startDate?: string, endDate?: string, plantSids?: Array<number>, componentTypes?: Array<number>, componentSids?: Array<string>, languageType?: number, options?: any): AxiosPromise<void> {
            return localVarFp.exportReport(exportType, groupSids, startDate, endDate, plantSids, componentTypes, componentSids, languageType, options).then((request) => request(axios, basePath));
        },
        /**
         * List generator analysis data by sid and analytical number.
         * @summary List generator analysis data by sid and analytical number. (Auth policies: CanViewGeneratorReports)
         * @param {string} analyticalNumber 
         * @param {string} componentSid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneratorReport(analyticalNumber: string, componentSid: string, options?: any): AxiosPromise<GetGeneratorReportResponseOkResponse> {
            return localVarFp.getGeneratorReport(analyticalNumber, componentSid, options).then((request) => request(axios, basePath));
        },
        /**
         * Get report details by id.
         * @summary Get report details by id.
         * @param {string} reportId 
         * @param {number} [reportType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReport(reportId: string, reportType?: number, componentSid?: string, options?: any): AxiosPromise<GetReportResponseOkResponse> {
            return localVarFp.getReport(reportId, reportType, componentSid, options).then((request) => request(axios, basePath));
        },
        /**
         * List reports by plant sids.
         * @summary List reports by plant sids. (Auth)
         * @param {Array<number>} componentTypes 
         * @param {Array<number>} [plantSids] 
         * @param {number} [reportType] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {SortProjectType} [sortingSortProjectType]   1 &#x3D; Plant  2 &#x3D; ReportType  3 &#x3D; Status  4 &#x3D; Excluded
         * @param {boolean} [sortingSortAscending] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [requestedOffset] 
         * @param {string} [term] 
         * @param {string} [termToLower] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReports(componentTypes: Array<number>, plantSids?: Array<number>, reportType?: number, fromDate?: string, toDate?: string, sortingSortProjectType?: SortProjectType, sortingSortAscending?: boolean, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: any): AxiosPromise<ListReportsResponseOkResponse> {
            return localVarFp.listReports(componentTypes, plantSids, reportType, fromDate, toDate, sortingSortProjectType, sortingSortAscending, page, size, requestedOffset, term, termToLower, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets the exclusion flag on a report.
         * @summary Sets the exclusion flag on a report. (Auth)
         * @param {string} analyticalNumber 
         * @param {number} [reportType] 
         * @param {boolean} [isExcluded] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setIsExcludeFlag(analyticalNumber: string, reportType?: number, isExcluded?: boolean, options?: any): AxiosPromise<SetIsExcludedResponseOkResponse> {
            return localVarFp.setIsExcludeFlag(analyticalNumber, reportType, isExcluded, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets the reference dates on a report.
         * @summary Sets the reference dates on a report. (Auth policies: CanSetReferenceReports)
         * @param {string} analyticalNumber 
         * @param {string} componentSid 
         * @param {number} [analysisType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setIsReference(analyticalNumber: string, componentSid: string, analysisType?: number, options?: any): AxiosPromise<SetIsReferenceResponseOkResponse> {
            return localVarFp.setIsReference(analyticalNumber, componentSid, analysisType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportsApi - interface
 * @export
 * @interface ReportsApi
 */
export interface ReportsApiInterface {
    /**
     * Exports an excel according to the filters.
     * @summary Exports an excel according to the filters. (Auth)
     * @param {number} exportType 
     * @param {Array<number>} [groupSids] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {Array<number>} [plantSids] 
     * @param {Array<number>} [componentTypes] 
     * @param {Array<string>} [componentSids] 
     * @param {number} [languageType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApiInterface
     */
    exportReport(exportType: number, groupSids?: Array<number>, startDate?: string, endDate?: string, plantSids?: Array<number>, componentTypes?: Array<number>, componentSids?: Array<string>, languageType?: number, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * List generator analysis data by sid and analytical number.
     * @summary List generator analysis data by sid and analytical number. (Auth policies: CanViewGeneratorReports)
     * @param {string} analyticalNumber 
     * @param {string} componentSid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApiInterface
     */
    getGeneratorReport(analyticalNumber: string, componentSid: string, options?: AxiosRequestConfig): AxiosPromise<GetGeneratorReportResponseOkResponse>;

    /**
     * Get report details by id.
     * @summary Get report details by id.
     * @param {string} reportId 
     * @param {number} [reportType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApiInterface
     */
    getReport(reportId: string, reportType?: number, componentSid?: string, options?: AxiosRequestConfig): AxiosPromise<GetReportResponseOkResponse>;

    /**
     * List reports by plant sids.
     * @summary List reports by plant sids. (Auth)
     * @param {Array<number>} componentTypes 
     * @param {Array<number>} [plantSids] 
     * @param {number} [reportType] 
     * @param {string} [fromDate] 
     * @param {string} [toDate] 
     * @param {SortProjectType} [sortingSortProjectType]   1 &#x3D; Plant  2 &#x3D; ReportType  3 &#x3D; Status  4 &#x3D; Excluded
     * @param {boolean} [sortingSortAscending] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {number} [requestedOffset] 
     * @param {string} [term] 
     * @param {string} [termToLower] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApiInterface
     */
    listReports(componentTypes: Array<number>, plantSids?: Array<number>, reportType?: number, fromDate?: string, toDate?: string, sortingSortProjectType?: SortProjectType, sortingSortAscending?: boolean, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig): AxiosPromise<ListReportsResponseOkResponse>;

    /**
     * Sets the exclusion flag on a report.
     * @summary Sets the exclusion flag on a report. (Auth)
     * @param {string} analyticalNumber 
     * @param {number} [reportType] 
     * @param {boolean} [isExcluded] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApiInterface
     */
    setIsExcludeFlag(analyticalNumber: string, reportType?: number, isExcluded?: boolean, options?: AxiosRequestConfig): AxiosPromise<SetIsExcludedResponseOkResponse>;

    /**
     * Sets the reference dates on a report.
     * @summary Sets the reference dates on a report. (Auth policies: CanSetReferenceReports)
     * @param {string} analyticalNumber 
     * @param {string} componentSid 
     * @param {number} [analysisType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApiInterface
     */
    setIsReference(analyticalNumber: string, componentSid: string, analysisType?: number, options?: AxiosRequestConfig): AxiosPromise<SetIsReferenceResponseOkResponse>;

}

/**
 * ReportsApi - object-oriented interface
 * @export
 * @class ReportsApi
 * @extends {BaseAPI}
 */
export class ReportsApi extends BaseAPI implements ReportsApiInterface {
    /**
     * Exports an excel according to the filters.
     * @summary Exports an excel according to the filters. (Auth)
     * @param {number} exportType 
     * @param {Array<number>} [groupSids] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {Array<number>} [plantSids] 
     * @param {Array<number>} [componentTypes] 
     * @param {Array<string>} [componentSids] 
     * @param {number} [languageType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public exportReport(exportType: number, groupSids?: Array<number>, startDate?: string, endDate?: string, plantSids?: Array<number>, componentTypes?: Array<number>, componentSids?: Array<string>, languageType?: number, options?: AxiosRequestConfig) {
        return ReportsApiFp(this.configuration).exportReport(exportType, groupSids, startDate, endDate, plantSids, componentTypes, componentSids, languageType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List generator analysis data by sid and analytical number.
     * @summary List generator analysis data by sid and analytical number. (Auth policies: CanViewGeneratorReports)
     * @param {string} analyticalNumber 
     * @param {string} componentSid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public getGeneratorReport(analyticalNumber: string, componentSid: string, options?: AxiosRequestConfig) {
        return ReportsApiFp(this.configuration).getGeneratorReport(analyticalNumber, componentSid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get report details by id.
     * @summary Get report details by id.
     * @param {string} reportId 
     * @param {number} [reportType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public getReport(reportId: string, reportType?: number, componentSid?: string, options?: AxiosRequestConfig) {
        return ReportsApiFp(this.configuration).getReport(reportId, reportType, componentSid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List reports by plant sids.
     * @summary List reports by plant sids. (Auth)
     * @param {Array<number>} componentTypes 
     * @param {Array<number>} [plantSids] 
     * @param {number} [reportType] 
     * @param {string} [fromDate] 
     * @param {string} [toDate] 
     * @param {SortProjectType} [sortingSortProjectType]   1 &#x3D; Plant  2 &#x3D; ReportType  3 &#x3D; Status  4 &#x3D; Excluded
     * @param {boolean} [sortingSortAscending] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {number} [requestedOffset] 
     * @param {string} [term] 
     * @param {string} [termToLower] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public listReports(componentTypes: Array<number>, plantSids?: Array<number>, reportType?: number, fromDate?: string, toDate?: string, sortingSortProjectType?: SortProjectType, sortingSortAscending?: boolean, page?: number, size?: number, requestedOffset?: number, term?: string, termToLower?: string, options?: AxiosRequestConfig) {
        return ReportsApiFp(this.configuration).listReports(componentTypes, plantSids, reportType, fromDate, toDate, sortingSortProjectType, sortingSortAscending, page, size, requestedOffset, term, termToLower, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets the exclusion flag on a report.
     * @summary Sets the exclusion flag on a report. (Auth)
     * @param {string} analyticalNumber 
     * @param {number} [reportType] 
     * @param {boolean} [isExcluded] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public setIsExcludeFlag(analyticalNumber: string, reportType?: number, isExcluded?: boolean, options?: AxiosRequestConfig) {
        return ReportsApiFp(this.configuration).setIsExcludeFlag(analyticalNumber, reportType, isExcluded, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets the reference dates on a report.
     * @summary Sets the reference dates on a report. (Auth policies: CanSetReferenceReports)
     * @param {string} analyticalNumber 
     * @param {string} componentSid 
     * @param {number} [analysisType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public setIsReference(analyticalNumber: string, componentSid: string, analysisType?: number, options?: AxiosRequestConfig) {
        return ReportsApiFp(this.configuration).setIsReference(analyticalNumber, componentSid, analysisType, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ThresholdsApi - axios parameter creator
 * @export
 */
export const ThresholdsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Updates a threshold by id.
         * @summary Updates a threshold by id. (Auth policies: CanEditThresholdsAndRecommendations)
         * @param {number} thresholdId The id of the threshold to be updated.
         * @param {ThresholdEditDto} [thresholdEditDto] The updated data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editThreshold: async (thresholdId: number, thresholdEditDto?: ThresholdEditDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'thresholdId' is not null or undefined
            assertParamExists('editThreshold', 'thresholdId', thresholdId)
            const localVarPath = `/api/v1/thresholds/{thresholdId}`
                .replace(`{${"thresholdId"}}`, encodeURIComponent(String(thresholdId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(thresholdEditDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export thresholds.
         * @summary Export thresholds. (Auth policies: CanEditThresholdsAndRecommendations)
         * @param {number} languageType 
         * @param {string} timezone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportThresholds: async (languageType: number, timezone: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'languageType' is not null or undefined
            assertParamExists('exportThresholds', 'languageType', languageType)
            // verify required parameter 'timezone' is not null or undefined
            assertParamExists('exportThresholds', 'timezone', timezone)
            const localVarPath = `/api/v1/thresholds/{languageType}/export/{timezone}`
                .replace(`{${"languageType"}}`, encodeURIComponent(String(languageType)))
                .replace(`{${"timezone"}}`, encodeURIComponent(String(timezone)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get threshold details by id.
         * @summary Get threshold details by id. (Auth policies: CanViewTransformerData)
         * @param {number} thresholdId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThresholdById: async (thresholdId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'thresholdId' is not null or undefined
            assertParamExists('getThresholdById', 'thresholdId', thresholdId)
            const localVarPath = `/api/v1/thresholds/{thresholdId}`
                .replace(`{${"thresholdId"}}`, encodeURIComponent(String(thresholdId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List thresholds.
         * @summary List thresholds. (Auth policies: CanViewTransformerData)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listThresholds: async (request?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/thresholds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (request !== undefined) {
                for (const [key, value] of Object.entries(request)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ThresholdsApi - functional programming interface
 * @export
 */
export const ThresholdsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ThresholdsApiAxiosParamCreator(configuration)
    return {
        /**
         * Updates a threshold by id.
         * @summary Updates a threshold by id. (Auth policies: CanEditThresholdsAndRecommendations)
         * @param {number} thresholdId The id of the threshold to be updated.
         * @param {ThresholdEditDto} [thresholdEditDto] The updated data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editThreshold(thresholdId: number, thresholdEditDto?: ThresholdEditDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EditThresholdResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editThreshold(thresholdId, thresholdEditDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ThresholdsApi.editThreshold']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Export thresholds.
         * @summary Export thresholds. (Auth policies: CanEditThresholdsAndRecommendations)
         * @param {number} languageType 
         * @param {string} timezone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportThresholds(languageType: number, timezone: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportThresholds(languageType, timezone, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ThresholdsApi.exportThresholds']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get threshold details by id.
         * @summary Get threshold details by id. (Auth policies: CanViewTransformerData)
         * @param {number} thresholdId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getThresholdById(thresholdId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetThresholdResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getThresholdById(thresholdId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ThresholdsApi.getThresholdById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List thresholds.
         * @summary List thresholds. (Auth policies: CanViewTransformerData)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listThresholds(request?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListThresholdsResponseOkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listThresholds(request, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ThresholdsApi.listThresholds']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ThresholdsApi - factory interface
 * @export
 */
export const ThresholdsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ThresholdsApiFp(configuration)
    return {
        /**
         * Updates a threshold by id.
         * @summary Updates a threshold by id. (Auth policies: CanEditThresholdsAndRecommendations)
         * @param {number} thresholdId The id of the threshold to be updated.
         * @param {ThresholdEditDto} [thresholdEditDto] The updated data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editThreshold(thresholdId: number, thresholdEditDto?: ThresholdEditDto, options?: any): AxiosPromise<EditThresholdResponseOkResponse> {
            return localVarFp.editThreshold(thresholdId, thresholdEditDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Export thresholds.
         * @summary Export thresholds. (Auth policies: CanEditThresholdsAndRecommendations)
         * @param {number} languageType 
         * @param {string} timezone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportThresholds(languageType: number, timezone: string, options?: any): AxiosPromise<void> {
            return localVarFp.exportThresholds(languageType, timezone, options).then((request) => request(axios, basePath));
        },
        /**
         * Get threshold details by id.
         * @summary Get threshold details by id. (Auth policies: CanViewTransformerData)
         * @param {number} thresholdId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThresholdById(thresholdId: number, options?: any): AxiosPromise<GetThresholdResponseOkResponse> {
            return localVarFp.getThresholdById(thresholdId, options).then((request) => request(axios, basePath));
        },
        /**
         * List thresholds.
         * @summary List thresholds. (Auth policies: CanViewTransformerData)
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listThresholds(request?: object, options?: any): AxiosPromise<ListThresholdsResponseOkResponse> {
            return localVarFp.listThresholds(request, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ThresholdsApi - interface
 * @export
 * @interface ThresholdsApi
 */
export interface ThresholdsApiInterface {
    /**
     * Updates a threshold by id.
     * @summary Updates a threshold by id. (Auth policies: CanEditThresholdsAndRecommendations)
     * @param {number} thresholdId The id of the threshold to be updated.
     * @param {ThresholdEditDto} [thresholdEditDto] The updated data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThresholdsApiInterface
     */
    editThreshold(thresholdId: number, thresholdEditDto?: ThresholdEditDto, options?: AxiosRequestConfig): AxiosPromise<EditThresholdResponseOkResponse>;

    /**
     * Export thresholds.
     * @summary Export thresholds. (Auth policies: CanEditThresholdsAndRecommendations)
     * @param {number} languageType 
     * @param {string} timezone 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThresholdsApiInterface
     */
    exportThresholds(languageType: number, timezone: string, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * Get threshold details by id.
     * @summary Get threshold details by id. (Auth policies: CanViewTransformerData)
     * @param {number} thresholdId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThresholdsApiInterface
     */
    getThresholdById(thresholdId: number, options?: AxiosRequestConfig): AxiosPromise<GetThresholdResponseOkResponse>;

    /**
     * List thresholds.
     * @summary List thresholds. (Auth policies: CanViewTransformerData)
     * @param {object} [request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThresholdsApiInterface
     */
    listThresholds(request?: object, options?: AxiosRequestConfig): AxiosPromise<ListThresholdsResponseOkResponse>;

}

/**
 * ThresholdsApi - object-oriented interface
 * @export
 * @class ThresholdsApi
 * @extends {BaseAPI}
 */
export class ThresholdsApi extends BaseAPI implements ThresholdsApiInterface {
    /**
     * Updates a threshold by id.
     * @summary Updates a threshold by id. (Auth policies: CanEditThresholdsAndRecommendations)
     * @param {number} thresholdId The id of the threshold to be updated.
     * @param {ThresholdEditDto} [thresholdEditDto] The updated data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThresholdsApi
     */
    public editThreshold(thresholdId: number, thresholdEditDto?: ThresholdEditDto, options?: AxiosRequestConfig) {
        return ThresholdsApiFp(this.configuration).editThreshold(thresholdId, thresholdEditDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export thresholds.
     * @summary Export thresholds. (Auth policies: CanEditThresholdsAndRecommendations)
     * @param {number} languageType 
     * @param {string} timezone 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThresholdsApi
     */
    public exportThresholds(languageType: number, timezone: string, options?: AxiosRequestConfig) {
        return ThresholdsApiFp(this.configuration).exportThresholds(languageType, timezone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get threshold details by id.
     * @summary Get threshold details by id. (Auth policies: CanViewTransformerData)
     * @param {number} thresholdId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThresholdsApi
     */
    public getThresholdById(thresholdId: number, options?: AxiosRequestConfig) {
        return ThresholdsApiFp(this.configuration).getThresholdById(thresholdId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List thresholds.
     * @summary List thresholds. (Auth policies: CanViewTransformerData)
     * @param {object} [request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThresholdsApi
     */
    public listThresholds(request?: object, options?: AxiosRequestConfig) {
        return ThresholdsApiFp(this.configuration).listThresholds(request, options).then((request) => request(this.axios, this.basePath));
    }
}



